webpackJsonp([1],Array(19).concat([
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _keys = __webpack_require__(508);

var _keys2 = _interopRequireDefault(_keys);

var _axios = __webpack_require__(59);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// PROD ENDPOINTS
var cms_endpoint_prefix = 'https://www.dayton.com/external-feeds/json/apps/v1/?id=';
var file_get_prefix = 'https://projects.dayton.com/best_of_dayton_endpoints/get_endpoint_data.php?endpoint=';
var api_GET_prefix = 'https://projects.dayton.com/best_of_dayton_endpoints/get_api_data.php?requested_set=';
var db_POST_prefix = 'https://projects.dayton.com/best_of_dayton_endpoints/post_to_db.php';
var db_PUT_prefix = 'https://projects.dayton.com/best_of_dayton_endpoints/put_to_db.php';
var timezone_data_endpoint = 'https://projects.dayton.com/best_of_dayton_endpoints/get_timezone_data.php';

// LOCALHOST ENDPOINT
if (document.domain == 'localhost') {
	var endpoint_path = 'http://localhost/bitbucket/best_of_dayton_pwa/endpoints/';
	cms_endpoint_prefix = 'https://www.dayton.com/external-feeds/json/apps/v1/?id=';
	file_get_prefix = endpoint_path + 'get_endpoint_data.php?endpoint=';
	api_GET_prefix = endpoint_path + 'get_api_data.php?requested_set=';
	db_POST_prefix = endpoint_path + 'post_to_db.php';
	db_PUT_prefix = endpoint_path + 'put_to_db.php';
	timezone_data_endpoint = endpoint_path + 'get_timezone_data.php';
}

exports.default = {

	/*cms_endpoint_prefix: 'https://www.dayton.com/external-feeds/json/apps/v1/?id=',
 file_get_prefix: 'https://projects.dayton.com/best_of_dayton_endpoints/get_endpoint_data.php?endpoint=',
 api_GET_prefix: 'https://projects.dayton.com/best_of_dayton_endpoints/get_api_data.php?requested_set=',
 db_POST_prefix: 'https://projects.dayton.com/best_of_dayton_endpoints/post_to_db.php',
 db_PUT_prefix: 'https://projects.dayton.com/best_of_dayton_endpoints/put_to_db.php',
 timezone_data_endpoint: 'https://projects.dayton.com/best_of_dayton_endpoints/get_timezone_data.php',*/

	/*cms_endpoint_prefix: 'https://www.dayton.com/external-feeds/json/apps/v1/?id=',
 file_get_prefix: 'https://projects.dayton.com/best_of_dayton_endpoints_dev/get_endpoint_data.php?endpoint=',
 api_GET_prefix: 'https://projects.dayton.com/best_of_dayton_endpoints_dev/get_api_data.php?requested_set=',
 db_POST_prefix: 'https://projects.dayton.com/best_of_dayton_endpoints_dev/post_to_db.php',
 db_PUT_prefix: 'https://projects.dayton.com/best_of_dayton_endpoints_dev/put_to_db.php',
 timezone_data_endpoint: 'https://projects.dayton.com/best_of_dayton_endpoints_dev/get_timezone_data.php',*/

	/*cms_endpoint_prefix: 'https://www.dayton.com/external-feeds/json/apps/v1/?id=',
 file_get_prefix: '/best_of_dayton_endpoints/get_endpoint_data.php?endpoint=',
 api_GET_prefix: '/best_of_dayton_endpoints/get_api_data.php?requested_set=',
 db_POST_prefix: '/best_of_dayton_endpoints/post_to_db.php',
 db_PUT_prefix: '/best_of_dayton_endpoints/put_to_db.php',
 timezone_data_endpoint: '/best_of_dayton_endpoints/get_timezone_data.php',*/

	get_api_data: function get_api_data(requested_set, options) {
		var rand = this.generate_random_string();
		var endpoint = api_GET_prefix + encodeURIComponent(requested_set) + '&rand=' + rand;

		// CHECK FOR OPTIONS
		if (options) {
			var options_qs = (0, _keys2.default)(options).map(function (key) {
				return key + '=' + options[key];
			}).join('&');
			endpoint += '&' + options_qs;
		}

		// console.log('endpoint for get request: ', endpoint);
		return _axios2.default.get(endpoint);
	},

	test_request: function test_request() {
		return 'test';
	},

	get_cms_list: function get_cms_list(list_id) {
		var endpoint = file_get_prefix + encodeURIComponent(cms_endpoint_prefix + list_id);
		endpoint = this.generate_cacher_url('dcom_bod_list_' + list_id, endpoint);

		return _axios2.default.get(endpoint);
	},

	save_new_nomination: function save_new_nomination(data) {
		var endpoint = db_POST_prefix;
		return _axios2.default.post(endpoint, data);
	},

	make_simple_post: function make_simple_post(data) {
		var endpoint = db_POST_prefix;
		return _axios2.default.post(endpoint, data);
	},

	get_timezone_data: function get_timezone_data() {
		var rand = this.generate_random_string();
		var endpoint = timezone_data_endpoint + '?rand=' + rand;

		return _axios2.default.get(endpoint);
	},

	generate_random_string: function generate_random_string() {
		return Math.floor(Math.random() * 1000000 + 1);
	},

	generate_cacher_url: function generate_cacher_url(saveas, url_to_cache) {
		var cacher_url = 'https://host.coxmediagroup.com/cop/digital/common/cache/cacher.php';
		cacher_url += '?saveas=' + saveas;
		cacher_url += '&json_url=' + encodeURIComponent(url_to_cache);

		return cacher_url;
	}
};

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(223);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _Homepage = __webpack_require__(224);

var _Homepage2 = _interopRequireDefault(_Homepage);

var _ContestListPage = __webpack_require__(241);

var _ContestListPage2 = _interopRequireDefault(_ContestListPage);

var _NominationPage = __webpack_require__(281);

var _NominationPage2 = _interopRequireDefault(_NominationPage);

var _NominationSinglePage = __webpack_require__(330);

var _NominationSinglePage2 = _interopRequireDefault(_NominationSinglePage);

var _VoteCardDemoPage = __webpack_require__(341);

var _VoteCardDemoPage2 = _interopRequireDefault(_VoteCardDemoPage);

var _VoteLandingPage = __webpack_require__(358);

var _VoteLandingPage2 = _interopRequireDefault(_VoteLandingPage);

var _VotingExperiencePage = __webpack_require__(371);

var _VotingExperiencePage2 = _interopRequireDefault(_VotingExperiencePage);

var _VotingExperienceSinglePage = __webpack_require__(374);

var _VotingExperienceSinglePage2 = _interopRequireDefault(_VotingExperienceSinglePage);

var _PageNotFound = __webpack_require__(377);

var _PageNotFound2 = _interopRequireDefault(_PageNotFound);

var _vueMeta = __webpack_require__(380);

var _vueMeta2 = _interopRequireDefault(_vueMeta);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const NominationSinglePage = () => import('@/pages/NominationSinglePage');
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vueMeta2.default);

var base = '/';
if (true) {
  base = '/best_of_dayton/';
}

exports.default = new _vueRouter2.default({
  mode: 'history',
  scrollBehavior: function scrollBehavior() {
    return { x: 0, y: 0 };
  },

  base: base,
  // base: '/best_of_dayton/',
  // base: '/',
  routes: [{
    path: '/',
    name: 'homepage',
    component: _Homepage2.default
  },
  /*{
    path: '/nominate',
    name: 'nominations',
    component: NominationPage
  },*/
  {
    path: '/nominate/',
    name: 'nominations',
    component: _NominationPage2.default
  },
  /*{
    path: '/nominate/:id',
    name: 'nominationsingle',
    component: NominationSinglePage
  },*/
  {
    path: '/nominate/:id/',
    name: 'nominationsingle',
    component: _NominationSinglePage2.default
  },
  /*{
    path: '/vote',
    name: 'vote',
    component: VoteLandingPage
  },*/
  {
    path: '/vote/',
    name: 'vote',
    component: _VoteLandingPage2.default
  }, {
    path: '/votenow',
    name: 'votenow',
    component: _VotingExperiencePage2.default
  }, {
    path: '/votenow/',
    name: 'votenow',
    component: _VotingExperiencePage2.default
  }, {
    path: '/votenow/:id',
    name: 'votenowsingle',
    component: _VotingExperienceSinglePage2.default
  }, {
    path: '/votenow/:id/',
    name: 'votenowsingle',
    component: _VotingExperienceSinglePage2.default
  },
  /*{
    path: '/oldvotedemo',
    name: 'oldvotedemo',
    component: VoteCardDemoPage
  },*/
  {
    path: '*',
    name: 'not_found',
    component: _PageNotFound2.default
  }]
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_countdown_timer_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_countdown_timer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_countdown_timer_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_countdown_timer_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_countdown_timer_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3eb11500_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_countdown_timer_vue__ = __webpack_require__(238);
function injectStyle (ssrContext) {
  __webpack_require__(237)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_countdown_timer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3eb11500_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_countdown_timer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_prompt_vue__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_prompt_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_prompt_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_prompt_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_prompt_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a23a8ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_prompt_vue__ = __webpack_require__(309);
function injectStyle (ssrContext) {
  __webpack_require__(308)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_prompt_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a23a8ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_prompt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trans_bounce_inL_outR_vue__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trans_bounce_inL_outR_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trans_bounce_inL_outR_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trans_bounce_inL_outR_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trans_bounce_inL_outR_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e4b0320_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trans_bounce_inL_outR_vue__ = __webpack_require__(326);
function injectStyle (ssrContext) {
  __webpack_require__(325)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trans_bounce_inL_outR_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e4b0320_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trans_bounce_inL_outR_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_story_list_vue__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_story_list_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_story_list_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_story_list_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_story_list_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e18c9b1a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_story_list_vue__ = __webpack_require__(232);
function injectStyle (ssrContext) {
  __webpack_require__(226)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_story_list_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e18c9b1a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_story_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_generic_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_generic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_generic_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_generic_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_generic_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af270e42_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_generic_vue__ = __webpack_require__(228);
function injectStyle (ssrContext) {
  __webpack_require__(227)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_generic_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af270e42_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_generic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_large_centered_button_vue__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_large_centered_button_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_large_centered_button_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_large_centered_button_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_large_centered_button_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13960324_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_large_centered_button_vue__ = __webpack_require__(234);
function injectStyle (ssrContext) {
  __webpack_require__(233)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_large_centered_button_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13960324_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_large_centered_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = {"contestants":[{"id":1,"name":"Bill's Donut Shop","image":"0720-bills-donut-shop2.jpg"},{"id":2,"name":"Stan the Donut Man","image":"stan_the_donut_man.jpg"},{"id":3,"name":"Duck's Donuts","image":"041218_Duck_donuts_14.jpg"},{"id":4,"name":"Donuts R Us","image":"donuts-431863_1280.jpg"},{"id":5,"name":"Do or Donut","image":"donuts-690281_1280.jpg"}]}

/***/ }),
/* 48 */,
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trans_zoom_vue__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trans_zoom_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trans_zoom_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trans_zoom_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trans_zoom_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65f447d1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trans_zoom_vue__ = __webpack_require__(339);
function injectStyle (ssrContext) {
  __webpack_require__(338)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trans_zoom_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65f447d1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trans_zoom_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dev_period_simulator_vue__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dev_period_simulator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dev_period_simulator_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dev_period_simulator_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dev_period_simulator_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_771b7f52_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dev_period_simulator_vue__ = __webpack_require__(369);
function injectStyle (ssrContext) {
  __webpack_require__(368)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dev_period_simulator_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_771b7f52_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dev_period_simulator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contest_banner_vue__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contest_banner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contest_banner_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contest_banner_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contest_banner_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_044322b5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contest_banner_vue__ = __webpack_require__(267);
function injectStyle (ssrContext) {
  __webpack_require__(266)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contest_banner_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_044322b5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contest_banner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeahead_vue__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeahead_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeahead_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeahead_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeahead_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_dedbdd88_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeahead_vue__ = __webpack_require__(298);
function injectStyle (ssrContext) {
  __webpack_require__(292)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dedbdd88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeahead_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_dedbdd88_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeahead_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sponsorship_box_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sponsorship_box_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sponsorship_box_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sponsorship_box_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sponsorship_box_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48dc56fa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sponsorship_box_vue__ = __webpack_require__(300);
function injectStyle (ssrContext) {
  __webpack_require__(299)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sponsorship_box_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48dc56fa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sponsorship_box_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_social_share_row_vue__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_social_share_row_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_social_share_row_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_social_share_row_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_social_share_row_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_469a6d79_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_social_share_row_vue__ = __webpack_require__(302);
function injectStyle (ssrContext) {
  __webpack_require__(301)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_social_share_row_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_469a6d79_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_social_share_row_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_card_vue__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_card_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_card_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_card_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_card_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_308f02ab_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vote_card_vue__ = __webpack_require__(356);
function injectStyle (ssrContext) {
  __webpack_require__(343)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_card_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_308f02ab_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vote_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_intro_event_not_started_vue__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_intro_event_not_started_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_intro_event_not_started_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_intro_event_not_started_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_intro_event_not_started_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_390d1cb3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vote_intro_event_not_started_vue__ = __webpack_require__(361);
function injectStyle (ssrContext) {
  __webpack_require__(360)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_intro_event_not_started_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_390d1cb3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vote_intro_event_not_started_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_intro_voting_period_vue__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_intro_voting_period_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_intro_voting_period_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_intro_voting_period_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_intro_voting_period_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3814c012_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vote_intro_voting_period_vue__ = __webpack_require__(363);
function injectStyle (ssrContext) {
  __webpack_require__(362)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_intro_voting_period_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3814c012_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vote_intro_voting_period_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_intro_voting_intermission_vue__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_intro_voting_intermission_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_intro_voting_intermission_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_intro_voting_intermission_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_intro_voting_intermission_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68f30c40_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vote_intro_voting_intermission_vue__ = __webpack_require__(365);
function injectStyle (ssrContext) {
  __webpack_require__(364)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_intro_voting_intermission_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68f30c40_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vote_intro_voting_intermission_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_intro_winners_period_vue__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_intro_winners_period_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_intro_winners_period_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_intro_winners_period_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_intro_winners_period_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cc93ad2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vote_intro_winners_period_vue__ = __webpack_require__(367);
function injectStyle (ssrContext) {
  __webpack_require__(366)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vote_intro_winners_period_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cc93ad2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vote_intro_winners_period_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(531);

var _typeof3 = _interopRequireDefault(_typeof2);

var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _vueForage = __webpack_require__(209);

var _vueForage2 = _interopRequireDefault(_vueForage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueForage2.default);

$vf.config({
  name: 'bod_storage'
});

var storage = {
  general_data_expiration_minutes: 60,
  state: {
    general_data_last_modified: 0
  },

  get_current_general_last_modified: function get_current_general_last_modified() {
    return this.state.general_data_last_modified;
  },

  retrieve_general_last_modified: function retrieve_general_last_modified() {
    var vm = this;

    vm.get_item('general_data_last_modified').then(function (vf_response) {
      // console.log('vf_response: ', vf_response);
      if (vf_response) {
        // SAVE TO LOCAL STATE
        _vue2.default.set(vm.state, 'general_data_last_modified', vf_response.general_data_last_modified);
      } else {
        // UPDATE IN STORAGE
        vm.update_general_last_modified();
      }
    });
  },

  update_general_last_modified: function update_general_last_modified() {
    var vm = this;
    var now = new Date();

    vm.set_item('general_data_last_modified', now.getTime()).then(function () {
      _vue2.default.set(vm.state, 'general_data_last_modified', now.getTime());
    });
  },

  get_item: function get_item(item_key) {
    return $vf.getItem(item_key);
  },

  set_item: function set_item(item_key, item_value) {
    // CHECK IF ITEM_VALUE IS AN OBJECT
    if ((typeof item_value === 'undefined' ? 'undefined' : (0, _typeof3.default)(item_value)) == 'object') {
      // APPEND "LAST_MODIFIED" TIMESTAMP
      var modified = new Date();
      modified = modified.getTime();
      item_value.last_modified = modified;
    }

    return $vf.setItem(item_key, item_value);
  },

  remove_item: function remove_item(item_key) {
    return $vf.removeItem(item_key);
  }

};

exports.default = storage;

/***/ }),
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var manipulation_helpers = {
  state: {},

  get_human_datetime: function get_human_datetime(the_date, tz_offset) {
    // EXPECTS "Mon Feb 07 2011 11:05:00 GMT" FORMAT FOR IE AND SAFARI

    if (the_date) {

      var tz = 'EDT';
      if (tz_offset != '-0400') {
        tz = 'EST';
      }

      return the_date += ' ' + tz;
    }
  },

  check_timestamp_diff: function check_timestamp_diff(timestamp, compare_to) {
    // INIT
    var result = {};
    var diff = parseInt(compare_to) - parseInt(timestamp);

    // CHECK IF RESULT IS LESS THAN OR GREATER THAN 0
    if (diff < 0) {
      result.sign = '-';
    } else {
      result.sign = '+';
    }

    // GET ABSOLUTE VALUE FOR TEMPORAL DISTANCE MEASURMENT
    diff = Math.abs(diff);

    // DETERMINE VARIOUS TEMPORAL DISTANCES FROM "COMPARE_TO"
    result.ms = diff;
    result.seconds = diff / 1000;
    result.minutes = diff / (1000 * 60);
    result.hours = diff / (1000 * 60 * 60);
    result.days = diff / (1000 * 60 * 60 * 24);

    return result;
  }

};

exports.default = manipulation_helpers;

/***/ }),
/* 97 */,
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _header = __webpack_require__(221);

var _header2 = _interopRequireDefault(_header);

var _footer = __webpack_require__(385);

var _footer2 = _interopRequireDefault(_footer);

var _nav_mobile = __webpack_require__(391);

var _nav_mobile2 = _interopRequireDefault(_nav_mobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'app',
  data: function data() {
    return {};
  },
  created: function created() {
    // GET INSTANCE DATA FOR APP
    this.$root.store.instances.get_client_instance_data(this.$root.store.get_current_clientid());

    // RETRIEVE GENERAL LAST MODIFIED
    this.$root.store.storage.retrieve_general_last_modified();
  },
  mounted: function mounted() {
    // OUTPUT CMG GA SCRIPTS
    this.outputGaScriptsForCMG();

    // CHECK FOR LOGGED IN USER
    this.$root.store.session.check_stored_login();
  },

  computed: {
    instanceid: function instanceid() {
      return this.$root.store.instances.state.instanceid;
    },
    instance_period: function instance_period() {
      return this.$root.store.instances.get_current_active_instance_period();
    },
    instance_data: function instance_data() {
      return this.$root.store.instances.state.instance_data;
    }
  },
  methods: {
    get_master_contest_list: function get_master_contest_list() {
      // GET ALL CONTESTS FOR APP ON LOAD.
      // THIS WILL IMPROVE PERFORMANCE OVERALL COMPARED
      // TO PULLING IN SMALLER CHUNKS LATER.
      this.$root.store.contests.get_master_contest_list(this.instanceid);
    },

    outputGaScriptsForCMG: function outputGaScriptsForCMG() {
      var gaScript = document.createElement('script');
      gaScript.src = '//assets.adobedtm.com/20d5deb47c9e7fe47a9f969db01578a739d7179d/satelliteLib-3bdb96ce8c62153cdc81a8a72fc964fe2ffa1652.js';
      document.getElementsByTagName('head')[0].appendChild(gaScript);

      // RUN
      setTimeout(function () {
        _satellite.pageBottom();
      }, 1000);
    }
  },
  watch: {
    instanceid: function instanceid(new_val, old_val) {
      var vm = this;

      if (new_val > 0) {
        vm.get_master_contest_list();
      }
    }
  },
  components: {
    AppHeader: _header2.default,
    AppFooter: _footer2.default,
    NavMobile: _nav_mobile2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _router = __webpack_require__(28);

var _router2 = _interopRequireDefault(_router);

var _search_box = __webpack_require__(381);

var _search_box2 = _interopRequireDefault(_search_box);

var _dev_period_simulator = __webpack_require__(50);

var _dev_period_simulator2 = _interopRequireDefault(_dev_period_simulator);

var _fontawesomeSvgCore = __webpack_require__(5);

var _freeSolidSvgIcons = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faBars, _freeSolidSvgIcons.faSearch); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
	name: 'AppHeader',
	props: ['app_label'],
	data: function data() {
		return {
			show_search: false,
			env: this.$root.state.env
		};
	},

	computed: {
		instance_period: function instance_period() {
			return this.$root.store.instances.get_current_active_instance_period();
		},
		master_contest_list: function master_contest_list() {
			return this.$root.store.contests.get_current_master_contest_list();
		}
	},
	methods: {
		goto_path: function goto_path(path_name, e) {
			e.preventDefault();

			this.$root.store.goto_path(path_name);
		},
		toggle_mobile_nav: function toggle_mobile_nav() {
			console.log('toggling nav: ');
			this.$root.store.nav.toggle_mobile_nav();
		},
		toggle_search: function toggle_search() {
			this.show_search = !this.show_search;
		},
		handle_search: function handle_search(search_for) {
			var vm = this;
			vm.toggle_search();

			if (vm.instance_period == 'Nomination Period') {
				this.$root.store.goto_path('/nominate', search_for.instance_contestid);
			} else if (vm.instance_period == 'Voting Period') {
				this.$root.store.goto_path('/votenow/', search_for.instance_contestid);
			}
		}
	},
	components: {
		SearchBox: _search_box2.default,
		DevPeriodSim: _dev_period_simulator2.default
	}
};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _story_list = __webpack_require__(35);

var _story_list2 = _interopRequireDefault(_story_list);

var _large_centered_button = __webpack_require__(46);

var _large_centered_button2 = _interopRequireDefault(_large_centered_button);

var _countdown_to_next_event = __webpack_require__(235);

var _countdown_to_next_event2 = _interopRequireDefault(_countdown_to_next_event);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import ResponsiveAdUnit from '@/components/ad_units/responsive_ad_unit.vue'


exports.default = {
  name: 'homepage',
  data: function data() {
    return {
      test_title: 'Best of Dayton 2019'
    };
  },

  computed: {
    instance_period: {
      get: function get() {
        return this.$root.store.instances.get_current_active_instance_period();
      }
    },
    editors_note_active: function editors_note_active() {
      var today = new Date();
      var day = today.getDate();
      var month = today.getMonth() + 1;
      var year = today.getFullYear();
      var is_active = false;

      if (year == 2018) {
        if (month == 12) {
          if (day < 10) {
            is_active = true;
          }
        }
      }

      return is_active;
    }
  },
  methods: {
    goto_path: function goto_path(path_name) {
      this.$root.store.goto_path(path_name);
    },
    run_chartbeat: function run_chartbeat() {
      window.updateChartbeat(document.title, window.location.pathname);
    },
    determine_chartbeat: function determine_chartbeat() {
      var vm = this;
      var page_title = document.title;

      if (page_title.indexOf(vm.$metaInfo.title) == 0) {
        vm.run_chartbeat();
      } else {
        setTimeout(function () {
          vm.determine_chartbeat();
        }, 500);
      }
    }
  },
  mounted: function mounted() {
    // this.$root.googletag.cmd.push(function() { googletag.display('div-gpt-ad-1461776865768-0'); });
    document.dispatchEvent(new Event('prerender-trigger'));
    this.determine_chartbeat();
    // window.updateChartbeat(document.title, window.location.pathname);
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Welcome',
      titleTemplate: '%s | ' + this.test_title,
      meta: [{
        name: 'description',
        vmid: 'description',
        content: 'Nominate and vote for your favorite local businesses, food, people, professionals, places, and more in the 2019 Best of Dayton contest.'
      }, {
        property: 'og:url',
        content: 'https://projects.dayton.com/best_of_dayton/'
      }, {
        property: 'twitter:card',
        content: 'summary_large_image'
      }, {
        property: 'twitter:site',
        content: '@daytondotcom'
      }, {
        property: 'og:image',
        content: 'https://www.dayton.com/rf/image_large/Pub/p10/Dayton/2019/11/08/Images/DDC_BestofDayton_LeadRelatedObject_169.jpg?v=2019'
      }]
    };
  },

  components: {
    StoryList: _story_list2.default,
    LargeCenteredButton: _large_centered_button2.default,
    CountdownToNextEvent: _countdown_to_next_event2.default
    // ResponsiveAdUnit
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _card_generic = __webpack_require__(36);

var _card_generic2 = _interopRequireDefault(_card_generic);

var _story_list_item = __webpack_require__(229);

var _story_list_item2 = _interopRequireDefault(_story_list_item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
	name: 'story_list',
	props: ['cms_list_id'],
	data: function data() {
		return {};
	},

	computed: {
		item_limit: function item_limit() {
			var vm = this;
			var limit = 2;

			switch (this.$mq) {
				case 'mobile':
					limit = 4;
					break;

				case 'tablet':
				case 'laptop':
				case 'desktop':
					limit = 4;
					break;
			}

			return limit;
		},

		list_data: function list_data() {
			var data = this.$root.store.lists.get_cms_list2(this.cms_list_id, this.item_limit);
			// console.log('data: ', data);
			return data;
		}
	},
	methods: {},
	components: {
		CardGeneric: _card_generic2.default,
		StoryListItem: _story_list_item2.default
	}
};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'card_generic',
  props: ['title', 'subtitle', 'title_class', 'size'],
  data: function data() {
    return {};
  },

  components: {}
};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
	name: 'story_list_item',
	props: ['link', 'master_image_url', 'title'],
	data: function data() {
		return {};
	},

	computed: {},
	methods: {
		open_story_url: function open_story_url(url) {
			var vm = this;

			// FIRE GA EVENT
			vm.$ga.event({
				eventCategory: 'Outbound Link',
				eventAction: 'click',
				eventLabel: url
			});

			// ADD TRACKING STRING
			url += '?source=best_of_dayton_pwa&item=story_card';
			window.open(url);
		}
	},
	components: {}
};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _router = __webpack_require__(28);

var _router2 = _interopRequireDefault(_router);

var _fontawesomeSvgCore = __webpack_require__(5);

var _freeSolidSvgIcons = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faCheckDouble, _freeSolidSvgIcons.faClipboardCheck); //
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'large_centered_button',
  props: ['button_text', 'icon', 'width'],
  data: function data() {
    return {};
  },

  methods: {
    announce_button_clicked: function announce_button_clicked() {
      this.$emit('button_clicked', '');
    }
  },
  components: {}
};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _countdown_timer = __webpack_require__(29);

var _countdown_timer2 = _interopRequireDefault(_countdown_timer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'countdown_to_next_event',
  props: [],
  data: function data() {
    return {
      countdown_title: '',
      countdown_date: '',
      event_data_needed: '',
      event_property_needed: 'start'
    };
  },

  computed: {
    master_instance_periods: function master_instance_periods() {
      return this.$root.store.instances.state.instance_periods;
    },
    instance_period: {
      get: function get() {
        return this.$root.store.instances.get_current_active_instance_period();
      }
    },
    tz_offset: function tz_offset() {
      return this.$root.store.instances.get_current_timezone_offset();
    },
    active_instance_updated: function active_instance_updated() {
      return this.$root.store.instances.state.active_instance_updated;
    }
  },
  methods: {
    get_period_data: function get_period_data(period) {
      return this.$root.store.instances.get_specific_instance_period(period);
    },
    check_for_instance_data: function check_for_instance_data(callback) {
      var vm = this;

      if (vm.active_instance_updated == true && vm.master_instance_periods.length > 0) {
        callback();
      } else {
        setTimeout(function () {
          vm.check_for_instance_data(callback);
        }, 200);
      }
    },
    determine_countdown_values: function determine_countdown_values() {
      var vm = this;

      // DETERMINE THE NEXT COUNTDOWN EVENT
      switch (vm.instance_period) {
        case 'Event not started':
          vm.event_data_needed = 'Nomination Period';
          vm.event_property_needed = 'start';
          vm.countdown_title = 'Nominations start in:';
          break;

        case 'Nomination Period':
          vm.event_data_needed = 'Nomination Period';
          vm.event_property_needed = 'stop';
          vm.countdown_title = 'Nominations end in:';
          break;

        case 'Nomination Intermission':
          vm.event_data_needed = 'Voting Period';
          vm.event_property_needed = 'start';
          vm.countdown_title = 'Voting starts in:';
          break;

        case 'Voting Period':
          vm.event_data_needed = 'Voting Period';
          vm.event_property_needed = 'stop';
          vm.countdown_title = 'Voting ends in:';
          break;

        case 'Voting Intermission':
          vm.event_data_needed = 'Winners Period';
          vm.event_property_needed = 'start';
          vm.countdown_title = 'Winners announced in:';
          break;

        default:
          vm.event_data_needed = 'Event has ended';
          break;
      }

      // DETERMINE COUNTDOWN DATE/TIME
      if (vm.event_data_needed != 'Event has ended' && vm.event_data_needed != '') {
        var period_data = vm.get_period_data(vm.event_data_needed);
        var target_date = this.$root.store.manipulation_helpers.get_human_datetime(period_data[vm.event_property_needed], vm.tz_offset);

        // console.log('target_date: ', target_date);

        vm.countdown_date = target_date;
      }
    }
  },
  watch: {},
  mounted: function mounted() {
    this.check_for_instance_data(this.determine_countdown_values);
  },

  components: {
    Countdown: _countdown_timer2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _card_generic = __webpack_require__(36);

var _card_generic2 = _interopRequireDefault(_card_generic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Example "target_date" = '01/20/2018 12:00 AM UTC-0500'
*/
exports.default = {
  name: 'countdown_timer',
  props: ['target_date', 'title'],
  data: function data() {
    return {
      show_countdown: true,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      timeout_period: 990,
      gsecs: 0,
      now: new Date(),
      current_target_date: this.target_date
    };
  },
  created: function created() {
    // this.trigger_countdown();
    if (this.current_target_date != '') {
      this.trigger_countdown();
    }
  },

  watch: {
    target_date: function target_date(new_val, old_val) {
      if (new_val != '') {
        this.current_target_date = new_val;
        this.trigger_countdown();
      }
    }
  },
  methods: {
    trigger_countdown: function trigger_countdown() {
      this.gsecs = this.get_time_diff();
      this.count_backward(this.gsecs);
    },
    count_backward: function count_backward(secs) {
      var vm = this;

      // IF TIMER HAS ELAPSED, STOP LOOPING
      if (secs <= 0) {
        vm.show_countdown = false;
        return false;
      }

      // CALC DAYS
      vm.days = vm.calcage(secs, 86400, 100000);
      vm.hours = vm.calcage(secs, 3600, 24);
      vm.minutes = vm.calcage(secs, 60, 60);
      vm.seconds = vm.calcage(secs, 1, 60);

      // SET TIMEOUT FOR LOOP
      setTimeout(function () {
        vm.count_backward(secs - 1);
      }, vm.timeout_period);
    },
    calcage: function calcage(secs, num1, num2) {
      var s = (Math.floor(secs / num1) % num2).toString();
      if (s.length < 2) {
        s = "0" + s;
      }
      return s;
    },
    get_time_diff: function get_time_diff() {
      var target = new Date(this.current_target_date);
      var diff = new Date(target - this.now);
      return Math.floor(diff.valueOf() / 1000);
    }
  },
  components: {
    CardGeneric: _card_generic2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contest_list = __webpack_require__(243);

var _contest_list2 = _interopRequireDefault(_contest_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ContestListPage',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js PWA'
    };
  },

  components: {
    ContestList: _contest_list2.default
  }
}; //
//
//
//
//
//

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(59);

var _axios2 = _interopRequireDefault(_axios);

var _sample_contest_list = __webpack_require__(263);

var _sample_contest_list2 = _interopRequireDefault(_sample_contest_list);

var _sample_contestant_list = __webpack_require__(47);

var _sample_contestant_list2 = _interopRequireDefault(_sample_contestant_list);

var _contest_list_box = __webpack_require__(264);

var _contest_list_box2 = _interopRequireDefault(_contest_list_box);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ContestList',
  data: function data() {
    return {
      contests: _sample_contest_list2.default,
      contestants: _sample_contestant_list2.default
    };
  },

  components: {
    ContestListItemBox: _contest_list_box2.default
  }
};

/***/ }),
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contest_banner = __webpack_require__(61);

var _contest_banner2 = _interopRequireDefault(_contest_banner);

var _VoteCard = __webpack_require__(268);

var _VoteCard2 = _interopRequireDefault(_VoteCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ContestListItemBox',
  props: ['contest', 'contestants', 'vote_visible', 'contestant_images'],
  data: function data() {
    return {
      vote_visible_toggle: this.vote_visible,
      contestant_images: this.contestant_images,
      contest_banner_type: 'contest'
    };
  },

  methods: {
    show_vote_card: function show_vote_card() {
      this.vote_visible_toggle = !this.vote_visible_toggle;
    }
  },
  components: {
    ContestBanner: _contest_banner2.default,
    VoteCard: _VoteCard2.default
  }
};

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fontawesomeSvgCore = __webpack_require__(5);

var _freeSolidSvgIcons = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faUtensils, _freeSolidSvgIcons.faShoppingCart, _freeSolidSvgIcons.faSmileBeam, _freeSolidSvgIcons.faTaxi, _freeSolidSvgIcons.faUsers, _freeSolidSvgIcons.faBowlingBall, _freeSolidSvgIcons.faFilm, _freeSolidSvgIcons.faShoppingBasket, _freeSolidSvgIcons.faSwimmer, _freeSolidSvgIcons.faMapMarkedAlt, _freeSolidSvgIcons.faCaretRight, _freeSolidSvgIcons.faCaretDown, _freeSolidSvgIcons.faCocktail);

exports.default = {
  name: 'ContestBanner',
  props: ['contest', 'label', 'icon', 'lead_image', 'banner_type', 'is_expanded'],
  data: function data() {
    return {};
  },

  methods: {
    resize_cms_image: function resize_cms_image(value) {
      if (value.indexOf('/rw/') > 0) {
        return value.replace(/\/rw\//g, '/rf/image_md/');
      } else {
        return value;
      }
    }
  },
  components: {}
};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import ContestantListWithImages from './vote/ContestantListWithImages.vue';
// import ContestantListWithOutImages from './vote/ContestantListWithOutImages.vue';

exports.default = {
  name: 'VoteCard',
  props: ['contest', 'contestants', 'vote_visible', 'contestant_images'],
  data: function data() {
    return {};
  },

  methods: {},
  components: {
    // ContestantListWithImages,
    // ContestantListWithOutImages
  }
};

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _super_category_contest_list = __webpack_require__(119);

var _super_category_contest_list2 = _interopRequireDefault(_super_category_contest_list);

var _login_prompt = __webpack_require__(30);

var _login_prompt2 = _interopRequireDefault(_login_prompt);

var _countdown_timer = __webpack_require__(29);

var _countdown_timer2 = _interopRequireDefault(_countdown_timer);

var _nom_intro_event_not_started = __webpack_require__(310);

var _nom_intro_event_not_started2 = _interopRequireDefault(_nom_intro_event_not_started);

var _nom_intro_nomination_period = __webpack_require__(313);

var _nom_intro_nomination_period2 = _interopRequireDefault(_nom_intro_nomination_period);

var _nom_intro_voting_not_ended = __webpack_require__(316);

var _nom_intro_voting_not_ended2 = _interopRequireDefault(_nom_intro_voting_not_ended);

var _nom_intro_voting_intermission = __webpack_require__(319);

var _nom_intro_voting_intermission2 = _interopRequireDefault(_nom_intro_voting_intermission);

var _nom_intro_winners_period = __webpack_require__(322);

var _nom_intro_winners_period2 = _interopRequireDefault(_nom_intro_winners_period);

var _trans_bounce_inL_outR = __webpack_require__(31);

var _trans_bounce_inL_outR2 = _interopRequireDefault(_trans_bounce_inL_outR);

var _dcom_latest_stories_list = __webpack_require__(137);

var _dcom_latest_stories_list2 = _interopRequireDefault(_dcom_latest_stories_list);

var _fontawesomeSvgCore = __webpack_require__(5);

var _freeSolidSvgIcons = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faSearch);

exports.default = {
	name: 'NominationPage',
	data: function data() {
		return {};
	},
	mounted: function mounted() {
		document.dispatchEvent(new Event('prerender-trigger'));
		this.determine_chartbeat();
	},
	beforeUpdate: function beforeUpdate() {
		// this.$root.store.nominations.change_single_nom_share_status(false);
	},

	computed: {
		instance_period: {
			get: function get() {
				return this.$root.store.instances.get_current_active_instance_period();
			}
		},
		timezone_offset: function timezone_offset() {
			return this.$root.store.instances.get_current_timezone_offset();
		},
		nom_period_data: function nom_period_data() {
			return this.$root.store.instances.get_specific_instance_period('Nomination Period');
		},
		is_logged_in: function is_logged_in() {
			return this.$root.store.session.check_login_status();
		},
		user_data: function user_data() {
			return this.$root.store.session.get_user_email();
		},
		nom_share_status: function nom_share_status() {
			return this.$root.store.nominations.get_current_nom_share_status();
		}
	},
	methods: {
		change_period: function change_period(new_period) {
			this.instance_period = new_period;
		},
		run_chartbeat: function run_chartbeat() {
			window.updateChartbeat(document.title, window.location.pathname);
		},
		determine_chartbeat: function determine_chartbeat() {
			var vm = this;
			var page_title = document.title;

			if (page_title.indexOf(vm.$metaInfo.title) == 0) {
				vm.run_chartbeat();
			} else {
				setTimeout(function () {
					vm.determine_chartbeat();
				}, 500);
			}
		}
	},
	metaInfo: function metaInfo() {
		return {
			title: 'Nominations',
			titleTemplate: '%s | Best of Dayton 2019',
			meta: [{
				name: 'description',
				vmid: 'description',
				content: 'Nominate your favorite local businesses, food, service providers, and more!'
			}, {
				property: 'og:title',
				content: 'Nominate for Best of Dayton 2019'
			}, {
				property: 'og:site_name',
				content: 'Best of Dayton 2019'
			}, {
				property: 'og:type',
				content: 'website'
			}, {
				property: 'og:description',
				content: 'Nominate your favorite local businesses, food, service providers, and more!'
			}, {
				property: 'og:image',
				content: 'https://www.dayton.com/rf/image_large/Pub/p10/Dayton/2019/11/08/Images/DDC_BestofDayton_LeadRelatedObject_169.jpg?v=2019'
			}]
		};
	},

	components: {
		SuperCategoryList: _super_category_contest_list2.default,
		LoginPrompt: _login_prompt2.default,
		IntroNotStarted: _nom_intro_event_not_started2.default,
		IntroNominationPeriod: _nom_intro_nomination_period2.default,
		IntroVotingNotEnded: _nom_intro_voting_not_ended2.default,
		IntroVotingIntermission: _nom_intro_voting_intermission2.default,
		IntroWinnersPeriod: _nom_intro_winners_period2.default,
		Countdown: _countdown_timer2.default,
		TransBounce: _trans_bounce_inL_outR2.default,
		DcomLatestStoriesList: _dcom_latest_stories_list2.default
	}
};

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_super_category_contest_list_vue__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_super_category_contest_list_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_super_category_contest_list_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_super_category_contest_list_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_super_category_contest_list_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5001f256_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_super_category_contest_list_vue__ = __webpack_require__(307);
function injectStyle (ssrContext) {
  __webpack_require__(283)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_super_category_contest_list_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5001f256_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_super_category_contest_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _super_category_single = __webpack_require__(284);

var _super_category_single2 = _interopRequireDefault(_super_category_single);

var _fontawesomeSvgCore = __webpack_require__(5);

var _freeSolidSvgIcons = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faSearch); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
	name: 'SuperCategoryList',
	props: ['list_type'],
	data: function data() {
		return {};
	},
	mounted: function mounted() {
		var vm = this;
		vm.$root.store.categories.refresh_super_category_list(this.instanceid);
	},

	computed: {
		instanceid: function instanceid() {
			return this.$root.store.instances.state.instanceid;
		},
		super_category_list: function super_category_list() {
			return this.$root.store.categories.get_current_super_category_list();
		},
		master_contest_list: function master_contest_list() {
			return this.$root.store.contests.get_current_master_contest_list();
		}
	},
	watch: {},
	components: {
		SuperCategorySingle: _super_category_single2.default
	}
};

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _contest_banner = __webpack_require__(61);

var _contest_banner2 = _interopRequireDefault(_contest_banner);

var _nominate_list_box = __webpack_require__(286);

var _nominate_list_box2 = _interopRequireDefault(_nominate_list_box);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
	name: 'SuperCategorySingle',
	props: ['contests', 'supercat_data', 'list_type'],
	data: function data() {
		return {
			contest_banner_type: 'supercat',
			supercat_contests: this.contests,
			show_supercat_contests: false
		};
	},
	mounted: function mounted() {
		this.find_supercat_contests();
	},

	computed: {},
	methods: {
		find_supercat_contests: function find_supercat_contests() {
			var _this = this;

			this.supercat_contests = this.contests.filter(function (item) {
				return item.category.match(_this.supercat_data.category);
			});
		},
		toggle_show_contests: function toggle_show_contests() {
			this.show_supercat_contests = !this.show_supercat_contests;
		}
	},
	components: {
		ContestBanner: _contest_banner2.default,
		NominationListBox: _nominate_list_box2.default
	}
};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _nominate_supercat_contest_box = __webpack_require__(288);

var _nominate_supercat_contest_box2 = _interopRequireDefault(_nominate_supercat_contest_box);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'NominationListBox',
	props: ['contests', 'list_type', 'supercat_icon'],
	data: function data() {
		return {};
	},

	methods: {},
	components: {
		NominationSupercatContestBox: _nominate_supercat_contest_box2.default
	}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _contest_banner = __webpack_require__(61);

var _contest_banner2 = _interopRequireDefault(_contest_banner);

var _nominate_card = __webpack_require__(290);

var _nominate_card2 = _interopRequireDefault(_nominate_card);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
	name: 'NominationSupercatContestBox',
	props: ['contest', 'list_type', 'supercat_icon'],
	data: function data() {
		return {
			contest_banner_type: 'contest',
			show_contest_nomination_card: false,
			nomination_details: {},
			nomination_save_result: false,
			nomination_save_in_progress: false,
			reset_nomination: false
		};
	},

	computed: {},
	methods: {
		toggle_nomination_card: function toggle_nomination_card() {
			if (this.list_type == 'nominations') {
				this.show_contest_nomination_card = !this.show_contest_nomination_card;
			} else if (this.list_type == 'voting') {
				this.goto_path('/votenow', this.contest.instance_contestid);
			}
		},

		goto_path: function goto_path(path_name, param) {
			this.$root.store.goto_path(path_name, param);
		},
		reset_nomination_status: function reset_nomination_status() {
			this.$set(this, 'nomination_save_result', false);
			this.$set(this, 'nomination_save_in_progress', false);
			this.$set(this, 'reset_nomination', false);
		},
		nomination_listener: function nomination_listener(nomination_text) {
			var vm = this;

			// SET LOCAL VARS WITH NOMINATION DETAILS
			vm.nomination_details.nomination_text = nomination_text;
			vm.nomination_details.contest = vm.contest;

			// BUILD DATA OBJECT FOR SAVING
			var data = {
				instance_contestid: vm.contest.instance_contestid,
				nomination_text: nomination_text,
				user_publicid: this.$root.store.session.get_userid()

				// SET NOMINATION SAVE TO IN PROGRESS
				// vm.nomination_save_in_progress = true;
			};vm.$set(vm, 'nomination_save_in_progress', true);

			// REQUEST NOMINATION SAVE
			vm.$root.store.nominations.record_nomination(data).then(function (response) {
				// console.log('response: ', response);

				// RESET IN PROGRESS STATUS
				// vm.nomination_save_in_progress = false;
				vm.$set(vm, 'nomination_save_in_progress', false);

				if (response.data.data.success === true) {
					// vm.nomination_save_result = true;
					vm.$set(vm, 'nomination_save_result', true);

					// FIRE GA EVENT
					vm.$ga.event({
						eventCategory: 'Nominations',
						eventAction: vm.contest.label,
						eventLabel: vm.nomination_details.nomination_text
					});

					// SET TIMER TO RESET NOMINATION
					setTimeout(function () {
						vm.$set(vm, 'reset_nomination', true);
					}, 2000);
				} else {
					console.log('nomination save error: ');
				}
			});
		}
	},
	components: {
		ContestBanner: _contest_banner2.default,
		NominationCard: _nominate_card2.default
	}
};

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _vueBootstrapTypeahead = __webpack_require__(62);

var _vueBootstrapTypeahead2 = _interopRequireDefault(_vueBootstrapTypeahead);

var _sponsorship_box = __webpack_require__(63);

var _sponsorship_box2 = _interopRequireDefault(_sponsorship_box);

var _social_share_row = __webpack_require__(64);

var _social_share_row2 = _interopRequireDefault(_social_share_row);

var _fontawesomeSvgCore = __webpack_require__(5);

var _freeSolidSvgIcons = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faCheckCircle); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
	name: 'NominationCard',
	props: ['instance_contestid', 'nomination_save_status', 'nomination_save_in_progress', 'reset_nomination_requested'],
	data: function data() {
		return {
			contest_nomination_text: '',
			save_status: this.nomination_save_status
		};
	},
	created: function created() {
		this.$root.store.contests.get_contest_sponsors(this.instance_contestid);
		this.$root.store.nominations.get_nomination_suggestions_by_contest(this.instance_contestid);
	},

	watch: {
		nomination_save_status: function nomination_save_status(new_val, old_val) {
			var vm = this;

			vm.$set(vm, 'save_status', new_val);
		},
		reset_nomination_requested: function reset_nomination_requested(new_val, old_val) {
			var vm = this;

			if (new_val === true) {
				vm.reset_nomination();
			}
		}
	},
	computed: {
		sponsor_list: function sponsor_list() {
			return this.$root.store.contests.get_current_contest_sponsors(this.instance_contestid);
		},
		nomination_suggestions: function nomination_suggestions() {
			return this.$root.store.nominations.get_current_nomination_suggestions_by_contest(this.instance_contestid);
		}
	},
	methods: {
		reset_nomination: function reset_nomination() {
			this.contest_nomination_text = '';
			this.$emit('request_nomination_reset', '');
		},
		record_nomination: function record_nomination() {
			var vm = this;

			if (vm.contest_nomination_text != '') {
				vm.$emit('record_nomination_from_contest', vm.contest_nomination_text);
			}
		},
		goto_nom_share: function goto_nom_share(path_name, param) {
			// TOGGLE NOM SHARE STATUS TO TRUE
			this.$root.store.nominations.change_single_nom_share_status(true);

			// GOTO SINGLE NOM
			this.goto_path(path_name, param);
		},
		goto_path: function goto_path(path_name, param) {
			this.$root.store.goto_path(path_name, param);
		}
	},
	components: {
		VueBootstrapTypeahead: _vueBootstrapTypeahead2.default,
		SponsorshipBox: _sponsorship_box2.default,
		SocialShareRow: _social_share_row2.default
	}
};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VueBootstrapTypeaheadList = __webpack_require__(293);

var _VueBootstrapTypeaheadList2 = _interopRequireDefault(_VueBootstrapTypeaheadList);

var _resizeObserverPolyfill = __webpack_require__(297);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'VueBootstrapTypehead',

  components: {
    VueBootstrapTypeaheadList: _VueBootstrapTypeaheadList2.default
  },

  props: {
    size: {
      type: String,
      default: null,
      validator: function validator(size) {
        return ['lg', 'sm'].indexOf(size) > -1;
      }
    },
    value: String,
    data: {
      type: Array,
      required: true,
      validator: function validator(d) {
        return d instanceof Array;
      }
    },
    serializer: {
      type: Function,
      default: function _default(d) {
        return d;
      },
      validator: function validator(d) {
        return d instanceof Function;
      }
    },
    backgroundVariant: String,
    textVariant: String,
    inputClass: {
      type: String,
      default: ''
    },
    maxMatches: {
      type: Number,
      default: 10
    },
    minMatchingChars: {
      type: Number,
      default: 2
    },
    placeholder: String,
    prepend: String,
    append: String
  },

  computed: {
    sizeClasses: function sizeClasses() {
      return this.size ? 'input-group input-group-' + this.size : 'input-group';
    },
    formattedData: function formattedData() {
      var _this = this;

      if (!(this.data instanceof Array)) {
        return [];
      }
      return this.data.map(function (d, i) {
        return {
          id: i,
          data: d,
          text: _this.serializer(d)
        };
      });
    }
  },

  methods: {
    resizeList: function resizeList(el) {
      var rect = el.getBoundingClientRect();
      // this.$refs.list.$el.style.top = rect.height + 5 + 'px'
      this.$refs.list.$el.style.width = rect.width + 'px';
    },
    handleHit: function handleHit(evt) {
      this.$emit('input', evt.text);
      this.$emit('hit', evt.data);
      this.$refs.input.blur();
      this.isFocused = false;
    },
    handleBlur: function handleBlur(evt) {
      var tgt = evt.relatedTarget;
      if (tgt && tgt.classList.contains('vbst-item')) {
        return;
      }
      this.isFocused = false;
    }
  },

  data: function data() {
    return {
      isFocused: false
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$_ro = new _resizeObserverPolyfill2.default(function (e) {
      _this2.resizeList(_this2.$refs.input);
    });
    this.$_ro.observe(this.$refs.input);
    this.$_ro.observe(this.$refs.list.$el);
  },
  beforeDestroy: function beforeDestroy() {
    this.$_ro.disconnect();
  }
};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VueBootstrapTypeaheadListItem = __webpack_require__(294);

var _VueBootstrapTypeaheadListItem2 = _interopRequireDefault(_VueBootstrapTypeaheadListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sanitize(text) {
  return text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
} //
//
//
//
//
//
//
//
//
//
//
//

function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

exports.default = {
  name: 'VueBootstrapTypeaheadList',

  components: {
    VueBootstrapTypeaheadListItem: _VueBootstrapTypeaheadListItem2.default
  },

  props: {
    data: {
      type: Array,
      required: true,
      validator: function validator(d) {
        return d instanceof Array;
      }
    },
    query: {
      type: String,
      default: ''
    },
    backgroundVariant: {
      type: String
    },
    textVariant: {
      type: String
    },
    maxMatches: {
      type: Number,
      default: 10
    },
    minMatchingChars: {
      type: Number,
      default: 2
    }
  },

  computed: {
    highlight: function highlight() {
      var _this = this;

      return function (text) {
        text = sanitize(text);
        if (_this.query.length === 0) {
          return text;
        }
        var re = new RegExp(_this.escapedQuery, 'gi');

        return text.replace(re, '<strong>$&</strong>');
      };
    },
    escapedQuery: function escapedQuery() {
      return escapeRegExp(sanitize(this.query));
    },
    matchedItems: function matchedItems() {
      if (this.query.length === 0 || this.query.length < this.minMatchingChars) {
        return [];
      }

      var re = new RegExp(this.escapedQuery, 'gi');

      // Filter, sort, and concat
      return this.data.filter(function (i) {
        return i.text.match(re) !== null;
      }).sort(function (a, b) {
        var aIndex = a.text.indexOf(a.text.match(re)[0]);
        var bIndex = b.text.indexOf(b.text.match(re)[0]);

        if (aIndex < bIndex) {
          return -1;
        }
        if (aIndex > bIndex) {
          return 1;
        }
        return 0;
      }).slice(0, this.maxMatches);
    }
  },

  methods: {
    handleHit: function handleHit(item, evt) {
      this.$emit('hit', item);
      evt.preventDefault();
    }
  }
};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'VueBootstrapTypeaheadListItem',

  props: {
    backgroundVariant: {
      type: String
    },
    textVariant: {
      type: String
    }
  },

  data: function data() {
    return {
      active: false
    };
  },


  computed: {
    textClasses: function textClasses() {
      var classes = '';
      classes += this.active ? 'active' : '';
      classes += this.backgroundVariant ? ' bg-' + this.backgroundVariant : '';
      classes += this.textVariant ? ' text-' + this.textVariant : '';
      return 'vbst-item list-group-item list-group-item-action ' + classes;
    }
  }
};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _card_generic = __webpack_require__(36);

var _card_generic2 = _interopRequireDefault(_card_generic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'sponsorship_box',
  props: ['title', 'sponsors'],
  data: function data() {
    return {};
  },

  methods: {
    resize_cms_image: function resize_cms_image(value) {
      if (value.indexOf('/rw/') > 0) {
        return value.replace(/\/rw\//g, '/rf/image_md/');
      } else {
        return value;
      }
    },
    sponsor_click: function sponsor_click(sponsor, e) {
      var vm = this;

      // FIRE GA EVENT
      vm.$ga.event({
        eventCategory: 'Sponsors',
        eventAction: 'click',
        eventLabel: sponsor.name
      });
    }
  },
  components: {
    CardGeneric: _card_generic2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fontawesomeSvgCore = __webpack_require__(5);

var _freeSolidSvgIcons = __webpack_require__(6);

var _freeBrandsSvgIcons = __webpack_require__(48);

_fontawesomeSvgCore.library.add(_freeBrandsSvgIcons.faFacebookSquare, _freeBrandsSvgIcons.faTwitterSquare, _freeSolidSvgIcons.faEnvelopeSquare); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'social_share_row',
  props: ['share_type', 'contest'],
  data: function data() {
    return {
      window_url: window.location.href,
      fb_app_id: '497104900789770'
    };
  },

  methods: {
    share_fb: function share_fb() {
      // let share_url = 'https://www.facebook.com/dialog/share?app_id='+this.fb_app_id+'&display=popup&href='+escape(window.location.href)+'&redirect_uri='+escape('https://projects.dayton.com/best_of_dayton/');
      var share_url = 'https://www.facebook.com/sharer/sharer.php?u=' + escape(window.location.href) + '&t=' + document.title;

      window.open(share_url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600');

      this.fire_ga_event('Facebook Share');
    },
    share_tw: function share_tw() {
      var share_text = escape('Submit your ' + this.share_type + ' for "' + this.contest.label + '" for Dayton.com\'s 2018 Best of Dayton contest.');

      window.open("https://twitter.com/share?url=" + escape(window.location.href) + "&text=" + share_text, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600');

      this.fire_ga_event('Twitter Share');
    },
    share_email: function share_email() {
      var subject = "Best of Dayton: " + this.$options.filters.capitalize_first_letter(this.share_type) + " for " + this.contest.label;
      var body = window.location.href;

      window.open('mailto:?subject=' + subject + '&body=' + body, '_top', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');

      this.fire_ga_event('Email Share');
    },
    fire_ga_event: function fire_ga_event(event_action) {
      var vm = this;

      // FIRE GA EVENT
      vm.$ga.event({
        eventCategory: 'Sharing',
        eventAction: event_action,
        eventLabel: this.window_url
      });
    }
  },
  filters: {
    capitalize_first_letter: function capitalize_first_letter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  },
  components: {}
};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _card_generic = __webpack_require__(36);

var _card_generic2 = _interopRequireDefault(_card_generic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'login_prompt',
  props: [],
  data: function data() {
    return {
      errors: [],
      form: {
        email: '',
        email_consent: '1'
      }
    };
  },

  methods: {
    check_form: function check_form(e) {
      e.preventDefault();
      var vm = this;
      // console.log('checking: ');
      // RESET ERRORS
      vm.errors = [];

      // CHECK IF VALID EMAIL
      if (!vm.form.email) {
        vm.errors.push('Email required.');
      } else if (!vm.valid_email(vm.form.email)) {
        vm.errors.push('Valid email required.');
      }

      if (vm.errors.length < 1) {
        vm.log_in();
      }
    },
    log_in: function log_in() {
      var vm = this;

      // INIT DATA
      var data = {
        email: vm.form.email,
        consent: vm.form.email_consent
      };

      this.$root.store.session.log_in(vm.form.email, vm.form.email_consent).then(function () {

        // FIRE GA EVENT
        vm.$ga.event({
          eventCategory: 'Logins',
          eventAction: 'User Login',
          eventLabel: data.email
        });
      });
    },
    valid_email: function valid_email(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  },
  components: {
    CardGeneric: _card_generic2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _countdown_timer = __webpack_require__(29);

var _countdown_timer2 = _interopRequireDefault(_countdown_timer);

var _fontawesomeSvgCore = __webpack_require__(5);

var _freeSolidSvgIcons = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faSearch); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'nom_intro_event_not_started',
  props: ['nom_start_date', 'tz_offset'],
  data: function data() {
    return {};
  },

  computed: {
    nomination_start_date: function nomination_start_date() {
      var vm = this;
      var start = '';

      if (vm.nom_start_date) {
        start = this.$root.store.manipulation_helpers.get_human_datetime(vm.nom_start_date, vm.tz_offset);
      }

      return start;
    }
  },
  methods: {},
  components: {
    Countdown: _countdown_timer2.default
  }
};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _countdown_timer = __webpack_require__(29);

var _countdown_timer2 = _interopRequireDefault(_countdown_timer);

var _fontawesomeSvgCore = __webpack_require__(5);

var _freeSolidSvgIcons = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faSearch); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'nom_intro_nomination_period',
  props: ['nom_stop_date'],
  data: function data() {
    return {};
  },

  computed: {
    nomination_stop_date: function nomination_stop_date() {
      var vm = this;
      var the_date = '';

      if (vm.nom_stop_date) {
        the_date = this.$root.store.manipulation_helpers.get_human_datetime(vm.nom_stop_date, vm.tz_offset);
      }

      return the_date;
    }
  },
  components: {
    Countdown: _countdown_timer2.default
  }
};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _large_centered_button = __webpack_require__(46);

var _large_centered_button2 = _interopRequireDefault(_large_centered_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'nom_intro_voting_not_ended',
  props: [],
  data: function data() {
    return {};
  },

  methods: {
    goto_path: function goto_path(path_name) {
      this.$root.store.goto_path(path_name);
    }
  },
  computed: {},
  components: {
    LargeCenteredButton: _large_centered_button2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _story_list = __webpack_require__(35);

var _story_list2 = _interopRequireDefault(_story_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'nom_intro_voting_intermission',
  props: ['nom_start_date', 'tz_offset'],
  data: function data() {
    return {};
  },

  computed: {},
  methods: {},
  components: {}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'nom_intro_winners_period',
  props: ['nom_start_date', 'tz_offset'],
  data: function data() {
    return {};
  },

  computed: {},
  methods: {},
  components: {}
};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'trans_bounce',
  props: [],
  data: function data() {
    return {};
  },

  methods: {},
  components: {}
};

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dcom_latest_stories_list_vue__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dcom_latest_stories_list_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dcom_latest_stories_list_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dcom_latest_stories_list_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dcom_latest_stories_list_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b412276_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dcom_latest_stories_list_vue__ = __webpack_require__(328);
function injectStyle (ssrContext) {
  __webpack_require__(327)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dcom_latest_stories_list_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b412276_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dcom_latest_stories_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _story_list = __webpack_require__(35);

var _story_list2 = _interopRequireDefault(_story_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'DcomLatestStories',
	data: function data() {
		return {
			dcom_stories_uuid: '0036de38-28b8-11e9-bab0-a7d3b5289767'
		};
	},

	computed: {},
	methods: {},
	components: {
		StoryList: _story_list2.default
	}
}; //
//
//
//
//
//
//
//
//
//

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nominate_card_large = __webpack_require__(332);

var _nominate_card_large2 = _interopRequireDefault(_nominate_card_large);

var _story_list = __webpack_require__(35);

var _story_list2 = _interopRequireDefault(_story_list);

var _login_prompt = __webpack_require__(30);

var _login_prompt2 = _interopRequireDefault(_login_prompt);

var _sample_contestant_list = __webpack_require__(47);

var _sample_contestant_list2 = _interopRequireDefault(_sample_contestant_list);

var _trans_zoom = __webpack_require__(49);

var _trans_zoom2 = _interopRequireDefault(_trans_zoom);

var _trans_bounce_inL_outR = __webpack_require__(31);

var _trans_bounce_inL_outR2 = _interopRequireDefault(_trans_bounce_inL_outR);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'nomination_single_page',
  data: function data() {
    return {
      nomination_details: {},
      nomination_save_result: false,
      nomination_save_in_progress: false,
      reset_nomination: false,
      show_contest_index: 0,
      vote_complete: false,
      voting_period_started: false, // NEED TO MAKE THIS A CALCULATION FROM STORE
      nomination_period_started: true,
      meta_title: 'Nominations',
      meta_image: 'https://www.dayton.com/rf/image_large/Pub/p10/Dayton/2019/11/08/Images/DDC_BestofDayton_LeadRelatedObject_169.jpg',
      meta_data: ''
    };
  },
  created: function created() {
    // console.log('nom page created: ');
  },
  mounted: function mounted() {
    // this.determine_chartbeat();
    // console.log('nom page mounted: ');
  },
  beforeUpdate: function beforeUpdate() {
    // console.log('nom page beforeUpdate: ');
  },
  updated: function updated() {
    // console.log('nom page update: ');
    // console.log('this.contest: ', this.contest);
  },
  destroyed: function destroyed() {
    // this.$root.store.nominations.change_single_nom_share_status(false);
  },

  watch: {
    contest: function contest(new_val, old_val) {
      var vm = this;

      if (new_val != old_val) {
        if (new_val) {

          if (vm.contest.label) {
            // vm.meta_title = vm.contest.label;
            vm.$set(vm, 'meta_title', vm.contest.label);
            vm.determine_chartbeat();
          }

          if (vm.contest.lead_image) {
            // vm.meta_image = vm.contest.lead_image;
            vm.$set(vm, 'meta_image', vm.contest.lead_image);
          }

          // vm.meta_data = vm.contest;
          vm.$set(vm, 'meta_data', vm.contest);

          setTimeout(function () {
            document.dispatchEvent(new Event('prerender-trigger'));
          }, 500);
        }
      }
    }
  },
  computed: {
    instance_period: function instance_period() {
      return this.$root.store.instances.state.active_instance_period;
    },
    instance_contestid: function instance_contestid() {
      return this.$route.params.id;
    },
    temp_master: function temp_master() {
      return this.$root.store.contests.state.master_contest_list;
    },
    is_logged_in: function is_logged_in() {
      return this.$root.store.session.check_login_status();
    },
    contest: function contest() {
      return this.$root.store.contests.get_single_contest(this.instance_contestid);
    },
    test: function test() {
      return 'testing';
    }
  },
  methods: {
    goto_path: function goto_path(path_name, param) {
      this.$root.store.goto_path(path_name, param);
    },
    reset_nomination_status: function reset_nomination_status() {
      this.nomination_save_result = false;
      // this.nomination_save_in_progress = false;
      this.$set(this, 'nomination_save_in_progress', false);
      this.reset_nomination = false;
    },
    nomination_listener: function nomination_listener(nomination_text) {
      var vm = this;

      // SET LOCAL VARS WITH NOMINATION DETAILS
      // vm.nomination_details.nomination_text = nomination_text;
      vm.$set(vm.nomination_details, 'nomination_text', nomination_text);
      // vm.nomination_details.contest = vm.contest;
      vm.$set(vm.nomination_details, 'contest', vm.contest);

      // BUILD DATA OBJECT FOR SAVING
      var data = {
        instance_contestid: vm.instance_contestid,
        nomination_text: nomination_text,
        user_publicid: this.$root.store.session.get_userid()

        // SET NOMINATION SAVE TO IN PROGRESS
      };vm.nomination_save_in_progress = true;

      // REQUEST NOMINATION SAVE
      vm.$root.store.nominations.record_nomination(data).then(function (response) {
        // console.log('response: ', response);

        // RESET IN PROGRESS STATUS
        vm.nomination_save_in_progress = false;

        if (response.data.data.success === true) {
          vm.nomination_save_result = true;
          vm.$set(vm, 'nomination_save_result', true);

          // FIRE GA EVENT
          vm.$ga.event({
            eventCategory: 'Nominations',
            eventAction: vm.contest.label,
            eventLabel: vm.nomination_details.nomination_text
          });

          // SET TIMER TO RESET NOMINATION
          setTimeout(function () {
            vm.$set(vm, 'reset_nomination', true);
          }, 2000);
        }
      });
    },

    run_chartbeat: function run_chartbeat() {
      window.updateChartbeat(document.title, window.location.pathname);
    },
    determine_chartbeat: function determine_chartbeat() {
      var vm = this;
      var page_title = document.title;

      if (page_title.indexOf(vm.$metaInfo.title) == 0) {
        vm.run_chartbeat();
      } else {
        setTimeout(function () {
          vm.determine_chartbeat();
        }, 500);
      }
    }
  },
  metaInfo: function metaInfo() {
    return {
      title: this.meta_title,
      titleTemplate: '%s | Best of Dayton 2019',
      meta: [{
        name: 'description',
        vmid: 'description',
        content: 'Nominate for "' + this.meta_title + '" in the Dayton.com 2019 Best of Dayton contest'
      }, {
        property: 'og:image',
        content: this.meta_image
      }]
    };
  },

  components: {
    NominateCardLarge: _nominate_card_large2.default,
    LoginPrompt: _login_prompt2.default,
    TransZoom: _trans_zoom2.default,
    TransBounce: _trans_bounce_inL_outR2.default,
    StoryList: _story_list2.default
  }
};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueBootstrapTypeahead = __webpack_require__(62);

var _vueBootstrapTypeahead2 = _interopRequireDefault(_vueBootstrapTypeahead);

var _social_share_row = __webpack_require__(64);

var _social_share_row2 = _interopRequireDefault(_social_share_row);

var _large_social_share = __webpack_require__(334);

var _large_social_share2 = _interopRequireDefault(_large_social_share);

var _sponsorship_box = __webpack_require__(63);

var _sponsorship_box2 = _interopRequireDefault(_sponsorship_box);

var _fontawesomeSvgCore = __webpack_require__(5);

var _freeSolidSvgIcons = __webpack_require__(6);

var _freeBrandsSvgIcons = __webpack_require__(48);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faUtensils, _freeSolidSvgIcons.faShoppingCart, _freeSolidSvgIcons.faSmileBeam, _freeSolidSvgIcons.faTaxi, _freeSolidSvgIcons.faUsers, _freeSolidSvgIcons.faBowlingBall, _freeSolidSvgIcons.faFilm, _freeSolidSvgIcons.faShoppingBasket, _freeSolidSvgIcons.faSwimmer, _freeSolidSvgIcons.faMapMarkedAlt, _freeSolidSvgIcons.faCaretRight, _freeSolidSvgIcons.faCaretDown, _freeBrandsSvgIcons.faFacebookSquare, _freeBrandsSvgIcons.faTwitterSquare, _freeSolidSvgIcons.faEnvelopeSquare, _freeSolidSvgIcons.faLongArrowAltRight); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'nominate_large_card',
  props: ['contest', 'instance_contestid', 'nomination_save_status', 'nomination_save_in_progress', 'reset_nomination_requested'],
  data: function data() {
    return {
      contest_nomination_text: '',
      save_status: this.nomination_save_status
    };
  },
  created: function created() {
    this.update_card_data();
  },
  mounted: function mounted() {},
  beforeUpdate: function beforeUpdate() {},
  updated: function updated() {},

  watch: {
    nomination_save_status: function nomination_save_status(new_val, old_val) {
      var vm = this;
      vm.save_status = new_val;
    },
    reset_nomination_requested: function reset_nomination_requested(new_val, old_val) {
      var vm = this;

      if (new_val === true) {
        vm.reset_nomination();
      }
    },
    contest: function contest(new_val, old_val) {
      this.update_card_data();
    }
  },
  computed: {
    sponsor_list: function sponsor_list() {
      return this.$root.store.contests.get_current_contest_sponsors(this.instance_contestid);
    },
    nomination_suggestions: function nomination_suggestions() {
      return this.$root.store.nominations.get_current_nomination_suggestions_by_contest(this.instance_contestid);
    },
    nom_share_status: function nom_share_status() {
      return this.$root.store.nominations.get_current_nom_share_status();
    }
  },
  methods: {
    reset_nomination: function reset_nomination() {
      this.contest_nomination_text = '';
      this.$emit('request_nomination_reset', '');
    },
    record_nomination: function record_nomination() {
      var vm = this;

      if (vm.contest_nomination_text != '') {
        vm.$emit('record_nomination_from_contest', vm.contest_nomination_text);
      }
    },
    resize_cms_image: function resize_cms_image(value) {
      if (value.indexOf('/rw/') > 0) {
        return value.replace(/\/rw\//g, '/rf/image_md/');
      } else {
        return value;
      }
    },
    update_card_data: function update_card_data() {
      this.$root.store.contests.get_contest_sponsors(this.instance_contestid);
      this.$root.store.nominations.get_nomination_suggestions_by_contest(this.instance_contestid);
    }
  },
  /*metaInfo() {
    return {
      meta: [
        {
          name: 'description',
          vmid: 'description',
          content: this.contest.label
        }
      ]
    }
  },*/
  filters: {},
  components: {
    VueBootstrapTypeahead: _vueBootstrapTypeahead2.default,
    SocialShareRow: _social_share_row2.default,
    SponsorshipBox: _sponsorship_box2.default,
    LargeSocialShare: _large_social_share2.default
  }
};

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fontawesomeSvgCore = __webpack_require__(5);

var _freeSolidSvgIcons = __webpack_require__(6);

var _freeBrandsSvgIcons = __webpack_require__(48);

_fontawesomeSvgCore.library.add(_freeBrandsSvgIcons.faFacebookSquare, _freeBrandsSvgIcons.faTwitterSquare, _freeSolidSvgIcons.faEnvelopeSquare, _freeSolidSvgIcons.faLink); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'large_social_share',
  props: ['share_type', 'contest'],
  data: function data() {
    return {
      window_url: window.location.href,
      fb_app_id: '497104900789770',
      link_copied: false
    };
  },

  methods: {
    share_fb: function share_fb() {
      // let share_url = 'https://www.facebook.com/dialog/share?app_id='+this.fb_app_id+'&display=popup&href='+escape(window.location.href)+'&redirect_uri='+escape('https://projects.dayton.com/best_of_dayton/');
      var share_url = 'https://www.facebook.com/sharer/sharer.php?u=' + escape(window.location.href) + '&t=' + document.title;

      window.open(share_url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600');

      this.fire_ga_event('Facebook Share');
    },
    share_tw: function share_tw() {
      var share_text = escape('Submit your ' + this.share_type + ' for "' + this.contest.label + '" for Dayton.com\'s 2018 Best of Dayton contest.');

      window.open("https://twitter.com/share?url=" + escape(window.location.href) + "&text=" + share_text, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600');

      this.fire_ga_event('Twitter Share');
    },
    share_email: function share_email() {
      var subject = "Best of Dayton: Nominate for " + this.contest.label;
      var body = window.location.href;

      window.open('mailto:?subject=' + subject + '&body=' + body, '_top', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');

      this.fire_ga_event('Email Share');
    },
    share_link: function share_link() {
      var vm = this;

      // RESET STATUS MSG
      vm.toggle_link_message(false);

      var link_text = document.getElementById('link_share_text');
      link_text.select();
      document.execCommand("copy");
      console.log('copied to clipboard: ');

      vm.toggle_link_message(true);

      this.fire_ga_event('Link Share');

      // SET TIMEOUT FOR MSG
      setTimeout(function () {
        vm.toggle_link_message(false);
      }, 2000);
    },
    toggle_link_message: function toggle_link_message(specific_value) {
      if (typeof specific_value != 'undefined') {
        this.link_copied = specific_value;
      } else {
        this.link_copied = !this.link_copied;
      }
    },
    fire_ga_event: function fire_ga_event(event_action) {
      var vm = this;

      // FIRE GA EVENT
      vm.$ga.event({
        eventCategory: 'Sharing',
        eventAction: event_action,
        eventLabel: this.window_url
      });
    }
  },
  components: {}
};

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'trans_zoom',
  props: [],
  data: function data() {
    return {};
  },

  methods: {},
  components: {}
};

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _router = __webpack_require__(28);

var _router2 = _interopRequireDefault(_router);

var _story_list = __webpack_require__(35);

var _story_list2 = _interopRequireDefault(_story_list);

var _vote_card = __webpack_require__(65);

var _vote_card2 = _interopRequireDefault(_vote_card);

var _login_prompt = __webpack_require__(30);

var _login_prompt2 = _interopRequireDefault(_login_prompt);

var _countdown_timer = __webpack_require__(29);

var _countdown_timer2 = _interopRequireDefault(_countdown_timer);

var _sample_contestant_list = __webpack_require__(47);

var _sample_contestant_list2 = _interopRequireDefault(_sample_contestant_list);

var _trans_zoom = __webpack_require__(49);

var _trans_zoom2 = _interopRequireDefault(_trans_zoom);

var _trans_bounce_inL_outR = __webpack_require__(31);

var _trans_bounce_inL_outR2 = _interopRequireDefault(_trans_bounce_inL_outR);

var _large_centered_button = __webpack_require__(46);

var _large_centered_button2 = _interopRequireDefault(_large_centered_button);

var _fontawesomeSvgCore = __webpack_require__(5);

var _freeSolidSvgIcons = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faSearch); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'VoteCardDemoPage',
  data: function data() {
    return {
      contest_list: [],
      contestant_list: _sample_contestant_list2.default.contestants,
      sponsors: [{
        name: 'Bill\'s Donuts',
        logo_url: 'https://store-ysa7mo.mybigcommerce.com/product_images/logo_thumb.png',
        website_url: 'http://billsdonutshop.com/'
      }, {
        name: 'Stan the Donut Man',
        logo_url: 'https://scontent.fluk1-1.fna.fbcdn.net/v/t1.0-9/12189751_10153675145671894_1012819119755676509_n.jpg?_nc_cat=107&oh=b3dd5b957f699a1242c150fcccdc2515&oe=5C620EDB',
        website_url: 'https://www.facebook.com/pages/Stan-The-Donut-Man/117942361565254'
      }],
      show_contest_index: 0,
      vote_complete: false,
      voting_period_started: false, // NEED TO MAKE THIS A CALCULATION FROM STORE
      nomination_period_started: true
    };
  },
  created: function created() {
    this.contest_list = this.$root.store.contests.get_master_contest_list();
  },

  computed: {
    is_logged_in: function is_logged_in() {
      return this.$root.store.session.check_login_status();
    }
  },
  methods: {
    toggle_vote_period_start: function toggle_vote_period_start() {
      this.voting_period_started = !this.voting_period_started;
      window.scrollTo(0, 0);
    },
    change_vote_card: function change_vote_card() {
      // UPDATE "VOTE_COMPLETE" TO FALSE TO RESET
      this.vote_complete = false;

      if (this.show_contest_index == 0) {
        this.show_contest_index = 1;
      } else {
        this.show_contest_index = 0;
      }

      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 1200);
    },
    record_vote: function record_vote() {
      // CATPURE "THIS"
      var vm = this;
      // UPDATE "VOTE_COMPLETE" TO TRUE
      this.vote_complete = true;

      // ARTIFICIAL DELAY TO SHOW USER THAT VOTE WAS COMPLETE
      setTimeout(function () {
        vm.change_vote_card();
      }, 1500);
    },
    goto_path: function goto_path(path_name) {
      this.$root.store.goto_path(path_name);
    }
  },
  metaInfo: {
    title: 'Vote Card Demo Page',
    titleTemplate: '%s | Best of Dayton 2019',
    meta: [{
      name: 'description',
      vmid: 'description',
      content: 'Nominate your favorite local businesses, food, service providers, and more!'
    }, {
      property: 'og:title',
      content: 'Nominate for Best of Dayton 2019'
    }, {
      property: 'og:site_name',
      content: 'Best of Dayton 2019'
    }, {
      property: 'og:type',
      content: 'website'
    }, {
      property: 'og:description',
      content: 'Nominate your favorite local businesses, food, service providers, and more!'
    }, {
      property: 'og:image',
      content: 'https://www.whio.com/rf/image_inline/Pub/Web/WHIO/Special%20Contents/Imported%20Images/Doppler%20Images/Live%20Doppler%207.jpg'
    }]
  },
  components: {
    VoteCard: _vote_card2.default,
    LoginPrompt: _login_prompt2.default,
    TransZoom: _trans_zoom2.default,
    TransBounce: _trans_bounce_inL_outR2.default,
    Countdown: _countdown_timer2.default,
    StoryList: _story_list2.default,
    LargeCenteredButton: _large_centered_button2.default
  }
};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ContestantListWithOutImages = __webpack_require__(344);

var _ContestantListWithOutImages2 = _interopRequireDefault(_ContestantListWithOutImages);

var _fixed_vote_card_button_row = __webpack_require__(347);

var _fixed_vote_card_button_row2 = _interopRequireDefault(_fixed_vote_card_button_row);

var _social_share_row = __webpack_require__(64);

var _social_share_row2 = _interopRequireDefault(_social_share_row);

var _generic_share_button = __webpack_require__(353);

var _generic_share_button2 = _interopRequireDefault(_generic_share_button);

var _sponsorship_box = __webpack_require__(63);

var _sponsorship_box2 = _interopRequireDefault(_sponsorship_box);

var _fontawesomeSvgCore = __webpack_require__(5);

var _freeSolidSvgIcons = __webpack_require__(6);

var _freeBrandsSvgIcons = __webpack_require__(48);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faUtensils, _freeSolidSvgIcons.faShoppingCart, _freeSolidSvgIcons.faSmileBeam, _freeSolidSvgIcons.faTaxi, _freeSolidSvgIcons.faUsers, _freeSolidSvgIcons.faBowlingBall, _freeSolidSvgIcons.faFilm, _freeSolidSvgIcons.faShoppingBasket, _freeSolidSvgIcons.faSwimmer, _freeSolidSvgIcons.faMapMarkedAlt, _freeSolidSvgIcons.faCaretRight, _freeSolidSvgIcons.faCaretDown, _freeBrandsSvgIcons.faFacebookSquare, _freeBrandsSvgIcons.faTwitterSquare, _freeSolidSvgIcons.faEnvelopeSquare, _freeSolidSvgIcons.faLongArrowAltRight, _freeSolidSvgIcons.faLongArrowAltLeft);

exports.default = {
  name: 'VoteCard',
  props: ['contest', 'instance_contestid', 'contestants', 'vote_complete', 'is_single_contest'],
  data: function data() {
    return {
      vote_enabled: false,
      selected_contestant: {},
      vote_status: 'idle'
    };
  },
  mounted: function mounted() {
    var vm = this;

    // GET CONTEST SPONSORS
    vm.$root.store.contests.get_contest_sponsors(this.instance_contestid);

    // UPDATE COUNT OF VOTES FOR USER
    if (this.$root.store.voting.get_voted_count() == 0) {
      vm.$root.store.voting.get_contest_list_by_type(vm.instanceid, 'unvoted', vm.user_publicid).then(function (response) {
        // ADJUST LIST TO BE ARRAY OF VALUES INSTEAD OF OBJECTS
        var new_list = [];
        var old_list = response.data.data;
        for (var key in old_list) {
          new_list.push(old_list[key].instance_contestid);
        }

        vm.$root.store.voting.store_unvoted_contest_list(new_list);
      }).then(function () {
        var vote_count = vm.calc_voted_count(vm.master_contest_list.length, vm.unvoted_contest_list.length);
        vm.$root.store.voting.store_voted_count(vote_count);
      });
    }
  },

  watch: {
    vote_complete: function vote_complete(new_val, old_val) {
      if (new_val == true) {
        this.$set(this, 'vote_status', 'complete');
      }
    },
    instance_contestid: function instance_contestid(new_val, old_val) {
      this.$root.store.contests.get_contest_sponsors(new_val);
      return true;
    }
  },
  computed: {
    contest_sponsors: function contest_sponsors() {
      var vm = this;
      var sponsors = this.$root.store.contests.get_current_contest_sponsors(vm.instance_contestid);

      return sponsors;
    },
    master_contest_list: function master_contest_list() {
      return this.$root.store.contests.get_current_master_contest_list();
    },
    unvoted_contest_list: function unvoted_contest_list() {
      return this.$root.store.voting.get_current_unvoted_contest_list();
    },
    voted_count: function voted_count() {
      return this.$root.store.voting.get_voted_count();
    },
    user_publicid: function user_publicid() {
      return this.$root.store.session.get_userid();
    },
    instanceid: function instanceid() {
      return this.$root.store.instances.get_current_instanceid();
    }
  },
  methods: {
    calc_voted_count: function calc_voted_count(total_contest_count, unvoted_contest_count) {
      return parseInt(total_contest_count) - parseInt(unvoted_contest_count);
    },
    handle_contestant_selected: function handle_contestant_selected(selected_contestant) {
      this.$set(this, 'selected_contestant', selected_contestant);
      this.$set(this, 'vote_status', 'ready');
      this.vote_enabled = true;
    },
    handle_vote: function handle_vote() {
      var vm = this;

      if (typeof vm.selected_contestant.finalistid != 'undefined') {
        // ADD CONTEST LABEL FOR TRACKING
        vm.selected_contestant.contest_label = vm.contest.label;
        // vm.$emit('next_contest_requested', '');
        vm.$set(vm, 'vote_status', 'processing');
        vm.$emit('contest_vote_submitted', vm.selected_contestant);
      }
    },
    skip_vote: function skip_vote() {
      var vm = this;

      // FIRE GA EVENT
      vm.$ga.event({
        eventCategory: 'Vote Skips',
        eventAction: 'skipped',
        eventLabel: vm.contest.label
      });

      vm.$emit('next_contest_requested', '');
    },
    resize_cms_image: function resize_cms_image(value) {
      if (value.indexOf('/rw/') > 0) {
        return value.replace(/\/rw\//g, '/rf/image_md/');
      } else {
        return value;
      }
    },
    handle_share_click: function handle_share_click() {
      // GOTO SINGLE VOTE PAGE
      this.goto_path_with_param('/votenow/', this.instance_contestid);
    },
    goto_path: function goto_path(path_name) {
      this.$root.store.goto_path(path_name);
    },
    goto_path_with_param: function goto_path_with_param(path_name, param) {
      this.$root.store.goto_path(path_name, param);
    }
  },
  filters: {},
  components: {
    ContestantListWithOutImages: _ContestantListWithOutImages2.default,
    SocialShareRow: _social_share_row2.default,
    FixedVoteButtonRow: _fixed_vote_card_button_row2.default,
    SponsorshipBox: _sponsorship_box2.default,
    GenericShareButton: _generic_share_button2.default
  }
};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ContestantListWithOutImages',
  props: ['contestants'],
  data: function data() {
    return {
      selected_contestant: {}
    };
  },

  methods: {
    update_selected_contestant: function update_selected_contestant(contestant) {
      this.selected_contestant = contestant;

      // LET PARENT KNOW THAT A SELECTION WAS MADE
      this.$emit('contestant_selected', contestant);
    }
  },
  components: {}
};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _progress_bar = __webpack_require__(349);

var _progress_bar2 = _interopRequireDefault(_progress_bar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'fixed_vote_button_row',
  props: ['vote_enabled', 'vote_status', 'total_contests', 'voted_count', 'is_single_contest'],
  data: function data() {
    return {
      has_submitted_vote: false
    };
  },

  methods: {
    send_vote: function send_vote() {
      var vm = this;

      vm.has_submitted_vote = true;

      vm.$emit('contest_vote_submitted', '');

      // ARTIFICIAL DELAY TO SIMULATE SENDING VOTE AND GETTING RESPONSE FROM SERVER
      /*setTimeout(function() {
        vm.$emit('contest_vote_submitted', '');
      }, 1000);*/
    },
    skip_vote: function skip_vote() {
      this.$emit('skip_vote', '');
    },
    view_all_contests: function view_all_contests() {
      // TOGGLE FORCE REFRESH TO TRUE
      this.$root.store.voting.change_force_unvoted_refresh(true);

      // GOTO VOTE PAGE
      this.goto_path('/vote/');
    },
    goto_path: function goto_path(path_name) {
      this.$root.store.goto_path(path_name);
    }
  },
  components: {
    ProgressBar: _progress_bar2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _card_generic = __webpack_require__(36);

var _card_generic2 = _interopRequireDefault(_card_generic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'progress_bar',
  props: ['current_count', 'max_count'],
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  computed: {
    progress_percent: function progress_percent() {
      var vm = this;

      if (vm.current_count == 0) {
        return 0;
      }
      if (vm.current_count == vm.max_count) {
        return 100;
      }

      var percent = parseInt(vm.current_count) / parseInt(vm.max_count);
      percent = percent * 100;
      percent = percent.toFixed(1);

      return percent;
    }
  },
  methods: {
    set_progress: function set_progress() {}
  },
  components: {
    CardGeneric: _card_generic2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'generic_share_button',
  props: ['button_text'],
  data: function data() {
    return {};
  },

  methods: {
    handle_button_click: function handle_button_click() {
      this.$emit('generic_share_clicked');
    }
  },
  components: {}
};

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _super_category_contest_list = __webpack_require__(119);

var _super_category_contest_list2 = _interopRequireDefault(_super_category_contest_list);

var _login_prompt = __webpack_require__(30);

var _login_prompt2 = _interopRequireDefault(_login_prompt);

var _trans_bounce_inL_outR = __webpack_require__(31);

var _trans_bounce_inL_outR2 = _interopRequireDefault(_trans_bounce_inL_outR);

var _vote_intro_event_not_started = __webpack_require__(66);

var _vote_intro_event_not_started2 = _interopRequireDefault(_vote_intro_event_not_started);

var _vote_intro_voting_period = __webpack_require__(67);

var _vote_intro_voting_period2 = _interopRequireDefault(_vote_intro_voting_period);

var _vote_intro_voting_intermission = __webpack_require__(68);

var _vote_intro_voting_intermission2 = _interopRequireDefault(_vote_intro_voting_intermission);

var _vote_intro_winners_period = __webpack_require__(69);

var _vote_intro_winners_period2 = _interopRequireDefault(_vote_intro_winners_period);

var _dev_period_simulator = __webpack_require__(50);

var _dev_period_simulator2 = _interopRequireDefault(_dev_period_simulator);

var _dcom_latest_stories_list = __webpack_require__(137);

var _dcom_latest_stories_list2 = _interopRequireDefault(_dcom_latest_stories_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'vote_landing_page',
  data: function data() {
    return {
      show_contest_index: 0,
      vote_complete: false,
      voting_period_started: false, // NEED TO MAKE THIS A CALCULATION FROM STORE
      nomination_period_started: true,
      env: this.$root.state.env
    };
  },
  created: function created() {
    // this.contest_list = this.$root.store.contests.get_master_contest_list();
  },
  mounted: function mounted() {
    document.dispatchEvent(new Event('prerender-trigger'));
    this.determine_chartbeat();
  },

  watch: {},
  computed: {
    instance_period: {
      get: function get() {
        return this.$root.store.instances.get_current_active_instance_period();
      }
    },
    is_logged_in: function is_logged_in() {
      return this.$root.store.session.check_login_status();
    },
    timezone_offset: function timezone_offset() {
      return this.$root.store.instances.get_current_timezone_offset();
    },
    vote_period_data: function vote_period_data() {
      return this.$root.store.instances.get_specific_instance_period('Voting Period');
    }
  },
  methods: {
    goto_path: function goto_path(path_name) {
      this.$root.store.goto_path(path_name);
    },
    run_chartbeat: function run_chartbeat() {
      window.updateChartbeat(document.title, window.location.pathname);
    },
    determine_chartbeat: function determine_chartbeat() {
      var vm = this;
      var page_title = document.title;

      if (page_title.indexOf(vm.$metaInfo.title) == 0) {
        vm.run_chartbeat();
      } else {
        setTimeout(function () {
          vm.determine_chartbeat();
        }, 500);
      }
    }
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Voting Information',
      titleTemplate: '%s | Best of Dayton 2019',
      meta: [{
        name: 'description',
        vmid: 'description',
        content: 'Find out how to vote for your favorite people, places, food, events, and more in the 2019 Best of Dayton contest.'
      }, {
        property: 'og:image',
        content: 'https://www.dayton.com/rf/image_large/Pub/p10/Dayton/2019/11/08/Images/DDC_BestofDayton_LeadRelatedObject_169.jpg'
      }]
    };
  },

  components: {
    SuperCategoryList: _super_category_contest_list2.default,
    LoginPrompt: _login_prompt2.default,
    TransBounce: _trans_bounce_inL_outR2.default,
    IntroNotStarted: _vote_intro_event_not_started2.default,
    IntroVotingPeriod: _vote_intro_voting_period2.default,
    IntroVotingIntermission: _vote_intro_voting_intermission2.default,
    IntroWinnersPeriod: _vote_intro_winners_period2.default,
    DevPeriodSimulator: _dev_period_simulator2.default,
    DcomLatestStoriesList: _dcom_latest_stories_list2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _countdown_timer = __webpack_require__(29);

var _countdown_timer2 = _interopRequireDefault(_countdown_timer);

var _fontawesomeSvgCore = __webpack_require__(5);

var _freeSolidSvgIcons = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faSearch); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'vote_intro_event_not_started',
  props: ['vote_start_date', 'tz_offset'],
  data: function data() {
    return {
      dcom_stories_uuid: '69728dd0-6965-11e6-ab50-bec7bcde827e'
    };
  },

  computed: {
    voting_start_date: function voting_start_date() {
      var vm = this;
      var start = '';

      if (vm.vote_start_date) {
        start = this.$root.store.manipulation_helpers.get_human_datetime(vm.vote_start_date, vm.tz_offset);
      }

      return start;
    }
  },
  methods: {},
  components: {
    Countdown: _countdown_timer2.default
  }
};

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _large_centered_button = __webpack_require__(46);

var _large_centered_button2 = _interopRequireDefault(_large_centered_button);

var _fontawesomeSvgCore = __webpack_require__(5);

var _freeSolidSvgIcons = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faSearch); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'vote_intro_nomination_period',
  props: ['is_logged_in'],
  data: function data() {
    return {
      show_voting_instructions: false
    };
  },

  methods: {
    goto_path: function goto_path(path_name) {
      this.$root.store.goto_path(path_name);
    },
    toggle_voting_instructions: function toggle_voting_instructions() {
      this.show_voting_instructions = !this.show_voting_instructions;
    }
  },
  computed: {},
  components: {
    LargeCenteredButton: _large_centered_button2.default
  }
};

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'vote_intro_voting_intermission',
  props: ['nom_start_date', 'tz_offset'],
  data: function data() {
    return {};
  },

  computed: {},
  methods: {},
  components: {}
};

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'vote_intro_winners_period',
  props: ['nom_start_date', 'tz_offset'],
  data: function data() {
    return {};
  },

  computed: {},
  methods: {},
  components: {}
};

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'dev_period_simulator',
  props: [],
  data: function data() {
    return {
      instance_period_options: [{
        text: 'Event not started',
        value: 'Event not started'
      }, {
        text: 'Nomination Period',
        value: 'Nomination Period'
      }, {
        text: 'Nomination Intermission',
        value: 'Nomination Intermission'
      }, {
        text: 'Voting Period',
        value: 'Voting Period'
      }, {
        text: 'Voting Intermission',
        value: 'Voting Intermission'
      }, {
        text: 'Winners Period',
        value: 'Winners Period'
      }, {
        text: 'Event has ended',
        value: 'Event has ended'
      }]
    };
  },

  computed: {
    instance_period: {
      get: function get() {
        return this.$root.store.instances.get_current_active_instance_period();
      },
      set: function set(value) {
        this.$root.store.instances.set_active_instance_period(value);
      }
    }
  },
  methods: {
    change_period: function change_period(new_period) {
      this.instance_period = new_period;
    }
  },
  components: {}
};

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vote_card = __webpack_require__(65);

var _vote_card2 = _interopRequireDefault(_vote_card);

var _login_prompt = __webpack_require__(30);

var _login_prompt2 = _interopRequireDefault(_login_prompt);

var _trans_zoom = __webpack_require__(49);

var _trans_zoom2 = _interopRequireDefault(_trans_zoom);

var _trans_bounce_inL_outR = __webpack_require__(31);

var _trans_bounce_inL_outR2 = _interopRequireDefault(_trans_bounce_inL_outR);

var _vote_intro_event_not_started = __webpack_require__(66);

var _vote_intro_event_not_started2 = _interopRequireDefault(_vote_intro_event_not_started);

var _vote_intro_voting_period = __webpack_require__(67);

var _vote_intro_voting_period2 = _interopRequireDefault(_vote_intro_voting_period);

var _vote_intro_voting_intermission = __webpack_require__(68);

var _vote_intro_voting_intermission2 = _interopRequireDefault(_vote_intro_voting_intermission);

var _vote_intro_winners_period = __webpack_require__(69);

var _vote_intro_winners_period2 = _interopRequireDefault(_vote_intro_winners_period);

var _dev_period_simulator = __webpack_require__(50);

var _dev_period_simulator2 = _interopRequireDefault(_dev_period_simulator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'voting_experience_page',
  data: function data() {
    return {
      vote_complete: false,
      voting_period_started: false, // NEED TO MAKE THIS A CALCULATION FROM STORE
      card_a_index: 0,
      card_b_index: 1,
      show_card_a: true,
      unvoted_contest_details: [],
      contest_preload_amount: 8,
      contest_preload_advance: 2,
      last_voted_on_index: 0,
      env: this.$root.state.env,
      init_vote_queue_started: false,
      finished_all_daily_votes: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    document.dispatchEvent(new Event('prerender-trigger'));

    if (this.user_publicid != 0 && this.instanceid != 0) {
      this.init_vote_queue();
    }
    // this.init_vote_queue();
    // this.$root.store.voting.get_contest_list_by_type(1, 'unvoted', this.user_publicid);
  },

  watch: {
    // WAIT FOR SUCCESSFUL LOGIN BEFORE DOING ANYTHING
    user_publicid: function user_publicid(new_val, old_val) {
      var vm = this;

      vm.check_for_prereqs(vm.init_vote_queue);
    },

    // WAIT FOR INSTANCEID BEFORE DOING ANYTHING
    instanceid: function instanceid(new_val, old_val) {
      var vm = this;

      vm.check_for_prereqs(vm.init_vote_queue);
    },

    // FORCE UNVOTED REFRESH IF TOGGLED TO TRUE
    force_unvoted_refresh: function force_unvoted_refresh(new_val, old_val) {
      if (new_val === true) {
        this.init_vote_queue();
        this.$root.store.voting.change_force_unvoted_refresh(false);
      }
    }
  },
  computed: {
    instance_period: {
      get: function get() {
        return this.$root.store.instances.get_current_active_instance_period();
      }
    },
    is_logged_in: function is_logged_in() {
      return this.$root.store.session.check_login_status();
    },
    master_contest_list: function master_contest_list() {
      return this.$root.store.contests.get_current_master_contest_list();
    },
    user_publicid: function user_publicid() {
      return this.$root.store.session.get_userid();
    },
    instanceid: function instanceid() {
      return this.$root.store.instances.get_current_instanceid();
    },
    unvoted_contest_list: function unvoted_contest_list() {
      return this.$root.store.voting.get_current_unvoted_contest_list();
    },
    timezone_offset: function timezone_offset() {
      return this.$root.store.instances.get_current_timezone_offset();
    },
    vote_period_data: function vote_period_data() {
      return this.$root.store.instances.get_specific_instance_period('Voting Period');
    },
    force_unvoted_refresh: function force_unvoted_refresh() {
      return this.$root.store.voting.get_current_force_unvoted_refresh();
    }
  },
  methods: {
    check_for_prereqs: function check_for_prereqs(callback) {
      var vm = this;

      if (typeof vm.instanceid != 'undefined' && vm.instanceid > 0 && typeof vm.user_publicid != 'undefined' && vm.user_publicid != 1 && vm.init_vote_queue_started == false) {
        // RUN CALLBACK
        callback();
      } else {
        // SET TIMEOUT TO RUN AGAIN
        setTimeout(function () {
          vm.check_for_prereqs(callback);
        }, 200);
      }
    },
    init_vote_queue: function init_vote_queue() {
      var vm = this;

      vm.init_vote_queue_started = true;
      vm.$set(vm, 'finished_all_daily_votes', false);

      // GET "UNVOTED" CONTEST IDs
      vm.$root.store.voting.get_contest_list_by_type(vm.instanceid, 'unvoted', vm.user_publicid).then(function (response) {
        // console.log('response.data.data.length: ', response.data.data.length);
        if (response.data.data.length == 0) {
          vm.$set(vm, 'finished_all_daily_votes', true);
        }

        // ADJUST LIST TO BE ARRAY OF VALUES INSTEAD OF OBJECTS
        var new_list = [];
        var old_list = response.data.data;
        for (var key in old_list) {
          new_list.push(old_list[key].instance_contestid);
        }
        // console.log('new_list: ', new_list);
        vm.$root.store.voting.store_unvoted_contest_list(new_list);
      }).then(function () {

        // RANDOMIZE LIST
        vm.randomize_unvoted_contest_list();

        // GET FIRST SET OF CONTEST DETAILS
        return vm.$root.store.contests.get_batch_contest_voting_details(vm.unvoted_contest_list.slice(0, vm.contest_preload_amount), vm.user_publicid);
      }).then(function (response) {
        if (response.data.data.length == 0) {
          vm.$set(vm, 'finished_all_daily_votes', true);
        }

        vm.$set(vm, 'unvoted_contest_details', response.data.data);
      });
    },
    randomize_unvoted_contest_list: function randomize_unvoted_contest_list() {
      this.unvoted_contest_list.sort(function () {
        return 0.5 - Math.random();
      });
    },
    randomize_unvoted_contest_details: function randomize_unvoted_contest_details() {
      this.unvoted_contest_details.sort(function () {
        return 0.5 - Math.random();
      });
    },
    get_batch_of_contest_details: function get_batch_of_contest_details() {
      var vm = this;
      var start_index = vm.last_voted_on_index + vm.contest_preload_advance + 1;
      var stop_index = start_index + vm.contest_preload_amount;
      var list = vm.unvoted_contest_list.slice(start_index, stop_index);

      vm.$root.store.contests.get_batch_contest_voting_details(list, vm.user_publicid).then(function (response) {
        if (typeof response.data.data != 'undefined' && response.data.data.length > 0) {
          var merged_details = vm.unvoted_contest_details;
          merged_details = merged_details.concat(response.data.data);

          vm.$set(vm, 'unvoted_contest_details', merged_details);
          // vm.randomize_unvoted_contest_details();
        }
      });
    },
    get_single_contest_details: function get_single_contest_details() {
      var vm = this;
      var start_index = vm.last_voted_on_index + vm.contest_preload_amount;
      var stop_index = start_index + 1;
      var list = vm.unvoted_contest_list.slice(start_index, stop_index);
      if (typeof list[0] != 'string') {
        list[0] = list[0].instance_contestid;
      }

      vm.$root.store.contests.get_batch_contest_voting_details(list, vm.user_publicid).then(function (response) {
        if (typeof response.data.data != 'undefined' && response.data.data.length > 0) {
          vm.unvoted_contest_details.push(response.data.data[0]);
        }
      });
    },
    change_vote_card: function change_vote_card() {
      var vm = this;

      // UPDATE "VOTE_COMPLETE" TO FALSE TO RESET
      vm.vote_complete = false;

      // UPDATE 
      if (vm.show_card_a == false) {
        // THIS IS CARD "B"
        vm.last_voted_on_index = vm.card_b_index;
        vm.card_b_index = vm.card_b_index + 2;
        vm.show_card_a = true;
      } else {
        // THIS IS CARD "A"
        vm.last_voted_on_index = vm.card_a_index;
        vm.card_a_index = vm.card_a_index + 2;
        vm.show_card_a = false;
      }

      // PRELOAD MORE CONTEST CONTESTS
      var loaded_contest_count = vm.unvoted_contest_details.length;
      var loaded_contest_count_last_index = loaded_contest_count - 1;
      var loaded_voted_diff = loaded_contest_count_last_index - vm.last_voted_on_index;
      /*console.log('loaded_contest_count: ', loaded_contest_count);
      console.log('loaded_contest_count_last_index: ', loaded_contest_count_last_index);
      console.log('vm.last_voted_on_index: ', vm.last_voted_on_index);
      console.log('loaded_voted_diff: ', loaded_voted_diff);*/
      if (loaded_voted_diff == vm.contest_preload_advance) {
        // console.log('NOW WANTING TO LOAD MORE CONTESTS: ', loaded_voted_diff);
        vm.get_batch_of_contest_details();
      } else if (loaded_voted_diff == 0) {
        vm.$set(vm, 'finished_all_daily_votes', true);
      }

      // vm.get_single_contest_details();

      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 1000);
    },
    record_vote: function record_vote(contestant) {
      var vm = this;

      // TRY TO SAVE VOTE
      vm.$root.store.voting.record_vote(vm.user_publicid, contestant.instance_contestid, contestant.finalistid).then(function (response) {

        // UPDATE "VOTE_COMPLETE" TO TRUE
        vm.vote_complete = true;

        // FIRE GA PAGEVIEW
        vm.$ga.page(vm.$router);
        /*vm.$ga.page({
          page: '',
          title: vm.$metaInfo.title,
          location: ''
        })*/

        // FIRE GA EVENT
        vm.$ga.event({
          eventCategory: 'Votes',
          eventAction: contestant.name,
          eventLabel: contestant.contest_label
        });

        // UPDATE "VOTED COUNT"
        var voted_count = vm.$root.store.voting.get_voted_count();
        voted_count++;
        vm.$root.store.voting.store_voted_count(voted_count);

        // ARTIFICIAL DELAY TO SHOW USER THAT VOTE WAS COMPLETE
        setTimeout(function () {
          vm.change_vote_card();
        }, 1500);
      });
    },
    goto_path: function goto_path(path_name) {
      this.$root.store.goto_path(path_name);
    }
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Vote Now',
      titleTemplate: '%s | Best of Dayton 2019',
      meta: [{
        name: 'description',
        vmid: 'description',
        content: 'Vote for your favorite local businesses, food, service providers, and more!'
      }, {
        property: 'og:title',
        content: 'Vote for Best of Dayton 2019'
      }, {
        property: 'og:site_name',
        content: 'Best of Dayton 2019'
      }, {
        property: 'og:type',
        content: 'website'
      }, {
        property: 'og:description',
        content: 'Vote for your favorite local businesses, food, service providers, and more!'
      }, {
        property: 'twitter:card',
        content: 'summary_large_image'
      }, {
        property: 'twitter:site',
        content: '@daytondotcom'
      }, {
        property: 'og:image',
        content: 'https://www.dayton.com/rf/image_large/Pub/Web/Dayton/Special%20Contents/Links/Images/DDC_BoD_VOTE_FBevent_1920x1080.jpg'
      }]
    };
  },

  components: {
    VoteCard: _vote_card2.default,
    LoginPrompt: _login_prompt2.default,
    TransZoom: _trans_zoom2.default,
    TransBounce: _trans_bounce_inL_outR2.default,
    IntroNotStarted: _vote_intro_event_not_started2.default,
    IntroVotingPeriod: _vote_intro_voting_period2.default,
    IntroVotingIntermission: _vote_intro_voting_intermission2.default,
    IntroWinnersPeriod: _vote_intro_winners_period2.default,
    DevPeriodSimulator: _dev_period_simulator2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vote_card = __webpack_require__(65);

var _vote_card2 = _interopRequireDefault(_vote_card);

var _login_prompt = __webpack_require__(30);

var _login_prompt2 = _interopRequireDefault(_login_prompt);

var _sample_contestant_list = __webpack_require__(47);

var _sample_contestant_list2 = _interopRequireDefault(_sample_contestant_list);

var _trans_zoom = __webpack_require__(49);

var _trans_zoom2 = _interopRequireDefault(_trans_zoom);

var _trans_bounce_inL_outR = __webpack_require__(31);

var _trans_bounce_inL_outR2 = _interopRequireDefault(_trans_bounce_inL_outR);

var _vote_intro_event_not_started = __webpack_require__(66);

var _vote_intro_event_not_started2 = _interopRequireDefault(_vote_intro_event_not_started);

var _vote_intro_voting_period = __webpack_require__(67);

var _vote_intro_voting_period2 = _interopRequireDefault(_vote_intro_voting_period);

var _vote_intro_voting_intermission = __webpack_require__(68);

var _vote_intro_voting_intermission2 = _interopRequireDefault(_vote_intro_voting_intermission);

var _vote_intro_winners_period = __webpack_require__(69);

var _vote_intro_winners_period2 = _interopRequireDefault(_vote_intro_winners_period);

var _dev_period_simulator = __webpack_require__(50);

var _dev_period_simulator2 = _interopRequireDefault(_dev_period_simulator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'voting_experience_single_page',
  data: function data() {
    return {
      vote_complete: false,
      voting_period_started: false, // NEED TO MAKE THIS A CALCULATION FROM STORE
      card_a_index: 0,
      show_card_a: true,
      single_contest_details: [],
      env: this.$root.state.env,
      got_single_contest_details: false,
      meta_title: 'Voting',
      meta_image: 'https://www.dayton.com/rf/image_large/Pub/Web/Dayton/Special%20Contents/Links/Images/DDC_BoD_VOTE_FBevent_1920x1080.jpg',
      meta_data: ''
    };
  },
  mounted: function mounted() {
    // document.dispatchEvent(new Event('prerender-trigger'));

    if (this.user_publicid > 1) {
      this.reset_contest();
      this.check_for_prereqs(this.get_single_contest_details);
    } else {
      // console.log('no userid: ');
      this.reset_contest();
      this.get_single_contest_details_no_user();
    }
    // this.init_vote_queue();
    // this.$root.store.voting.get_contest_list_by_type(1, 'unvoted', this.user_publicid);
  },

  watch: {
    $route: function $route(to, from) {
      // console.log('seeing route change: ');
      if (this.meta_data == '') {
        // console.log('updating meta from route change: ');
        this.update_metadata(this.single_contest_details);
      }
      this.reset_contest();
      this.check_for_prereqs(this.get_single_contest_details);
    },


    // WATCH CONTEST DETAILS FOR PRE-RENDER/META
    single_contest_details: function single_contest_details(new_val, old_val) {
      var vm = this;

      // console.log('updating meta from contest change: ');
      if (new_val.length > 0) {
        // console.log('updating meta from contest change 2: ');
        vm.update_metadata(new_val);
      }
    },

    // WAIT FOR SUCCESSFUL LOGIN BEFORE DOING ANYTHING
    user_publicid: function user_publicid(new_val, old_val) {
      var vm = this;

      vm.check_for_prereqs(vm.get_single_contest_details);
    },

    // CHANGE CONTEST DETAILS ON NEW ROUTE
    instance_contestid: function instance_contestid() {
      var vm = this;

      vm.check_for_prereqs(vm.get_single_contest_details);
    }
  },
  computed: {
    instance_period: {
      get: function get() {
        return this.$root.store.instances.get_current_active_instance_period();
      }
    },
    is_logged_in: function is_logged_in() {
      return this.$root.store.session.check_login_status();
    },
    user_publicid: function user_publicid() {
      return this.$root.store.session.get_userid();
    },
    instance_contestid: function instance_contestid() {
      return this.$route.params.id;
    },
    timezone_offset: function timezone_offset() {
      return this.$root.store.instances.get_current_timezone_offset();
    },
    vote_period_data: function vote_period_data() {
      return this.$root.store.instances.get_specific_instance_period('Voting Period');
    }
  },
  methods: {
    update_metadata: function update_metadata(contest_details) {
      var vm = this;
      // console.log('contest_details: ', contest_details);
      var details = contest_details[0];

      if (details) {
        // console.log('details: ', details);
        if (details.label) {
          vm.meta_title = details.label;
          vm.determine_chartbeat();
        }

        if (details.lead_image) {
          vm.meta_image = details.lead_image;
        }

        vm.meta_data = vm.details;

        setTimeout(function () {
          // console.log('running prerender trigger: ');
          document.dispatchEvent(new Event('prerender-trigger'));
        }, 500);
      } else {
        // console.log('details not defined: ');
      }
    },
    check_for_prereqs: function check_for_prereqs(callback) {
      var vm = this;

      if (typeof vm.instance_contestid != 'undefined' && vm.instance_contestid > 0 && typeof vm.user_publicid != 'undefined' && vm.user_publicid > 1 && vm.got_single_contest_details == false) {
        // RUN CALLBACK
        callback();
      } else {
        // SET TIMEOUT TO RUN AGAIN
        setTimeout(function () {
          vm.check_for_prereqs(callback);
        }, 200);
      }
    },
    reset_contest: function reset_contest() {
      this.single_contest_details = [];
      this.got_single_contest_details = false;
      this.vote_complete = false;
    },
    get_single_contest_details: function get_single_contest_details() {
      var vm = this;
      vm.got_single_contest_details = true;

      var list = [];
      list.push(vm.instance_contestid);
      if (typeof list[0] != 'string') {
        list[0] = list[0].instance_contestid;
      }

      vm.$root.store.contests.get_batch_contest_voting_details(list, vm.user_publicid).then(function (response) {
        if (typeof response.data.data != 'undefined' && response.data.data.length > 0) {
          vm.single_contest_details[0] = response.data.data[0];
          vm.$set(vm, 'single_contest_details', [response.data.data[0]]);
        }
      });
    },
    get_single_contest_details_no_user: function get_single_contest_details_no_user() {
      var vm = this;
      // vm.got_single_contest_details = true;

      var list = [];
      list.push(vm.instance_contestid);
      if (typeof list[0] != 'string') {
        list[0] = list[0].instance_contestid;
      }

      vm.$root.store.contests.get_batch_contest_voting_details(list, 0).then(function (response) {
        if (typeof response.data.data != 'undefined' && response.data.data.length > 0) {
          vm.single_contest_details[0] = response.data.data[0];
          vm.$set(vm, 'single_contest_details', [response.data.data[0]]);
        }
      });
    },
    record_vote: function record_vote(contestant) {
      var vm = this;

      // TRY TO SAVE VOTE
      vm.$root.store.voting.record_vote(vm.user_publicid, contestant.instance_contestid, contestant.finalistid).then(function (response) {

        // UPDATE "VOTE_COMPLETE" TO TRUE
        vm.vote_complete = true;

        // FIRE GA PAGEVIEW
        vm.$ga.page(vm.$router);
        /*vm.$ga.page({
          page: '',
          title: vm.$metaInfo.title,
          location: ''
        })*/

        // FIRE GA EVENT
        vm.$ga.event({
          eventCategory: 'Votes',
          eventAction: contestant.name,
          eventLabel: contestant.contest_label
        });

        // UPDATE "VOTED COUNT"
        var voted_count = vm.$root.store.voting.get_voted_count();
        voted_count++;
        vm.$root.store.voting.store_voted_count(voted_count);

        // ARTIFICIAL DELAY TO SHOW USER THAT VOTE WAS COMPLETE
        setTimeout(function () {
          vm.$root.store.voting.change_force_unvoted_refresh(true);
          vm.goto_path('/votenow');
        }, 1500);
      });
    },
    run_chartbeat: function run_chartbeat() {
      window.updateChartbeat(document.title, window.location.pathname);
    },
    determine_chartbeat: function determine_chartbeat() {
      var vm = this;
      var page_title = document.title;

      if (page_title.indexOf(vm.$metaInfo.title) == 0) {
        vm.run_chartbeat();
      } else {
        setTimeout(function () {
          vm.determine_chartbeat();
        }, 500);
      }
    },
    goto_path: function goto_path(path_name) {
      this.$root.store.goto_path(path_name);
    }
  },
  metaInfo: function metaInfo() {
    return {
      title: this.meta_title,
      titleTemplate: '%s | Vote Now for Best of Dayton 2019',
      meta: [{
        name: 'description',
        vmid: 'description',
        content: 'Vote for "' + this.meta_title + '" in the Dayton.com 2019 Best of Dayton contest'
      }, {
        property: 'og:title',
        content: 'Vote for "' + this.meta_title + '" in the Dayton.com 2019 Best of Dayton contest'
      }, {
        property: 'og:site_name',
        content: 'Best of Dayton 2019'
      }, {
        property: 'og:type',
        content: 'website'
      }, {
        property: 'og:description',
        content: 'Vote for your favorite local businesses, food, service providers, and more!'
      }, {
        property: 'twitter:card',
        content: 'summary_large_image'
      }, {
        property: 'twitter:site',
        content: '@daytondotcom'
      }, {
        property: 'og:image',
        content: this.meta_image
      }]
    };
  },

  components: {
    VoteCard: _vote_card2.default,
    LoginPrompt: _login_prompt2.default,
    TransZoom: _trans_zoom2.default,
    TransBounce: _trans_bounce_inL_outR2.default,
    IntroNotStarted: _vote_intro_event_not_started2.default,
    IntroVotingPeriod: _vote_intro_voting_period2.default,
    IntroVotingIntermission: _vote_intro_voting_intermission2.default,
    IntroWinnersPeriod: _vote_intro_winners_period2.default,
    DevPeriodSimulator: _dev_period_simulator2.default
  }
};

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'PageNotFound',
  data: function data() {
    return {
      contest_list: contest_list
    };
  }
};

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueBootstrapTypeahead = __webpack_require__(62);

var _vueBootstrapTypeahead2 = _interopRequireDefault(_vueBootstrapTypeahead);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'search_box',
  props: ['contest_list'],
  data: function data() {
    return {
      contest_nomination_text: '',
      suggestions: [{
        id: 1,
        nomination_text: 'Test 1'
      }, {
        id: 2,
        nomination_text: 'Test 2'
      }]
    };
  },

  computed: {},
  methods: {
    emit_hit: function emit_hit(hit) {
      var vm = this;
      vm.$emit('search_hit', hit);

      // FIRE GA EVENT
      vm.$ga.event({
        eventCategory: 'Searches',
        eventAction: hit.label,
        eventLabel: 'Search String'
      });
    }
  },
  components: {
    VueBootstrapTypeahead: _vueBootstrapTypeahead2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _logout_button = __webpack_require__(387);

var _logout_button2 = _interopRequireDefault(_logout_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// require('@/vendor/chartbeat_tracking.js');

exports.default = {
  name: 'AppFooter',
  data: function data() {
    return {
      full_year: this.get_copyright_year(),
      footer_link_suffix: '?source=bod_2018',
      footer_links: [{
        label: 'Contest Guidelines',
        link: 'https://www.dayton.com/marketing/dayton-com-best-2018-contest-guidelines/IZSydcw1ws3deMJ790SJrM/'
      }, {
        label: 'Visitor Agreement',
        link: 'https://www.dayton.com/visitor_agreement/'
      }, {
        label: 'Privacy Policy',
        link: 'https://www.dayton.com/privacy_policy/'
      }, {
        label: 'Contact',
        link: 'https://www.dayton.com/contact-us/'
      }, {
        label: 'Mobile Apps',
        link: 'https://projects.coxmediagroupohio.com/products/mobile-products-list/'
      }]
    };
  },
  created: function created() {
    /*let cb = document.createElement('script');
    cb.src = '@/vendor/chartbeat_tracking.js';
    document.getElementsByTagName('head')[0].appendChild(cb);*/
  },

  computed: {
    is_logged_in: function is_logged_in() {
      return this.$root.store.session.check_login_status();
    }
  },
  methods: {
    get_copyright_year: function get_copyright_year() {
      var year = new Date();
      return year.getFullYear();
    }
  },
  components: {
    LogoutButton: _logout_button2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'logout_button',
  props: ['custom_class'],
  data: function data() {
    return {};
  },

  methods: {
    log_out: function log_out(e) {
      e.preventDefault();

      this.$root.store.session.log_out();
    }
  },
  components: {}
};

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nav_mobile_item = __webpack_require__(393);

var _nav_mobile_item2 = _interopRequireDefault(_nav_mobile_item);

var _fontawesomeSvgCore = __webpack_require__(5);

var _freeSolidSvgIcons = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faTimes); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'nav_mobile',
  props: [],
  data: function data() {
    return {};
  },

  computed: {
    show_mobile_nav: function show_mobile_nav() {
      return this.$root.store.nav.get_mobile_nav_visibility();
    },
    main_nav_items: function main_nav_items() {
      return this.$root.store.nav.get_main_nav();
    }
  },
  methods: {
    toggle_mobile_nav: function toggle_mobile_nav() {
      // this.show_mobile_nav = !this.show_mobile_nav;
      this.$root.store.nav.toggle_mobile_nav();
    },
    request_close_nav: function request_close_nav() {
      this.$emit('request_close_nav', '');
    }
  },
  components: {
    NavMobileItem: _nav_mobile_item2.default
  }
};

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _router = __webpack_require__(28);

var _router2 = _interopRequireDefault(_router);

var _fontawesomeSvgCore = __webpack_require__(5);

var _freeSolidSvgIcons = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faHome, _freeSolidSvgIcons.faCheckDouble, _freeSolidSvgIcons.faClipboardCheck); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'nav_mobile_item',
  props: ['label', 'icon', 'path_name'],
  data: function data() {
    return {};
  },

  methods: {
    close_mobile_nav: function close_mobile_nav() {
      this.$root.store.nav.close_mobile_nav();
    },
    goto_path: function goto_path(path_name) {
      this.$root.store.goto_path(path_name);

      this.close_mobile_nav();
    }
  },
  components: {}
};

/***/ }),
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _router = __webpack_require__(28);

var _router2 = _interopRequireDefault(_router);

var _http_services = __webpack_require__(19);

var _http_services2 = _interopRequireDefault(_http_services);

var _mod_contests = __webpack_require__(515);

var _mod_contests2 = _interopRequireDefault(_mod_contests);

var _mod_voting = __webpack_require__(516);

var _mod_voting2 = _interopRequireDefault(_mod_voting);

var _mod_nominations = __webpack_require__(517);

var _mod_nominations2 = _interopRequireDefault(_mod_nominations);

var _mod_lists = __webpack_require__(527);

var _mod_lists2 = _interopRequireDefault(_mod_lists);

var _mod_session = __webpack_require__(530);

var _mod_session2 = _interopRequireDefault(_mod_session);

var _mod_navigation = __webpack_require__(561);

var _mod_navigation2 = _interopRequireDefault(_mod_navigation);

var _mod_categories = __webpack_require__(562);

var _mod_categories2 = _interopRequireDefault(_mod_categories);

var _mod_instances = __webpack_require__(563);

var _mod_instances2 = _interopRequireDefault(_mod_instances);

var _mod_manipulation_helpers = __webpack_require__(96);

var _mod_manipulation_helpers2 = _interopRequireDefault(_mod_manipulation_helpers);

var _mod_storage = __webpack_require__(91);

var _mod_storage2 = _interopRequireDefault(_mod_storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	debug: true,
	state: {
		clientid: 'FA721ACE33381B9F3B1B881B9B24370D'
	},

	get_current_clientid: function get_current_clientid() {
		return this.state.clientid;
	},

	goto_path: function goto_path(path_name, param) {
		var push_path = path_name;

		// APPEND TRAILING SLASH
		if (push_path.slice(-1) != '/') {
			push_path += '/';
		}

		// IF PARAM SET, APPEND IT
		if (param) {
			push_path += param + '/';
		}

		// console.log('push_path: ', push_path);

		_router2.default.push({
			path: push_path
		});
	},

	nominations: _mod_nominations2.default,
	contests: _mod_contests2.default,
	voting: _mod_voting2.default,
	lists: _mod_lists2.default,
	session: _mod_session2.default,
	nav: _mod_navigation2.default,
	categories: _mod_categories2.default,
	instances: _mod_instances2.default,
	manipulation_helpers: _mod_manipulation_helpers2.default,
	storage: _mod_storage2.default
};

/***/ }),
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _vue2TouchEvents = __webpack_require__(217);

var _vue2TouchEvents2 = _interopRequireDefault(_vue2TouchEvents);

var _App = __webpack_require__(218);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(28);

var _router2 = _interopRequireDefault(_router);

var _bootstrapVue = __webpack_require__(398);

var _bootstrapVue2 = _interopRequireDefault(_bootstrapVue);

var _vueFontawesome = __webpack_require__(507);

var _store = __webpack_require__(193);

var _store2 = _interopRequireDefault(_store);

var _vueAnalytics = __webpack_require__(564);

var _vueAnalytics2 = _interopRequireDefault(_vueAnalytics);

var _vueMq = __webpack_require__(565);

var _vueMq2 = _interopRequireDefault(_vueMq);

var _vueForage = __webpack_require__(209);

var _vueForage2 = _interopRequireDefault(_vueForage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
var checkIfProd = "production" === 'production';

// console.log('process.env.NODE_ENV: ', process.env.NODE_ENV);
// console.log('checkIfProd: ', checkIfProd);

// import DoubleClick from 'vue-doubleclick';
_vue2.default.component('font-awesome-icon', _vueFontawesome.FontAwesomeIcon);
_vue2.default.component('font-awesome-layers', _vueFontawesome.FontAwesomeLayers);
_vue2.default.component('font-awesome-layers-text', _vueFontawesome.FontAwesomeLayersText);

_vue2.default.config.productionTip = false;

_vue2.default.use(_bootstrapVue2.default);

_vue2.default.use(_vue2TouchEvents2.default);

_vue2.default.use(_vueMq2.default, {
	breakpoints: {
		mobile: 450,
		tablet: 900,
		laptop: 1250,
		desktop: Infinity
	}
});

// Vue.use(vf);

/*
REMEMBER TO DISABLE DEBUG AND ENABLE SENDHITTASK FOR PROD
*/
_vue2.default.use(_vueAnalytics2.default, {
	id: 'UA-57696902-6', // CMGO GA ACCOUNT
	// id: 'UA-12007193-41', // CMG GA ACCOUNT
	// id: ['UA-57696902-6','UA-12007193-41'], // COMBINED CMGO AND CMG ACCOUNT CALLS
	router: _router2.default,
	autoTracking: {
		screenview: false
	},
	debug: {
		enabled: false,
		trace: false,
		sendHitTask: checkIfProd
	}
});

/** CONFIGURATION START **/
window._sf_async_config = {};
window._sf_async_config.uid = 31585;
window._sf_async_config.domain = 'dayton.com';
window._sf_async_config.useCanonical = true;
// _sf_async_config.sections = 'section1,section2 ';
// _sf_async_config.authors = 'author1,author2 ';
/** CONFIGURATION END **/

window.removeChartbeat = function () {
	if (checkIfProd) {
		if (document.getElementById('cb_script')) {
			var cb_script = document.getElementById('cb_script');
			cb_script.parentNode.removeChild(cb_script);
		}
	}
};
window.updateChartbeat = function (page_title, path_name) {
	if (checkIfProd) {
		if (typeof window.pSUPERFLY == 'undefined') {
			setTimeout(function () {
				window.updateChartbeat(page_title, path_name);
			}, 3000);
		} else {
			window.pSUPERFLY.virtualPage({
				path: path_name,
				title: page_title
			});
		}
	}
};
window.loadChartbeat = function () {
	if (checkIfProd) {
		window._sf_endpt = new Date().getTime();

		var e = document.createElement('script');
		e.setAttribute('language', 'javascript');
		e.setAttribute('type', 'text/javascript');
		e.setAttribute('id', 'cb_script');
		e.setAttribute('src', '//static.chartbeat.com/js/chartbeat_video.js');
		document.body.appendChild(e);
	}
};
if (checkIfProd) {
	var oldonload = window.onload;
	window.onload = typeof window.onload != 'function' ? loadChartbeat : function () {
		oldonload();
		loadChartbeat();
	};
}

/*
COMMENTING OUT AD UNIT SETUP
*/
/*let mappings = {

	block: [
		{ window: [0, 0], sizes: [[300, 250]] }, // MOBILE
		{ window: [420, 0], sizes: [[300, 250]] }, // TABLET
		{ window: [480, 0], sizes: [[300, 250]] }, // TABLET
		{ window: [768, 0], sizes: [[300, 250]] }, // LAPTOP
		{ window: [1024, 0], sizes: [[300, 250]] }, // DESKTOP
		{ window: [1280, 0], sizes: [[300, 250]] }, // DESKTOP BIG
	],

	rectangle: [
        { window: [0, 0], sizes: [[320, 50]] }, // MOBILE
		{ window: [420, 0], sizes: [[320, 50]] }, // TABLET
		{ window: [480, 0], sizes: [[320, 50]] }, // TABLET
		{ window: [768, 0], sizes: [[320, 50]] }, // LAPTOP
		{ window: [1024, 0], sizes: [[320, 50]] }, // DESKTOP
		{ window: [1280, 0], sizes: [[320, 50]] }, // DESKTOP BIG
    ],

	banner: [
		{ window: [0, 0], sizes: [[320, 50]] }, // MOBILE
		{ window: [420, 0], sizes: [[320, 50]] }, // TABLET
		{ window: [480, 0], sizes: [[320, 50]] }, // TABLET
		{ window: [768, 0], sizes: [[728, 90]] }, // LAPTOP
		{ window: [1024, 0], sizes: [[728, 90]] }, // DESKTOP
		{ window: [1280, 0], sizes: [[728, 90]] }, // DESKTOP BIG
	]
};

let sizes = {
	block: [[300, 250]]
}

Vue.use(DoubleClick, {
    id: '12523293',
    mappings,
    sizes
});*/
/*
END AD UNIT SETUP
*/

/* eslint-disable no-new */
var root = new _vue2.default({
	el: '#app',
	router: _router2.default,
	template: '<App/>',
	data: {
		store: _store2.default,
		state: {
			env: "production"
		}
	},
	components: {
		App: _App2.default
	}
});

/***/ }),
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e43c572_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(397);
function injectStyle (ssrContext) {
  __webpack_require__(219)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e43c572_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 220 */,
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fdc496e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__(384);
function injectStyle (ssrContext) {
  __webpack_require__(222)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fdc496e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */,
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Homepage_vue__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Homepage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Homepage_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Homepage_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Homepage_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_969d3614_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Homepage_vue__ = __webpack_require__(240);
function injectStyle (ssrContext) {
  __webpack_require__(225)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Homepage_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_969d3614_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Homepage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card_generic",class:{ sm: _vm.size == 'sm' }},[(_vm.title)?_c('h4',{staticClass:"card_title",class:_vm.title_class,domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.subtitle)?_c('p',{staticClass:"card_subtitle"},[_vm._v("\n    "+_vm._s(_vm.subtitle)+"\n  ")]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_story_list_item_vue__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_story_list_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_story_list_item_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_story_list_item_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_story_list_item_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57283ce3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_story_list_item_vue__ = __webpack_require__(231);
function injectStyle (ssrContext) {
  __webpack_require__(230)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_story_list_item_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57283ce3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_story_list_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"story_list_item_container"},[_c('div',{staticClass:"story_list_item",class:_vm.$mq,on:{"click":function($event){_vm.open_story_url(_vm.link)}}},[_c('div',{staticClass:"story_item_image",style:({'background-image': 'url(\'' + _vm.master_image_url + '\')'})}),_vm._v(" "),_c('span',{staticClass:"story_item_title"},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"story_list_container"},[(_vm.list_data)?_c('card-generic',{attrs:{"title":"<a href='https://www.dayton.com/' target='_blank'>> More from Dayton.com</a>","title_class":"orange"}},[_c('div',{staticClass:"row"},_vm._l((_vm.list_data.list_items),function(item,index){return _c('div',{key:("list_" + index),staticClass:"col-6"},[_c('story-list-item',_vm._b({},'story-list-item',item,false))],1)}))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"start_voting_button_container"},[_c('button',{directives:[{name:"touch",rawName:"v-touch:tap",value:(_vm.announce_button_clicked),expression:"announce_button_clicked",arg:"tap"}],staticClass:"btn btn-primary",class:_vm.width,attrs:{"type":"button"}},[_c('span',{staticClass:"btn_icon"},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}})],1),_vm._v(_vm._s(_vm.button_text)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_countdown_to_next_event_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_countdown_to_next_event_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_countdown_to_next_event_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_countdown_to_next_event_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_countdown_to_next_event_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21c7e7e2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_countdown_to_next_event_vue__ = __webpack_require__(239);
function injectStyle (ssrContext) {
  __webpack_require__(236)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_countdown_to_next_event_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21c7e7e2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_countdown_to_next_event_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countdown_timer_container",class:_vm.$mq},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[(_vm.show_countdown)?_c('card-generic',{attrs:{"title":_vm.title,"title_class":"teal"}},[_c('div',{staticClass:"countdown_cell_container"},[_c('div',{staticClass:"countdown_cell"},[_c('span',{staticClass:"countdown_val"},[_vm._v(_vm._s(_vm.days))]),_vm._v(" "),_c('span',{staticClass:"countdown_label"},[_vm._v("Days")])]),_vm._v(" "),_c('div',{staticClass:"countdown_cell"},[_c('span',{staticClass:"countdown_val"},[_vm._v(_vm._s(_vm.hours))]),_vm._v(" "),_c('span',{staticClass:"countdown_label"},[_vm._v("Hours")])]),_vm._v(" "),_c('div',{staticClass:"countdown_cell"},[_c('span',{staticClass:"countdown_val"},[_vm._v(_vm._s(_vm.minutes))]),_vm._v(" "),_c('span',{staticClass:"countdown_label"},[_vm._v("Minutes")])]),_vm._v(" "),_c('div',{staticClass:"countdown_cell"},[_c('span',{staticClass:"countdown_val"},[_vm._v(_vm._s(_vm.seconds))]),_vm._v(" "),_c('span',{staticClass:"countdown_label"},[_vm._v("Seconds")])])])]):_vm._e()],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countdown_to_next_event_container"},[(_vm.event_data_needed != '' && _vm.event_data_needed != 'Event has ended')?_c('countdown',{attrs:{"target_date":_vm.countdown_date,"title":_vm.countdown_title}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"homepage"}},[_c('h3',{staticClass:"section_title"},[_vm._v("Welcome!")]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-lg-10"},[_c('div',{staticClass:"opening_text"},[_c('h5',{staticClass:"text-center"},[_vm._v("The best of What to Do, What to Love, and What to Know in Dayton")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h4',[_vm._v("Vote for all your favorite businesses, local professionals, food, and more!")]),_vm._v(" "),(_vm.editors_note_active)?_c('div',{staticStyle:{"background":"yellow","padding":"1em","margin":"1em 0"}},[_c('h3',[_vm._v("EDITOR'S NOTE")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',[_vm._v("\n            We launched voting for Dayton.com's Best of 2018 contest on Wednesday, Dec. 5., and within hours, our servers were overwhelmed by the volume of votes. Many users experienced difficulty casting votes or being able to progress from one category to another.")]),_vm._v(" "),_c('p',[_vm._v("\n            We've been working around the clock to resolve this issue and have made some upgrades to help improve the voting experience.")]),_vm._v(" "),_c('p',[_vm._v("\n            The contest has resumed, and we are extending the voting period through Dec. 26 to give everyone a few extra days of voting.")]),_vm._v(" "),_c('p',[_vm._v("\n            Any votes cast on Dec. 5 were recorded and will still count toward the total. ")]),_vm._v(" "),_c('p',[_vm._v("\n            Happy voting!")]),_vm._v(" "),_vm._m(2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-12 order-first col-lg-6 order-lg-last"},[_c('div',{staticClass:"responsive_container_zzz",class:_vm.$mq},[_c('countdown-to-next-event')],1),_vm._v(" "),(_vm.instance_period == 'Nomination Period')?_c('div',{staticClass:"responsive_container_zzz",class:_vm.$mq},[_c('large-centered-button',{attrs:{"button_text":"Nominate Now","icon":"clipboard-check","width":"full"},on:{"button_clicked":function($event){_vm.goto_path('nominate')}}})],1):_vm._e(),_vm._v(" "),(_vm.instance_period == 'Voting Period')?_c('div',{staticClass:"responsive_container_zzz",class:_vm.$mq},[_c('large-centered-button',{attrs:{"button_text":"Start Voting","icon":"check-double","width":"full"},on:{"button_clicked":function($event){_vm.goto_path('vote')}}})],1):_vm._e()])]),_vm._v(" "),_c('h4',[_vm._v("\n            Also check out some of our other great content from Dayton.com:\n          ")])]),_vm._v(" "),_c('story-list',{attrs:{"cms_list_id":"0036de38-28b8-11e9-bab0-a7d3b5289767"}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lead_image"},[_c('img',{attrs:{"src":"https://www.dayton.com/rf/image_large/Pub/p11/Dayton/2020/01/06/Images/DDC_VoteNOW_LeadRelatedObject_169.jpg","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n              Best of Dayton "),_c('strong',[_vm._v("VOTING is back!")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n            Please contact us at "),_c('a',{attrs:{"href":"mailto:contact@dayton.com"}},[_vm._v("contact@dayton.com")]),_vm._v(" if you have any questions or issues.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 order-last col-lg-6 order-lg-first"},[_c('p',[_vm._v("Here's how you can participate:")]),_vm._v(" "),_c('ol',[_c('li',[_c('strong',[_vm._v("Nominate")]),_vm._v(" your favorite businesses, professionals, service providers, food, and more during the nomination period.")]),_vm._v(" "),_c('li',[_vm._v("When voting starts... "),_c('strong',[_vm._v("VOTE!")]),_vm._v(" Come back and vote every day and tell everyone you know to do the same. All votes matter!")]),_vm._v(" "),_c('li',[_vm._v("There are "),_c('strong',[_vm._v("over 150 categories")]),_vm._v(" this year, so remember to check out several to support everyone you might want to vote for.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContestListPage_vue__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContestListPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContestListPage_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContestListPage_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContestListPage_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e30e8c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContestListPage_vue__ = __webpack_require__(280);
function injectStyle (ssrContext) {
  __webpack_require__(242)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContestListPage_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e30e8c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContestListPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contest_list_vue__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contest_list_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contest_list_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contest_list_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contest_list_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_069a493c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contest_list_vue__ = __webpack_require__(279);
function injectStyle (ssrContext) {
  __webpack_require__(244)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contest_list_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_069a493c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contest_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */
/***/ (function(module, exports) {

module.exports = {"contests":[{"id":1,"label":"Best Local Donut Shop","image":"https://www.publicdomainpictures.net/pictures/270000/nahled/donuts-15367481797jY.jpg","category":"food","icon":"utensils","visible":false},{"id":2,"label":"Best Local Pizza Place","image":"https://get.pxhere.com/photo/dish-food-cuisine-pizza-cheese-salami-pepperoni-cool-image-cool-photo-junk-food-italian-food-stone-oven-pizza-cheese-european-food-sicilian-pizza-flatbread-pizza-stone-stone-oven-pizza-california-style-pizza-1411428.jpg","category":"food","icon":"utensils","visible":false},{"id":3,"label":"Best Local Laser Tag","image":"http://c1.staticflickr.com/8/7312/8734078597_4395c0dd15_b.jpg","category":"activities","icon":"smile-beam","visible":false},{"id":4,"label":"Best Local Jeweler","image":"https://c1.staticflickr.com/6/5789/21075107410_4b67f914fb_b.jpg","category":"shopping","icon":"shopping-cart","visible":false},{"id":5,"label":"Best Asian Restaurant","image":"https://www.maxpixel.net/static/photo/2x/Cooking-Dimsum-Asian-Food-Steamed-Cuisine-Soy-2090944.jpg","category":"food","icon":"utensils","visible":false},{"id":6,"label":"Best Patio","image":"https://upload.wikimedia.org/wikipedia/commons/thumb/7/76/Eganville-Friscoes-Restaurant-Deck.jpg/1024px-Eganville-Friscoes-Restaurant-Deck.jpg","category":"places","icon":"smile-beam","visible":false},{"id":7,"label":"Best View","image":"https://dun6irwnoloqf.cloudfront.net/images/venues/6003/Dayton-Racquet-Club-Wedding-Dayton-OH-4_main.1441863854.jpg","category":"places","icon":"shopping-cart","visible":false}]}

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contest_list_box_vue__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contest_list_box_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contest_list_box_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contest_list_box_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contest_list_box_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49aa4eb5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contest_list_box_vue__ = __webpack_require__(278);
function injectStyle (ssrContext) {
  __webpack_require__(265)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contest_list_box_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49aa4eb5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contest_list_box_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 265 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 266 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contest_banner_container",class:[_vm.banner_type, _vm.$mq]},[_c('div',{staticClass:"contest_banner_cover"}),_vm._v(" "),_c('div',{staticClass:"contest_banner"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row",class:_vm.banner_type},[_c('div',{staticClass:"col-2"},[(_vm.icon)?_c('span',{staticClass:"contest_category_icon"},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('div',{staticClass:"contestant_name"},[_vm._v(_vm._s(_vm.label))])]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('div',{staticClass:"contest_expanded_icon"},[(!_vm.is_expanded)?_c('font-awesome-icon',{attrs:{"icon":"caret-right"}}):_c('font-awesome-icon',{attrs:{"icon":"caret-down"}})],1)])])])]),_vm._v(" "),(_vm.is_expanded && _vm.banner_type == 'contest' && _vm.contest.lead_image)?_c('div',{staticClass:"contest_image",style:({backgroundImage: 'url(\'' + _vm.resize_cms_image(_vm.contest.lead_image) +  '\')'})}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VoteCard_vue__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VoteCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VoteCard_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VoteCard_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VoteCard_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59f0ccc0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VoteCard_vue__ = __webpack_require__(270);
function injectStyle (ssrContext) {
  __webpack_require__(269)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VoteCard_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59f0ccc0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VoteCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.vote_visible)?_c('div',{staticClass:"vote_card"},[_c('div',{staticClass:"contest_image",style:({backgroundImage: ("url(" + (__webpack_require__(271)("./" + (_vm.contest.image))) + ")")})}),_vm._v(" "),(!_vm.contestant_images)?_c('contestant-list-with-out-images',{attrs:{"contestants":_vm.contestants}}):_vm._e(),_vm._v(" "),(_vm.contestant_images)?_c('contestant-list-with-images',{attrs:{"contestants":_vm.contestants,"contestant_images":_vm.contestant_images}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./BoD_Badge_Logo.png": 272,
	"./DDC_BestofDayton_19_937x360.jpg": 273,
	"./DDC_BestofDayton_19_IGPost_1080x1080.jpg": 274,
	"./DDC_BestofDayton_201920_ProfPic_400x400.jpg": 275,
	"./bod_slate_wide.jpg": 276,
	"./dayton-dotcom-logo.png": 117,
	"./logo.png": 277
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 271;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/BoD_Badge_Logo.2f96c03.png";

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DDC_BestofDayton_19_937x360.a7c8485.jpg";

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DDC_BestofDayton_19_IGPost_1080x1080.72d2001.jpg";

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DDC_BestofDayton_201920_ProfPic_400x400.d60bcae.jpg";

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bod_slate_wide.e565047.jpg";

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contest_list_item"},[_c('contest-banner',{attrs:{"contest":_vm.contest,"banner_type":_vm.contest_banner_type},nativeOn:{"click":function($event){_vm.show_vote_card()}}}),_vm._v(" "),_c('transition',{attrs:{"name":"","enter-active-class":"animated bounceInUp faster","leave-active-class":"animated bounceOutDown faster"}},[_c('vote-card',{attrs:{"contest":_vm.contest,"contestant_images":_vm.contestant_images,"contestants":_vm.contestants,"vote_visible":_vm.vote_visible_toggle}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contest_list_container"},[_vm._l((_vm.contests.contests),function(contest){return _c('div',{key:contest.id},[_c('contest-list-item-box',{attrs:{"contest":contest,"contestants":_vm.contestants,"vote_visible":false,"contestant_images":false}})],1)}),_vm._v(" "),_vm._l((_vm.contests.contests),function(contest){return _c('div',{key:contest.id},[_c('contest-list-item-box',{attrs:{"contest":contest,"contestants":_vm.contestants,"vote_visible":false,"contestant_images":true}})],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"contest_list_page"}},[_c('contest-list')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationPage_vue__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationPage_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationPage_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationPage_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8fe262c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NominationPage_vue__ = __webpack_require__(329);
function injectStyle (ssrContext) {
  __webpack_require__(282)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationPage_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8fe262c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NominationPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 282 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_super_category_single_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_super_category_single_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_super_category_single_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_super_category_single_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_super_category_single_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45262bf0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_super_category_single_vue__ = __webpack_require__(306);
function injectStyle (ssrContext) {
  __webpack_require__(285)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_super_category_single_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45262bf0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_super_category_single_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nominate_list_box_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nominate_list_box_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nominate_list_box_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nominate_list_box_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nominate_list_box_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1760f3a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nominate_list_box_vue__ = __webpack_require__(305);
function injectStyle (ssrContext) {
  __webpack_require__(287)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nominate_list_box_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1760f3a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nominate_list_box_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 287 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nominate_supercat_contest_box_vue__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nominate_supercat_contest_box_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nominate_supercat_contest_box_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nominate_supercat_contest_box_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nominate_supercat_contest_box_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26bbeeb0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nominate_supercat_contest_box_vue__ = __webpack_require__(304);
function injectStyle (ssrContext) {
  __webpack_require__(289)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nominate_supercat_contest_box_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26bbeeb0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nominate_supercat_contest_box_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nominate_card_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nominate_card_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nominate_card_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nominate_card_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nominate_card_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28c09862_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nominate_card_vue__ = __webpack_require__(303);
function injectStyle (ssrContext) {
  __webpack_require__(291)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nominate_card_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28c09862_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nominate_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 291 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadList_vue__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadList_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadList_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadList_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_04749f2c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeaheadList_vue__ = __webpack_require__(296);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_04749f2c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeaheadList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadListItem_vue__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadListItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadListItem_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadListItem_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadListItem_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_eb6d14aa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeaheadListItem_vue__ = __webpack_require__(295);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadListItem_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_eb6d14aa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeaheadListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.textClasses,attrs:{"href":"#"},on:{"mouseover":function($event){_vm.active = true},"mouseout":function($event){_vm.active = false}}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-group shadow"},_vm._l((_vm.matchedItems),function(item,id){return _c('vue-bootstrap-typeahead-list-item',{key:id,attrs:{"background-variant":_vm.backgroundVariant,"text-variant":_vm.textVariant},domProps:{"innerHTML":_vm._s(_vm.highlight(item.text))},nativeOn:{"click":function($event){_vm.handleHit(item, $event)}}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 297 */,
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:_vm.sizeClasses},[(_vm.$slots.prepend || _vm.prepend)?_c('div',{staticClass:"input-group-prepend"},[_vm._t("prepend",[_c('span',{staticClass:"input-group-text"},[_vm._v(_vm._s(_vm.prepend))])])],2):_vm._e(),_vm._v(" "),_c('input',{ref:"input",class:("form-control " + _vm.inputClass),attrs:{"type":"search","placeholder":_vm.placeholder,"aria-label":_vm.placeholder,"autocomplete":"off"},domProps:{"value":_vm.value},on:{"focus":function($event){_vm.isFocused = true},"blur":_vm.handleBlur,"input":function($event){_vm.$emit('input', $event.target.value)}}}),_vm._v(" "),(_vm.$slots.append || _vm.append)?_c('div',{staticClass:"input-group-append"},[_vm._t("append",[_c('span',{staticClass:"input-group-text"},[_vm._v(_vm._s(_vm.append))])])],2):_vm._e()]),_vm._v(" "),_c('vue-bootstrap-typeahead-list',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFocused && _vm.data.length > 0),expression:"isFocused && data.length > 0"}],ref:"list",staticClass:"vbt-autcomplete-list",attrs:{"query":_vm.value,"data":_vm.formattedData,"background-variant":_vm.backgroundVariant,"text-variant":_vm.textVariant,"minMatchingChars":_vm.minMatchingChars},on:{"hit":_vm.handleHit}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sponsorship_box_container",class:_vm.$mq},[_c('h6',[_vm._v("This contest sponsored by:")]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},_vm._l((_vm.sponsors),function(sponsor,index){return _c('div',{key:"sponsor_"+index,staticClass:"col-4"},[_c('div',{staticClass:"sponsor_box"},[_c('a',{attrs:{"href":sponsor.website_url,"target":"_blank"},on:{"click":function($event){_vm.sponsor_click(sponsor, $event)}}},[_c('div',{staticClass:"sponsor_image_container"},[_c('img',{attrs:{"src":_vm.resize_cms_image(sponsor.logo_url),"alt":sponsor.name}})]),_vm._v(" "),_c('span',{staticClass:"sponsor_name"},[_vm._v(_vm._s(sponsor.name))])])])])}))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center social_share_container"},[_c('div',{staticClass:"flex_item share_text"},[_vm._v("\n    Share "),_c('font-awesome-icon',{attrs:{"icon":{prefix: 'fas', iconName: 'caret-right'}}})],1),_vm._v(" "),_c('div',{staticClass:"flex_item"},[_c('div',{staticClass:"fb_share_button",on:{"click":_vm.share_fb}},[_c('font-awesome-icon',{attrs:{"icon":{prefix: 'fab', iconName: 'facebook-square'}}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex_item"},[_c('div',{staticClass:"tw_share_button",on:{"click":_vm.share_tw}},[_c('font-awesome-icon',{attrs:{"icon":{prefix: 'fab', iconName: 'twitter-square'}}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex_item",on:{"click":_vm.share_email}},[_c('div',{staticClass:"email_share_button"},[_c('font-awesome-icon',{attrs:{"icon":{prefix: 'fas', iconName: 'envelope-square'}}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nomination_card_container"},[_c('div',{staticClass:"nomination_card"},[_c('div',{staticClass:"nomination_actions"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8"},[_c('vue-bootstrap-typeahead',{attrs:{"placeholder":"Type nomination...","serializer":function (s) { return s.nomination_text; },"data":_vm.nomination_suggestions,"size":"lg","inputClass":"bod_input_field","backgroundVariant":"info","textVariant":"white"},model:{value:(_vm.contest_nomination_text),callback:function ($$v) {_vm.contest_nomination_text=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"contest_nomination_text"}})],1),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('transition',{attrs:{"name":"","mode":"out-in","enter-active-class":"animated tada faster","leave-active-class":"animated pulse faster"}},[(!_vm.save_status)?_c('button',{key:"nominate",staticClass:"btn btn-primary",class:{disabled: _vm.nomination_save_in_progress},attrs:{"type":"button","disabled":_vm.nomination_save_in_progress},on:{"click":_vm.record_nomination}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.nomination_save_in_progress),expression:"!nomination_save_in_progress"}]},[_vm._v("\n\t\t\t\t\t\t\t\tNominate\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.nomination_save_in_progress),expression:"nomination_save_in_progress"}]},[_vm._v("\n\t\t\t\t\t\t\t\t...\n\t\t\t\t\t\t\t")])]):_c('button',{key:"confirmation",staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){_vm.reset_nomination()}}},[_c('font-awesome-icon',{attrs:{"icon":"check-circle"}})],1)])],1)])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"nom_share_button"},[_c('b-button',{attrs:{"size":"lg","variant":"secondary"},on:{"click":function($event){_vm.goto_nom_share('/nominate', _vm.instance_contestid)}}},[_vm._v("\n\t\t\t\t\t\tShare\n\t\t\t\t\t")])],1)])])]),_vm._v(" "),(_vm.sponsor_list.length > 0)?_c('sponsorship-box',{attrs:{"title":"This contest sponsored by:","sponsors":_vm.sponsor_list}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nomination_supercat_contest_box"},[_c('contest-banner',{attrs:{"contest":_vm.contest,"label":_vm.contest.label,"icon":_vm.supercat_icon,"lead_image":_vm.contest.lead_image,"banner_type":_vm.contest_banner_type,"is_expanded":_vm.show_contest_nomination_card},nativeOn:{"click":function($event){_vm.toggle_nomination_card()}}}),_vm._v(" "),(_vm.list_type == 'nominations')?_c('div',{staticClass:"nomination_list_box_wrapper"},[_c('transition',{attrs:{"name":"","enter-active-class":"animated bounceInLeft faster","leave-active-class":"animated bounceOutRight faster"}},[(_vm.show_contest_nomination_card)?_c('nomination-card',{attrs:{"instance_contestid":_vm.contest.instance_contestid,"nomination_save_status":_vm.nomination_save_result,"nomination_save_in_progress":_vm.nomination_save_in_progress,"reset_nomination_requested":_vm.reset_nomination},on:{"record_nomination_from_contest":_vm.nomination_listener,"request_nomination_reset":_vm.reset_nomination_status}}):_vm._e()],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nomination_list_box_container"},_vm._l((_vm.contests),function(contest){return _c('div',{key:contest.id,staticClass:"nomination_list_box"},[_c('nomination-supercat-contest-box',{attrs:{"contest":contest,"list_type":_vm.list_type,"supercat_icon":_vm.supercat_icon}})],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"super_category_single_container"},[_c('contest-banner',{attrs:{"contest":_vm.supercat_data,"label":_vm.supercat_data.category,"icon":_vm.supercat_data.icon,"lead_image":_vm.supercat_data.lead_image,"banner_type":_vm.contest_banner_type,"is_expanded":_vm.show_supercat_contests},nativeOn:{"click":function($event){_vm.toggle_show_contests()}}}),_vm._v(" "),_c('transition',{attrs:{"name":"","enter-active-class":"animated bounceInLeft faster","leave-active-class":"animated bounceOutRight faster"}},[_c('nomination-list-box',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_supercat_contests),expression:"show_supercat_contests"}],attrs:{"contests":_vm.supercat_contests,"list_type":_vm.list_type,"supercat_icon":_vm.supercat_data.icon}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"super_category_list_container",class:_vm.$mq},[_vm._m(0),_vm._v(" "),(_vm.super_category_list.length == 0 || _vm.master_contest_list.length == 0)?_c('div',{staticClass:"loading_indicator"},[_vm._v("Loading contests...")]):_vm._e(),_vm._v(" "),_vm._l((_vm.super_category_list),function(supercat,index){return _c('super-category-single',{key:"supercat_"+index,attrs:{"contests":_vm.master_contest_list,"supercat_data":supercat,"list_type":_vm.list_type}})})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"super_category_list_header"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[_vm._v("\n\t\t\t\t\tBrowse by category\n\t\t\t\t")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login_prompt_container"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-lg-10"},[_c('card-generic',{attrs:{"title":"Enter your email to begin"}},[_c('form',{attrs:{"id":"form_login"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8 col-lg-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"}],staticClass:"form-control",attrs:{"type":"email","placeholder":"email address"},domProps:{"value":(_vm.form.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-4 col-lg-2"},[_c('button',{staticClass:"btn btn-secondary btn_login",attrs:{"type":"submit"},on:{"click":_vm.check_form}},[_vm._v("\n\n                  Go!\n\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('b-form-checkbox',{attrs:{"id":"email_consent","value":"1","unchecked-value":"0"},model:{value:(_vm.form.email_consent),callback:function ($$v) {_vm.$set(_vm.form, "email_consent", $$v)},expression:"form.email_consent"}},[_vm._v("\n                  I want to learn about contest events, nomination, and voting periods by receiving a one-time email with more info.\n                ")]),_vm._v(" "),_c('p',{staticClass:"small-text"},[_vm._v("\n                  Your email address is required to start nominating and voting. We will not share or sell your email address with any 3rd parties.\n                ")])],1)])]),_vm._v(" "),_c('transition',{attrs:{"name":"vote_cards","mode":"out-in","enter-active-class":"animated flipInX","leave-active-class":"animated flipOutX"}},[(_vm.errors.length > 0)?_c('div',{staticClass:"login_form_errors alert alert-danger"},[_c('ul',_vm._l((_vm.errors),function(error){return _c('li',[_vm._v("\n                  "+_vm._s(error)+"\n                ")])}))]):_vm._e()])],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_event_not_started_vue__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_event_not_started_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_event_not_started_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_event_not_started_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_event_not_started_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36cbfb48_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nom_intro_event_not_started_vue__ = __webpack_require__(312);
function injectStyle (ssrContext) {
  __webpack_require__(311)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_event_not_started_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36cbfb48_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nom_intro_event_not_started_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"nom_intro_event_not_started"}},[_c('h4',[_vm._v("Nominations coming soon!")]),_vm._v(" "),_c('countdown',{attrs:{"target_date":_vm.nomination_start_date,"title":"Nominations start in:"}}),_vm._v(" "),_c('p',[_vm._v("\n    Soon you'll be able to nominate your favorite local restaurants, foods, people, services, places, and more to help them earn a spot as a Best of Dayton finalist this year. \n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_nomination_period_vue__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_nomination_period_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_nomination_period_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_nomination_period_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_nomination_period_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f0fd75c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nom_intro_nomination_period_vue__ = __webpack_require__(315);
function injectStyle (ssrContext) {
  __webpack_require__(314)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_nomination_period_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f0fd75c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nom_intro_nomination_period_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"nom_intro_nomination_period"}},[_c('h4',[_vm._v("Now accepting all nominations!")]),_vm._v(" "),_c('p',[_vm._v("\n  Hurry up and nominate your favorite local restaurants, foods, people, services, places, and more to help them earn a spot as a Best of Dayton finalist this year. \n  ")]),_vm._v(" "),_c('p',[_vm._v("\n  Looking for something specific? Try the search icon "),_c('font-awesome-icon',{attrs:{"icon":"search"}}),_vm._v(" in the top-right corner of your screen.\n  ")],1),_vm._v(" "),_c('countdown',{attrs:{"target_date":_vm.nomination_stop_date,"title":"Nominations end in:"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_voting_not_ended_vue__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_voting_not_ended_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_voting_not_ended_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_voting_not_ended_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_voting_not_ended_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f803776_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nom_intro_voting_not_ended_vue__ = __webpack_require__(318);
function injectStyle (ssrContext) {
  __webpack_require__(317)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_voting_not_ended_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f803776_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nom_intro_voting_not_ended_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"nom_intro_voting_not_ended"}},[_c('h4',[_vm._v("Nominations are currently closed")]),_vm._v(" "),_c('p',[_vm._v("\n    Our nomination database is bursting with all of the great nominations we received this year. Thanks to everyone who participated!\n  ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',[_vm._v("\n    It's not over yet and we still need your help to pick some winners. Use the big button below to head on over to our voting page and find out how to get your vote on.\n  ")]),_vm._v(" "),_c('large-centered-button',{attrs:{"button_text":"VOTE","icon":"check-double","width":"full"},on:{"button_clicked":function($event){_vm.goto_path('/vote')}}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframe_container"},[_c('iframe',{staticClass:"giphy-embed",attrs:{"src":"https://giphy.com/embed/l0MYt5jPR6QX5pnqM","width":"100%","height":"200","frameBorder":"0","allowFullScreen":""}}),_c('a',{attrs:{"href":"https://giphy.com/gifs/party-the-office-hard-l0MYt5jPR6QX5pnqM"}},[_vm._v("via GIPHY")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("BUT WAIT!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_voting_intermission_vue__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_voting_intermission_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_voting_intermission_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_voting_intermission_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_voting_intermission_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57a7ce16_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nom_intro_voting_intermission_vue__ = __webpack_require__(321);
function injectStyle (ssrContext) {
  __webpack_require__(320)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_voting_intermission_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57a7ce16_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nom_intro_voting_intermission_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"nom_intro_voting_intermission"}},[_c('h4',[_vm._v("Nominations are currently closed")]),_vm._v(" "),_c('p',[_vm._v("\n    Nominations and voting have ended for this year's contest and we're eagerly counting the votes to find out who you picked for this year's \"Bests\".\n  ")]),_vm._v(" "),_c('div',{staticClass:"iframe_container"},[_c('iframe',{staticClass:"giphy-embed",attrs:{"src":"https://giphy.com/embed/Bp5dwyOW9BwbK","width":"100%","height":"200","frameBorder":"0","allowFullScreen":""}}),_c('a',{attrs:{"href":"https://giphy.com/gifs/Bp5dwyOW9BwbK"}},[_vm._v("via GIPHY")])]),_vm._v(" "),_c('p',[_vm._v("\n    Use the big button below to head on over to our \"winners\" section to learn more about when winners will be announced and how you can be notified as soon as they're posted.\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_winners_period_vue__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_winners_period_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_winners_period_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_winners_period_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_winners_period_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57cacaf2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nom_intro_winners_period_vue__ = __webpack_require__(324);
function injectStyle (ssrContext) {
  __webpack_require__(323)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nom_intro_winners_period_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57cacaf2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nom_intro_winners_period_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"nom_intro_winners_period"}},[_c('h4',[_vm._v("Nominations are currently closed")]),_vm._v(" "),_c('p',[_vm._v("\n    But good news: "),_c('strong',[_vm._v("the winners have been announced!")])]),_vm._v(" "),_c('p',[_vm._v("\n    Use the big button below to head on over to our \"winners\" section to find out if your finalists won.\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"trans-bounce","mode":"out-in","enter-active-class":"animated bounceInLeft faster","leave-active-class":"animated bounceOutRight faster"}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dcom_latest_stories_container"},[_c('story-list',{attrs:{"cms_list_id":_vm.dcom_stories_uuid}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"nomination_page"}},[_c('h3',{staticClass:"section_title"},[_vm._v("Nominations")]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-lg-10"},[(_vm.instance_period == 'Event not started')?_c('intro-not-started',{attrs:{"nom_start_date":_vm.nom_period_data.start,"tz_offset":_vm.timezone_offset}}):_vm._e(),_vm._v(" "),(_vm.instance_period == 'Nomination Period')?_c('intro-nomination-period',{attrs:{"nom_stop_date":_vm.nom_period_data.stop,"tz_offset":_vm.timezone_offset}}):_vm._e(),_vm._v(" "),(_vm.instance_period == 'Nomination Intermission' || _vm.instance_period == 'Voting Period')?_c('intro-voting-not-ended',{attrs:{"nom_start_date":_vm.nom_period_data.start,"tz_offset":_vm.timezone_offset}}):_vm._e(),_vm._v(" "),(_vm.instance_period == 'Voting Intermission')?_c('intro-voting-intermission',{attrs:{"nom_start_date":_vm.nom_period_data.start,"tz_offset":_vm.timezone_offset}}):_vm._e(),_vm._v(" "),(_vm.instance_period == 'Winners Period' || _vm.instance_period == 'Event has ended')?_c('intro-winners-period',{attrs:{"nom_start_date":_vm.nom_period_data.start,"tz_offset":_vm.timezone_offset}}):_vm._e(),_vm._v(" "),(_vm.instance_period != 'Nomination Period')?_c('div',{staticClass:"stories_toggle"},[_c('h4',[_vm._v("\n\t\t\t\t\tHere's some other great stuff from Dayton.com:\n\t\t\t\t")]),_vm._v(" "),_c('dcom-latest-stories-list')],1):_vm._e()],1)])]),_vm._v(" "),(_vm.instance_period == 'Nomination Period')?_c('div',{staticClass:"login_category_container"},[_c('trans-bounce',[(!_vm.is_logged_in)?_c('login-prompt'):_c('super-category-list',{attrs:{"list_type":"nominations"}})],1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationSinglePage_vue__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationSinglePage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationSinglePage_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationSinglePage_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationSinglePage_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_407153e9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NominationSinglePage_vue__ = __webpack_require__(340);
function injectStyle (ssrContext) {
  __webpack_require__(331)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationSinglePage_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_407153e9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NominationSinglePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nominate_card_large_vue__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nominate_card_large_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nominate_card_large_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nominate_card_large_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nominate_card_large_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09342592_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nominate_card_large_vue__ = __webpack_require__(337);
function injectStyle (ssrContext) {
  __webpack_require__(333)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nominate_card_large_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09342592_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nominate_card_large_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_large_social_share_vue__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_large_social_share_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_large_social_share_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_large_social_share_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_large_social_share_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a55ee0fe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_large_social_share_vue__ = __webpack_require__(336);
function injectStyle (ssrContext) {
  __webpack_require__(335)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_large_social_share_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a55ee0fe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_large_social_share_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"large_social_container"},[_c('h4',[_vm._v("Share")]),_vm._v(" "),_c('input',{attrs:{"type":"text","id":"link_share_text"},domProps:{"value":_vm.window_url}}),_vm._v(" "),_c('div',{staticClass:"social_button_container"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"fb_share_button social_button",on:{"click":_vm.share_fb}},[_c('font-awesome-icon',{attrs:{"icon":{prefix: 'fab', iconName: 'facebook-square'}}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"tw_share_button social_button",on:{"click":_vm.share_tw}},[_c('font-awesome-icon',{attrs:{"icon":{prefix: 'fab', iconName: 'twitter-square'}}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"email_share_button social_button",on:{"click":_vm.share_email}},[_c('font-awesome-icon',{attrs:{"icon":{prefix: 'fas', iconName: 'envelope-square'}}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"link_share_button social_button",on:{"click":_vm.share_link}},[_c('font-awesome-icon',{attrs:{"icon":{prefix: 'fas', iconName: 'link'}}}),_vm._v(" "),_c('transition',{attrs:{"name":"","mode":"out-in","enter-active-class":"animated bounceIn faster","leave-active-class":"animated bounceOut faster"}},[(_vm.link_copied)?_c('div',{staticClass:"link_copy_message"},[_vm._v("\n                Link copied to clipboard\n              ")]):_vm._e()])],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nominate_large_card_container"},[_c('sponsorship-box',{directives:[{name:"show",rawName:"v-show",value:(_vm.sponsor_list.length > 0),expression:"sponsor_list.length > 0"}],attrs:{"title":"This contest sponsored by:","sponsors":_vm.sponsor_list}}),_vm._v(" "),_c('div',{staticClass:"nominate_large_card"},[_c('div',{staticClass:"nominate_large_card_header"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-2"},[(_vm.contest.icon)?_c('span',{staticClass:"nominate_large_card_icon_container"},[_c('font-awesome-icon',{attrs:{"icon":_vm.contest.icon}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-10"},[_vm._v("\n            "+_vm._s(_vm.contest.label)+"\n          ")])])])]),_vm._v(" "),(_vm.contest.lead_image)?_c('div',{staticClass:"contest_image",style:({'background-image': 'url(' + _vm.resize_cms_image(_vm.contest.lead_image) + ')' })}):_vm._e(),_vm._v(" "),(_vm.nom_share_status)?_c('large-social-share',{attrs:{"share_type":"nomination","contest":_vm.contest}}):_vm._e(),_vm._v(" "),(!_vm.nom_share_status)?_c('social-share-row',{attrs:{"share_type":"nomination","contest":_vm.contest}}):_vm._e(),_vm._v(" "),(!_vm.nom_share_status)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('vue-bootstrap-typeahead',{attrs:{"placeholder":"Type nomination...","serializer":function (s) { return s.nomination_text; },"data":_vm.nomination_suggestions,"size":"lg","inputClass":"bod_input_field","backgroundVariant":"info","textVariant":"white"},model:{value:(_vm.contest_nomination_text),callback:function ($$v) {_vm.contest_nomination_text=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"contest_nomination_text"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('transition',{attrs:{"name":"","mode":"out-in","enter-active-class":"animated tada faster","leave-active-class":"animated pulse faster"}},[(!_vm.save_status)?_c('button',{key:"nominate",staticClass:"btn btn-primary",class:{disabled: _vm.nomination_save_in_progress},attrs:{"type":"button","disabled":_vm.nomination_save_in_progress},on:{"click":_vm.record_nomination}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.nomination_save_in_progress),expression:"!nomination_save_in_progress"}]},[_vm._v("\n                  Nominate\n                ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.nomination_save_in_progress),expression:"nomination_save_in_progress"}]},[_vm._v("\n                  ...\n                ")])]):_c('button',{key:"confirmation",staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){_vm.reset_nomination()}}},[_c('font-awesome-icon',{attrs:{"icon":"check-circle"}})],1)])],1)])]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"trans-zoom","mode":"out-in","enter-active-class":"animated zoomIn faster","leave-active-class":"animated zoomOut faster"}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.$mq,attrs:{"id":"nomination_single_page"}},[_c('h3',{staticClass:"section_title"},[_vm._v("Nominate")]),_vm._v(" "),(_vm.instance_period == 'Nomination Period')?_c('div',{staticClass:"noms_active"},[_c('p',[_vm._v("\n      Type the name of a person, place, business, event, etc. below and then smash that \"nominate\" button. \n    ")])]):_vm._e(),_vm._v(" "),(_vm.instance_period != 'Nomination Period')?_c('div',{staticClass:"noms_not_active"},[_c('p',[_vm._v("\n      Nominations are not currently open. Get the latest info on our homepage by tapping the Dayton.com logo at the top of this page.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Or check out some of our latest content on Dayton.com:\n    ")]),_vm._v(" "),_c('story-list',{attrs:{"cms_list_id":"69728dd0-6965-11e6-ab50-bec7bcde827e"}})],1):_vm._e(),_vm._v(" "),(_vm.instance_period == 'Nomination Period')?_c('div',{staticClass:"nomination_container"},[_c('trans-zoom',[(!_vm.is_logged_in)?_c('login-prompt'):_vm._e(),_vm._v(" "),(_vm.is_logged_in)?_c('div',{staticClass:"nomination_card_outer_container"},[(_vm.contest)?_c('nominate-card-large',{attrs:{"instance_contestid":_vm.instance_contestid,"contest":_vm.contest,"nomination_save_status":_vm.nomination_save_result,"nomination_save_in_progress":_vm.nomination_save_in_progress,"reset_nomination_requested":_vm.reset_nomination},on:{"record_nomination_from_contest":_vm.nomination_listener,"request_nomination_reset":_vm.reset_nomination_status}}):_vm._e()],1):_vm._e()],1),_vm._v(" "),_c('p',{staticClass:"text-center"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){_vm.goto_path('/nominate')}}},[_vm._v("View All Contests")])])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VoteCardDemoPage_vue__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VoteCardDemoPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VoteCardDemoPage_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VoteCardDemoPage_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VoteCardDemoPage_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2cd0bbc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VoteCardDemoPage_vue__ = __webpack_require__(357);
function injectStyle (ssrContext) {
  __webpack_require__(342)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VoteCardDemoPage_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2cd0bbc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VoteCardDemoPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContestantListWithOutImages_vue__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContestantListWithOutImages_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContestantListWithOutImages_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContestantListWithOutImages_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContestantListWithOutImages_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b999412_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContestantListWithOutImages_vue__ = __webpack_require__(346);
function injectStyle (ssrContext) {
  __webpack_require__(345)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContestantListWithOutImages_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b999412_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContestantListWithOutImages_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"constestant_list_container container"},[_c('div',{staticClass:"row"},_vm._l((_vm.contestants),function(contestant){return _c('div',{key:contestant.finalistid,staticClass:"col-12"},[_c('div',{staticClass:"contestant_name_no_img",class:{ contestant_selected: _vm.selected_contestant.finalistid == contestant.finalistid},domProps:{"textContent":_vm._s(contestant.name)}}),_vm._v(" "),_c('div',{staticClass:"contest_name_cover",on:{"click":function($event){_vm.update_selected_contestant(contestant)}}})])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fixed_vote_card_button_row_vue__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fixed_vote_card_button_row_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fixed_vote_card_button_row_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fixed_vote_card_button_row_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fixed_vote_card_button_row_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93483186_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fixed_vote_card_button_row_vue__ = __webpack_require__(352);
function injectStyle (ssrContext) {
  __webpack_require__(348)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fixed_vote_card_button_row_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93483186_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fixed_vote_card_button_row_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progress_bar_vue__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progress_bar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progress_bar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progress_bar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progress_bar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fa6453a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_progress_bar_vue__ = __webpack_require__(351);
function injectStyle (ssrContext) {
  __webpack_require__(350)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progress_bar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fa6453a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_progress_bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress_bar_container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-7"},[_c('div',{staticClass:"progress_bar_outer"},[_c('div',{staticClass:"progress_bar",style:({width: _vm.progress_percent + '%'})})])]),_vm._v(" "),_c('div',{staticClass:"col-5"},[_c('div',{staticClass:"progress_bar_counts"},[_vm._v("\n        "+_vm._s(_vm.current_count)+" / "+_vm._s(_vm.max_count)+"\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vote_button_row_container"},[_c('div',{staticClass:"vote_button_row"},[(_vm.is_single_contest != 'true')?_c('button',{staticClass:"btn btn-success btn_vote btn_vote_complete",attrs:{"type":"button"},on:{"click":_vm.skip_vote}},[_vm._v("\n      Skip to Next "),_c('font-awesome-icon',{attrs:{"icon":"long-arrow-alt-right"}})],1):_vm._e(),_vm._v(" "),(_vm.is_single_contest == 'true')?_c('button',{staticClass:"btn btn-success btn_vote btn_vote_complete",attrs:{"type":"button"},on:{"click":_vm.view_all_contests}},[_vm._v("\n      View List "),_c('font-awesome-icon',{attrs:{"icon":"long-arrow-alt-right"}})],1):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"","mode":"out-in","enter-active-class":"animated tada faster"}},[(_vm.vote_status != 'complete')?_c('button',{key:"vote_button",staticClass:"btn btn-primary btn_vote",class:{disabled: _vm.vote_status != 'ready'},attrs:{"disabled":_vm.vote_status != 'ready'},on:{"click":_vm.send_vote}},[(_vm.vote_status != 'processing')?_c('span',[_vm._v("\n          Send Vote\n        ")]):_c('span',[_vm._v("\n          ...\n        ")])]):_vm._e(),_vm._v(" "),(_vm.vote_status == 'complete')?_c('button',{key:"vote_button_complete",staticClass:"btn btn-success btn_vote btn_vote_complete"},[_c('font-awesome-icon',{attrs:{"icon":"check-circle"}})],1):_vm._e()])],1),_vm._v(" "),_c('progress-bar',{attrs:{"current_count":_vm.voted_count,"max_count":_vm.total_contests}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_generic_share_button_vue__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_generic_share_button_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_generic_share_button_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_generic_share_button_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_generic_share_button_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52771ff8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_generic_share_button_vue__ = __webpack_require__(355);
function injectStyle (ssrContext) {
  __webpack_require__(354)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_generic_share_button_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52771ff8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_generic_share_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"generic_share_button_container"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"generic_share_button"},[_c('b-button',{attrs:{"size":"lg","variant":"secondary"},on:{"click":_vm.handle_button_click}},[(_vm.button_text)?_c('span',[_vm._v(_vm._s(_vm.button_text))]):_vm._e(),_vm._v(" "),(!_vm.button_text)?_c('span',[_vm._v("Share")]):_vm._e()])],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vote_card_container"},[(_vm.contest_sponsors.length > 0)?_c('sponsorship-box',{attrs:{"title":"This contest sponsored by:","sponsors":_vm.contest_sponsors}}):_vm._e(),_vm._v(" "),(_vm.is_single_contest != 'true')?_c('b-button',{attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.goto_path('/vote/')}}},[_c('font-awesome-icon',{attrs:{"icon":"long-arrow-alt-left"}}),_vm._v(" Full contest list\n  ")],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vote_card"},[_c('div',{staticClass:"vote_card_header"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-2"},[(_vm.contest.icon)?_c('span',{staticClass:"vote_card_icon_container"},[_c('font-awesome-icon',{attrs:{"icon":_vm.contest.icon}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-10"},[_vm._v("\n            "+_vm._s(_vm.contest.label)+"\n          ")])])])]),_vm._v(" "),(_vm.contest.lead_image)?_c('div',{staticClass:"contest_image",style:({'background-image': 'url(\'' + _vm.resize_cms_image(_vm.contest.lead_image) + '\')' })}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"appear":"","appear-class":"animated pulse faster","appear-to-class":"animated pulse faster","appear-active-class":"animated pulse faster"}},[(_vm.is_single_contest == 'true')?_c('social-share-row',{attrs:{"share_type":"vote","contest":_vm.contest}}):_vm._e()],1),_vm._v(" "),(_vm.is_single_contest != 'true')?_c('generic-share-button',{on:{"generic_share_clicked":_vm.handle_share_click}}):_vm._e(),_vm._v(" "),(_vm.contest.has_voted == false)?_c('contestant-list-with-out-images',{attrs:{"contestants":_vm.contestants},on:{"contestant_selected":_vm.handle_contestant_selected}}):_vm._e(),_vm._v(" "),(_vm.contest.has_voted == true)?_c('div',{staticClass:"already_voted_container"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)]):_vm._e(),_vm._v(" "),_c('fixed-vote-button-row',{attrs:{"vote_enabled":_vm.vote_enabled,"vote_status":_vm.vote_status,"total_contests":_vm.master_contest_list.length,"voted_count":_vm.voted_count,"is_single_contest":_vm.is_single_contest},on:{"contest_vote_submitted":_vm.handle_vote,"skip_vote":_vm.skip_vote}})],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Thank you")]),_vm._v(" for voting on this contest today!\n      ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n        You'll be able to "),_c('strong',[_vm._v("vote")]),_vm._v(" on this contest once "),_c('strong',[_vm._v("each day")]),_vm._v(" during the voting period, so come back "),_c('strong',[_vm._v("everyday")]),_vm._v(" to help your favorites win.\n      ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n        Don't forget to "),_c('strong',[_vm._v("SHARE")]),_vm._v(" this contest (using the buttons above) to let others know they can vote too!\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"vote_card_demo_page"}},[_c('h3',{staticClass:"section_title"},[_vm._v("Voting")]),_vm._v(" "),(!_vm.voting_period_started)?_c('div',{staticClass:"vote_page_inactive"},[_c('countdown',{attrs:{"target_date":"12/05/2018 12:00 AM UTC-0400","title":"Voting starts in:"}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('large-centered-button',{attrs:{"button_text":"Nominate Now","icon":"clipboard-check","width":"full"},on:{"button_clicked":function($event){_vm.goto_path('nominate')}}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',[_vm._v("\n            We're just as excited as you are for voting to begin!\n          ")]),_vm._v(" "),(_vm.nomination_period_started)?_c('p',[_vm._v("\n            But just because voting hasn't started yet doesn't mean there's nothing to do. Head on over to our "),_c('a',{attrs:{"href":"/nominate"},on:{"click":function($event){_vm.goto_path('nominate')}}},[_vm._v("nominations section")]),_vm._v(" and tell us who you'd like to see in the final contests.\n          ")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("\n            If you've already nominated all your favorites, check out some other great content from Dayton.com below.\n          ")]),_vm._v(" "),_c('story-list',{attrs:{"cms_list_id":"69728dd0-6965-11e6-ab50-bec7bcde827e"}})],1)])])],1):_vm._e(),_vm._v(" "),(_vm.voting_period_started)?_c('div',{staticClass:"vote_page_active"},[_c('trans-zoom',[(!_vm.is_logged_in)?_c('login-prompt'):_vm._e(),_vm._v(" "),(_vm.is_logged_in)?_c('div',{staticClass:"vote_card_outer_container"},[_c('trans-bounce',[(_vm.show_contest_index == 0)?_c('vote-card',{key:"vote_card_a",attrs:{"contest":_vm.contest_list[0],"contestants":_vm.contestant_list,"vote_complete":_vm.vote_complete,"sponsors":_vm.sponsors},on:{"contest_vote_submitted":_vm.record_vote,"next_contest_requested":_vm.change_vote_card}}):_c('vote-card',{key:"vote_card_b",attrs:{"contest":_vm.contest_list[1],"contestants":_vm.contestant_list,"vote_complete":_vm.vote_complete,"sponsors":_vm.sponsors},on:{"contest_vote_submitted":_vm.record_vote,"next_contest_requested":_vm.change_vote_card}})],1)],1):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('p',{staticClass:"text-center",staticStyle:{"margin":"0"}},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){_vm.toggle_vote_period_start()}}},[_vm._v("Toggle voting started")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VoteLandingPage_vue__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VoteLandingPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VoteLandingPage_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VoteLandingPage_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VoteLandingPage_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_327296c7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VoteLandingPage_vue__ = __webpack_require__(370);
function injectStyle (ssrContext) {
  __webpack_require__(359)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VoteLandingPage_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_327296c7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VoteLandingPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"vote_intro_event_not_started"}},[_c('h4',[_vm._v("Voting will start soon!")]),_vm._v(" "),_c('countdown',{attrs:{"target_date":_vm.voting_start_date,"title":"Voting start in:"}}),_vm._v(" "),_c('p',[_vm._v("\n    Soon you'll be able to vote for your favorite local restaurants, foods, people, services, places, and more to help them earn a spot as a Best of Dayton finalist this year. \n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"vote_intro_nomination_period"}},[_c('h4',[_vm._v("Time to vote!")]),_vm._v(" "),_c('p',[_vm._v("\n    We crunched the numbers and now have the official finalists.\n  ")]),_vm._v(" "),_c('p',[_vm._v("\n    Your favorites can't win without your support, so make sure you're showing them some love each and every day.\n  ")]),_vm._v(" "),(!_vm.show_voting_instructions)?_c('b-button',{attrs:{"size":"sm","variant":"link"},on:{"click":_vm.toggle_voting_instructions}},[_vm._v("How does voting work?")]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"","mode":"out-in","enter-active-class":"animated fadeIn faster","leave-active-class":"animated fadeOut faster"}},[(_vm.show_voting_instructions)?_c('div',{staticClass:"voting_instructions"},[_c('p',[_c('strong',[_vm._v("How does voting work?")]),_vm._v(" You can vote for you favorites everyday. Make sure you know who you want to win though, because "),_c('em',[_vm._v("you can only vote once per day")]),_vm._v(" on each of the 130+ contests. Every vote counts so make them great!\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Looking for something specific? Try the search icon "),_c('font-awesome-icon',{attrs:{"icon":"search"}}),_vm._v(" in the top-right corner of your screen.\n      ")],1),_vm._v(" "),_c('p',[_vm._v("\n        Just wanna vote? Don't care where you start? Mash the big button below and have fun!\n      ")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm","variant":"link"},on:{"click":_vm.toggle_voting_instructions}},[_vm._v("Hide instructions")])],1):_vm._e()]),_vm._v(" "),(_vm.is_logged_in)?_c('large-centered-button',{attrs:{"button_text":"RANDOMIZE","icon":"check-double","width":"full"},on:{"button_clicked":function($event){_vm.goto_path('/votenow')}}}):_vm._e(),_vm._v(" "),(_vm.is_logged_in)?_c('p',{staticClass:"text-center"},[_c('strong',{staticStyle:{"font-size":"2em"}},[_vm._v("OR")])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"vote_intro_voting_intermission"}},[_c('h4',[_vm._v("Voting is currently closed")]),_vm._v(" "),_c('p',[_vm._v("\n    Nominations and voting have ended for this year's contest and we're eagerly counting the votes to find out who you picked for this year's \"Bests\".\n  ")]),_vm._v(" "),_c('div',{staticClass:"iframe_container"},[_c('iframe',{staticClass:"giphy-embed",attrs:{"src":"https://giphy.com/embed/Bp5dwyOW9BwbK","width":"100%","height":"200","frameBorder":"0","allowFullScreen":""}}),_c('a',{attrs:{"href":"https://giphy.com/gifs/Bp5dwyOW9BwbK"}},[_vm._v("via GIPHY")])]),_vm._v(" "),_c('p',[_vm._v("\n    Use the big button below to head on over to our \"winners\" section to learn more about when winners will be announced and how you can be notified as soon as they're posted.\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"vote_intro_winners_period"}},[_c('h4',[_vm._v("Voting is currently closed")]),_vm._v(" "),_c('p',[_vm._v("\n    But good news: "),_c('strong',[_vm._v("the winners have been announced!")])]),_vm._v(" "),_c('div',{staticClass:"iframe_container"},[_c('iframe',{staticClass:"giphy-embed",attrs:{"src":"https://giphy.com/embed/l3q2RJBdaqJY2SV3O","width":"100%","height":"200","frameBorder":"0","allowFullScreen":""}}),_c('p',[_c('a',{attrs:{"href":"https://giphy.com/gifs/jerseydemic-l3q2RJBdaqJY2SV3O"}},[_vm._v("via GIPHY")])])]),_vm._v(" "),_c('p',[_vm._v("\n    Use the big button below to head on over to our \"winners\" section to find out if your finalists won.\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dev_period_simulator"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h6',[_vm._v("(DEV) Simulate Period")]),_vm._v(" "),_c('b-form-select',{attrs:{"options":_vm.instance_period_options},on:{"input":_vm.change_period},model:{value:(_vm.instance_period),callback:function ($$v) {_vm.instance_period=$$v},expression:"instance_period"}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"vote_landing_page"}},[_c('h3',{staticClass:"section_title"},[_vm._v("Voting")]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-lg-10"},[(_vm.instance_period == 'Event not started' || _vm.instance_period == 'Nomination Period' || _vm.instance_period == 'Nomination Intermission')?_c('intro-not-started',{attrs:{"vote_start_date":_vm.vote_period_data.start,"tz_offset":_vm.timezone_offset}}):_vm._e(),_vm._v(" "),(_vm.instance_period == 'Voting Period')?_c('intro-voting-period',{attrs:{"vote_start_date":_vm.vote_period_data.start,"tz_offset":_vm.timezone_offset,"is_logged_in":_vm.is_logged_in}}):_vm._e(),_vm._v(" "),(_vm.instance_period == 'Voting Intermission')?_c('intro-voting-intermission',{attrs:{"vote_start_date":_vm.vote_period_data.start,"tz_offset":_vm.timezone_offset}}):_vm._e(),_vm._v(" "),(_vm.instance_period == 'Winners Period' || _vm.instance_period == 'Event has ended')?_c('intro-winners-period',{attrs:{"vote_start_date":_vm.vote_period_data.start,"tz_offset":_vm.timezone_offset}}):_vm._e()],1)])]),_vm._v(" "),(_vm.instance_period == 'Voting Period')?_c('div',{staticClass:"login_category_container"},[_c('trans-bounce',[(!_vm.is_logged_in)?_c('login-prompt'):_c('super-category-list',{attrs:{"list_type":"voting"}})],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-lg-10"},[_c('h4',[_vm._v("\n          Here's some other great stuff from Dayton.com:\n        ")]),_vm._v(" "),_c('dcom-latest-stories-list')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VotingExperiencePage_vue__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VotingExperiencePage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VotingExperiencePage_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VotingExperiencePage_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VotingExperiencePage_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e269fb8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VotingExperiencePage_vue__ = __webpack_require__(373);
function injectStyle (ssrContext) {
  __webpack_require__(372)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VotingExperiencePage_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e269fb8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VotingExperiencePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.$mq,attrs:{"id":"voting_experience_page"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[(_vm.instance_period == 'Event not started' || _vm.instance_period == 'Nomination Period' || _vm.instance_period == 'Nomination Intermission')?_c('intro-not-started',{attrs:{"vote_start_date":_vm.vote_period_data.start,"tz_offset":_vm.timezone_offset}}):_vm._e(),_vm._v(" "),(_vm.instance_period == 'Voting Intermission')?_c('intro-voting-intermission',{attrs:{"vote_start_date":_vm.vote_period_data.start,"tz_offset":_vm.timezone_offset}}):_vm._e(),_vm._v(" "),(_vm.instance_period == 'Winners Period' || _vm.instance_period == 'Event has ended')?_c('intro-winners-period',{attrs:{"vote_start_date":_vm.vote_period_data.start,"tz_offset":_vm.timezone_offset}}):_vm._e(),_vm._v(" "),(_vm.instance_period == 'Voting Period')?_c('div',{staticClass:"voting_container"},[_c('h3',{staticClass:"section_title"},[_vm._v("Vote Now")]),_vm._v(" "),_c('trans-zoom',[(!_vm.is_logged_in)?_c('login-prompt'):_vm._e(),_vm._v(" "),(_vm.is_logged_in)?_c('div',{staticClass:"vote_card_outer_container"},[_c('trans-bounce',[(!_vm.unvoted_contest_details[_vm.card_a_index] && !_vm.unvoted_contest_details[_vm.card_b_index] && _vm.finished_all_daily_votes == false)?_c('div',{staticClass:"loading_contests_box"},[_vm._v("\n                  Loading contests...\n                ")]):_vm._e(),_vm._v(" "),(_vm.finished_all_daily_votes == true)?_c('div',{staticClass:"completed_voting_message"},[_c('div',{staticClass:"loading_contests_box"},[_vm._v("\n                    All done!\n                  ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Congrats!")]),_vm._v(" You reached the end of our contest list, and that's a lot. \n                  ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Check back each day")]),_vm._v(" to get another chance to vote for your favorites or simply "),_c('strong',[_vm._v("refresh this page")]),_vm._v(" to see any contest you might have missed today. You can vote on each contest once per day during the voting period.\n                  ")]),_vm._v(" "),_c('p',[_vm._v("\n                    Your favorites need your help to win, so get in "),_c('strong',[_vm._v("as many votes as you can")]),_vm._v(" before voting closes!\n                  ")])]):_vm._e(),_vm._v(" "),(_vm.show_card_a && _vm.unvoted_contest_details[_vm.card_a_index] && _vm.finished_all_daily_votes == false)?_c('vote-card',{key:"vote_card_a",attrs:{"contest":_vm.unvoted_contest_details[_vm.card_a_index],"instance_contestid":_vm.unvoted_contest_details[_vm.card_a_index].instance_contestid,"contestants":_vm.unvoted_contest_details[_vm.card_a_index].finalists,"vote_complete":_vm.vote_complete,"is_single_contest":"false"},on:{"contest_vote_submitted":_vm.record_vote,"next_contest_requested":_vm.change_vote_card}}):_vm._e(),_vm._v(" "),(!_vm.show_card_a && _vm.unvoted_contest_details[_vm.card_b_index] && _vm.finished_all_daily_votes == false)?_c('vote-card',{key:"vote_card_b",attrs:{"contest":_vm.unvoted_contest_details[_vm.card_b_index],"instance_contestid":_vm.unvoted_contest_details[_vm.card_b_index].instance_contestid,"contestants":_vm.unvoted_contest_details[_vm.card_b_index].finalists,"vote_complete":_vm.vote_complete,"is_single_contest":"false"},on:{"contest_vote_submitted":_vm.record_vote,"next_contest_requested":_vm.change_vote_card}}):_vm._e()],1)],1):_vm._e()],1)],1):_vm._e()],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VotingExperienceSinglePage_vue__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VotingExperienceSinglePage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VotingExperienceSinglePage_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VotingExperienceSinglePage_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VotingExperienceSinglePage_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b59549b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VotingExperienceSinglePage_vue__ = __webpack_require__(376);
function injectStyle (ssrContext) {
  __webpack_require__(375)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VotingExperienceSinglePage_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b59549b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VotingExperienceSinglePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.$mq,attrs:{"id":"voting_experience_single_page"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[(_vm.instance_period == 'Event not started' || _vm.instance_period == 'Nomination Period' || _vm.instance_period == 'Nomination Intermission')?_c('intro-not-started',{attrs:{"vote_start_date":_vm.vote_period_data.start,"tz_offset":_vm.timezone_offset}}):_vm._e(),_vm._v(" "),(_vm.instance_period == 'Voting Intermission')?_c('intro-voting-intermission',{attrs:{"vote_start_date":_vm.vote_period_data.start,"tz_offset":_vm.timezone_offset}}):_vm._e(),_vm._v(" "),(_vm.instance_period == 'Winners Period' || _vm.instance_period == 'Event has ended')?_c('intro-winners-period',{attrs:{"vote_start_date":_vm.vote_period_data.start,"tz_offset":_vm.timezone_offset}}):_vm._e(),_vm._v(" "),(_vm.instance_period == 'Voting Period')?_c('div',{staticClass:"voting_container"},[_c('h3',{staticClass:"section_title"},[_vm._v("Vote Now!")]),_vm._v(" "),_c('trans-zoom',[(!_vm.is_logged_in)?_c('login-prompt'):_vm._e(),_vm._v(" "),(_vm.is_logged_in)?_c('div',{staticClass:"vote_card_outer_container"},[(_vm.show_card_a && _vm.single_contest_details[_vm.card_a_index])?_c('vote-card',{key:"vote_card_a",attrs:{"contest":_vm.single_contest_details[_vm.card_a_index],"instance_contestid":_vm.single_contest_details[_vm.card_a_index].instance_contestid,"contestants":_vm.single_contest_details[_vm.card_a_index].finalists,"vote_complete":_vm.vote_complete,"is_single_contest":"true"},on:{"contest_vote_submitted":_vm.record_vote,"next_contest_requested":function($event){_vm.goto_path('/votenow')}}}):_vm._e()],1):_vm._e()],1)],1):_vm._e()],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2cea568_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound_vue__ = __webpack_require__(379);
function injectStyle (ssrContext) {
  __webpack_require__(378)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2cea568_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"page_not_found"}},[_c('h2',[_vm._v("404")]),_vm._v(" "),_c('h4',[_vm._v("That's an error.")]),_vm._v(" "),_c('p',[_vm._v("\n    The page you're looking for could not be found.\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 380 */,
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_box_vue__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_box_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_box_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_box_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_box_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b669416_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_box_vue__ = __webpack_require__(383);
function injectStyle (ssrContext) {
  __webpack_require__(382)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_box_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b669416_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_box_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search_box_container",class:_vm.$mq},[_c('vue-bootstrap-typeahead',{attrs:{"placeholder":"Type nomination...","serializer":function (s) { return s.label; },"data":_vm.contest_list,"size":"lg","inputClass":"bod_input_field","backgroundVariant":"info","textVariant":"white"},on:{"hit":_vm.emit_hit},model:{value:(_vm.contest_nomination_text),callback:function ($$v) {_vm.contest_nomination_text=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"contest_nomination_text"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app_header_container"},[_c('header',{staticClass:"app_header"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-2"},[_c('div',{staticClass:"icon_container",on:{"click":_vm.toggle_mobile_nav}},[_c('font-awesome-icon',{attrs:{"icon":"bars"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('div',{staticClass:"logo_container"},[_c('a',{attrs:{"href":"/"},on:{"click":function($event){_vm.goto_path('/', $event)}}},[_c('img',{attrs:{"src":__webpack_require__(117),"alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:((_vm.instance_period == 'Nomination Period' || _vm.instance_period == 'Voting Period')),expression:"(instance_period == 'Nomination Period' || instance_period == 'Voting Period')"}],staticClass:"icon_container",on:{"click":_vm.toggle_search}},[_c('font-awesome-icon',{attrs:{"icon":"search"}})],1)])])])]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animated flipInX faster","leave-active-class":"animated flipOutX faster"}},[(_vm.show_search && (_vm.instance_period == 'Nomination Period' || _vm.instance_period == 'Voting Period'))?_c('search-box',{attrs:{"contest_list":_vm.master_contest_list},on:{"search_hit":_vm.handle_search}}):_vm._e()],1),_vm._v(" "),_c('h1',{staticClass:"app_title"},[_vm._v(_vm._s(_vm.app_label))]),_vm._v(" "),(_vm.env == 'development')?_c('dev-period-sim'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f7f3300_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__(390);
function injectStyle (ssrContext) {
  __webpack_require__(386)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f7f3300_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_logout_button_vue__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_logout_button_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_logout_button_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_logout_button_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_logout_button_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_662e196c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_logout_button_vue__ = __webpack_require__(389);
function injectStyle (ssrContext) {
  __webpack_require__(388)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_logout_button_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_662e196c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_logout_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logout_container",class:_vm.custom_class},[_c('a',{attrs:{"href":""},on:{"click":function($event){_vm.log_out($event)}}},[_vm._v("Sign out")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app_footer_container"},[_c('footer',[_c('p',[_vm._v("\n      © "+_vm._s(_vm.full_year)+" Cox Media Group Ohio\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      | \n      "),_vm._l((_vm.footer_links),function(item,index){return _c('span',{key:"footer_link_"+index,staticClass:"footer_link"},[_c('a',{attrs:{"href":item.link,"target":"_blank"}},[_vm._v("\n          "+_vm._s(item.label)+"\n        ")]),_vm._v(" | \n      ")])}),_vm._v(" "),(_vm.is_logged_in)?_c('logout-button',{attrs:{"custom_class":"footer_link"}}):_vm._e()],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_mobile_vue__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_mobile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_mobile_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_mobile_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_mobile_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_557bb94f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_mobile_vue__ = __webpack_require__(396);
function injectStyle (ssrContext) {
  __webpack_require__(392)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_mobile_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_557bb94f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_mobile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_mobile_item_vue__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_mobile_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_mobile_item_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_mobile_item_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_mobile_item_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_008e4f26_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_mobile_item_vue__ = __webpack_require__(395);
function injectStyle (ssrContext) {
  __webpack_require__(394)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_mobile_item_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_008e4f26_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_mobile_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 394 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile_nav_item"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"nav_item_icon",on:{"click":function($event){_vm.goto_path(_vm.path_name)}}},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"nav_item_label"},[_c('div',{staticClass:"nav_item_label",on:{"click":function($event){_vm.goto_path(_vm.path_name)}}},[_vm._v(" \n          "+_vm._s(_vm.label)+"\n        ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideout_nav_container"},[_c('transition',{attrs:{"name":"","mode":"out-in","enter-active-class":"animated slideInLeft faster","leave-active-class":"animated slideOutLeft faster"}},[(_vm.show_mobile_nav)?_c('nav',{class:_vm.$mq,attrs:{"id":"mobile_nav"}},[_c('div',{directives:[{name:"touch",rawName:"v-touch:tap",value:(_vm.toggle_mobile_nav),expression:"toggle_mobile_nav",arg:"tap"}],staticClass:"btn_close_nav"},[_c('font-awesome-icon',{attrs:{"icon":"times"}})],1),_vm._v(" "),_c('div',{staticClass:"nav_item_container container"},_vm._l((_vm.main_nav_items),function(item,index){return _c('nav-mobile-item',{key:"nav_item_"+index,attrs:{"label":item.label,"icon":item.icon,"path_name":item.path_name}})}))]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('nav-mobile'),_vm._v(" "),_c('app-header',{attrs:{"app_label":_vm.instance_data.label}}),_vm._v(" "),_c('transition',{attrs:{"name":"","mode":"out-in","enter-active-class":"animated fadeIn faster","leave-active-class":"animated fadeOut faster"}},[_c('keep-alive',[_c('router-view')],1)],1),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _http_services = __webpack_require__(19);

var _http_services2 = _interopRequireDefault(_http_services);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contests = {
  state: {
    master_contest_list: [],
    contest_sponsors: []
  },

  get_current_master_contest_list: function get_current_master_contest_list() {
    return this.state.master_contest_list;
  },

  get_master_contest_list: function get_master_contest_list(instanceid) {
    var vm = this;

    if (vm.state.master_contest_list.length > 0) {
      // return vm.state.master_contest_list;
    } else {
      // GET CONTEST LIST FROM DB
      vm.fetch_master_contest_list(instanceid).then(function (response) {
        _vue2.default.set(vm.state, 'master_contest_list', response.data.data);
      });
    }
  },

  get_single_contest: function get_single_contest(instance_contestid) {
    var vm = this;
    var single_contest = {};

    // GET FROM MASTER_CONTEST_LIST LOCALLY
    for (var key in vm.state.master_contest_list) {
      if (vm.state.master_contest_list[key].instance_contestid == instance_contestid) {
        single_contest = vm.state.master_contest_list[key];
      }
    }

    return single_contest;
  },

  get_batch_contest_voting_details: function get_batch_contest_voting_details(instance_contestid_list, userid) {
    // console.log('instance_contestid_list: ', instance_contestid_list);
    if (instance_contestid_list instanceof Array) {
      return this.fetch_batch_contest_voting_details(instance_contestid_list, userid);
    } else {
      return false;
    }
  },

  get_current_contest_sponsors: function get_current_contest_sponsors(instance_contestid) {
    var vm = this;
    var sponsors = [];

    for (var key in vm.state.contest_sponsors) {
      if (typeof vm.state.contest_sponsors[key].instance_contestid != 'undefined') {
        if (vm.state.contest_sponsors[key].instance_contestid == instance_contestid) {
          sponsors.push(vm.state.contest_sponsors[key]);
        }
      }
    }

    return sponsors;
  },

  get_contest_sponsors: function get_contest_sponsors(instance_contestid) {
    var vm = this;
    var sponsors_exist = false;

    // CHECK TO SEE IF SPONSORS ALREADY EXIST FOR THIS CONTEST
    for (var key in vm.state.contest_sponsors) {
      if (vm.state.contest_sponsors[key].instance_contestid == instance_contestid) {
        sponsors_exist = true;
      }
    }

    // RETRIEVE SPONSOR LIST FROM DB IF NOT ALREADY PRESENT
    if (!sponsors_exist) {
      vm.fetch_contest_sponsors(instance_contestid).then(function (response) {
        // LOOP THROUGH RESULTS TO STORE EACH SPONSOR INDIVIDUALLY
        for (var key in response.data.data) {
          vm.state.contest_sponsors.push(response.data.data[key]);
        }
      });
    }
  },

  fetch_master_contest_list: function fetch_master_contest_list(instanceid) {
    var vm = this;
    var requested_set = 'master_contest_list';

    return _http_services2.default.get_api_data(requested_set, { instanceid: instanceid });
  },

  fetch_contest_sponsors: function fetch_contest_sponsors(instance_contestid) {
    var vm = this;
    var requested_set = 'contest_sponsors';

    return _http_services2.default.get_api_data(requested_set, { instance_contestid: instance_contestid });
  },

  fetch_batch_contest_voting_details: function fetch_batch_contest_voting_details(instance_contestid_list, userid) {
    var vm = this;
    var requested_set = 'batch_contest_voting_details';
    var options = {
      list: instance_contestid_list,
      userid: userid
    };

    return _http_services2.default.get_api_data(requested_set, options);
  }

};

exports.default = contests;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _http_services = __webpack_require__(19);

var _http_services2 = _interopRequireDefault(_http_services);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var voting = {
  state: {
    unvoted_contest_list: [],
    voted_count: 0,
    force_unvoted_refresh: false
  },

  get_current_unvoted_contest_list: function get_current_unvoted_contest_list() {
    return this.state.unvoted_contest_list;
  },

  get_current_force_unvoted_refresh: function get_current_force_unvoted_refresh() {
    return this.state.force_unvoted_refresh;
  },

  /*
  type: string; e.g. 'voted' or 'unvoted'
  */
  get_contest_list_by_type: function get_contest_list_by_type(instanceid, type, user_publicid) {
    var vm = this;
    // return vm.fetch_contest_list_by_type(instanceid, type, user_publicid);
    return vm.fetch_contest_list_by_type(instanceid, type, user_publicid);
    /*.then(function(response) {
      console.log('contest_list_by_type: ', response);
      vm.store_unvoted_contest_list(response.data.data);
    })*/
  },

  get_voted_count: function get_voted_count() {
    return this.state.voted_count;
  },

  store_voted_count: function store_voted_count(voted_count) {
    var vm = this;

    if (voted_count <= 0) {
      voted_count = 0;
    }

    vm.state.voted_count = parseInt(voted_count);
    _vue2.default.set(vm, 'voted_count', parseInt(voted_count));
  },

  change_force_unvoted_refresh: function change_force_unvoted_refresh(new_val) {
    this.state.force_unvoted_refresh = new_val;
  },

  fetch_contest_list_by_type: function fetch_contest_list_by_type(instanceid, type, userid) {
    var vm = this;
    var requested_set = 'contest_list_by_type';
    var options = {
      instanceid: instanceid,
      type: type,
      userid: userid
    };

    return _http_services2.default.get_api_data(requested_set, options);
  },

  record_vote: function record_vote(user_publicid, instance_contestid, contest_finalistid) {
    var vm = this;
    var requested_action = 'record_vote';
    var options = {
      userid: user_publicid,
      instance_contestid: instance_contestid,
      finalistid: contest_finalistid,
      requested_action: requested_action
    };

    return _http_services2.default.make_simple_post(options);
  },

  store_unvoted_contest_list: function store_unvoted_contest_list(unvoted_contest_list) {
    // this.state.unvoted_contest_list = unvoted_contest_list;
    _vue2.default.set(this.state, 'unvoted_contest_list', unvoted_contest_list);
  }

};

exports.default = voting;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(518);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _http_services = __webpack_require__(19);

var _http_services2 = _interopRequireDefault(_http_services);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nominations = {
  state: {
    nomination_suggestions: [],
    show_single_nom_share: false
  },

  get_current_nomination_suggestions_by_contest: function get_current_nomination_suggestions_by_contest(instance_contestid) {
    var vm = this;
    var suggestions = [];

    // LOOP THROUGH SUGGESTIONS
    for (var key in vm.state.nomination_suggestions) {
      if (vm.state.nomination_suggestions[key].instance_contestid == instance_contestid) {
        suggestions.push(vm.state.nomination_suggestions[key]);
      }
    }

    return suggestions;
  },

  get_nomination_suggestions_by_contest: function get_nomination_suggestions_by_contest(instance_contestid) {
    var vm = this;

    // FETCH NOMINATIONS
    vm.fetch_nominations_suggestions_by_contest(instance_contestid).then(function (response) {
      _vue2.default.set(vm.state, 'nomination_suggestions', response.data.data);
    });
  },

  get_current_nom_share_status: function get_current_nom_share_status() {
    return this.state.show_single_nom_share;
  },

  change_single_nom_share_status: function change_single_nom_share_status(status) {
    this.state.show_single_nom_share = status;
  },

  fetch_nominations_suggestions_by_contest: function fetch_nominations_suggestions_by_contest(instance_contestid) {
    var vm = this;
    var requested_set = 'nomination_suggestions';

    return _http_services2.default.get_api_data(requested_set, { instance_contestid: instance_contestid });
  },

  record_nomination: function record_nomination(data) {
    // ADD REQUESTED ACTION
    data.requested_action = 'add_new_nomination';

    return _http_services2.default.save_new_nomination(data);
  },

  record_single_nomination: function record_single_nomination(contest, nomination_text) {
    if (nomination_text != '' && contest.label != 'undefined') {

      var nomination = [{
        contest: contest.label,
        nominee: nomination_text
      }];

      this.record_nominations(nomination);

      return {
        status: true,
        message: 'Nomination saved successfully'
      };
    } else {
      return {
        status: false,
        message: 'Error: missing required nomination fields.'
      };
    }
  },

  record_nominations: function record_nominations(noms) {
    var my_noms = this.state.my_nominations;
    my_noms = [].concat((0, _toConsumableArray3.default)(my_noms), (0, _toConsumableArray3.default)(noms));
    // my_noms = Set(my_noms);
    _vue2.default.set(this.state, 'my_nominations', my_noms);
  }
};

exports.default = nominations;

/***/ }),
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _http_services = __webpack_require__(19);

var _http_services2 = _interopRequireDefault(_http_services);

var _mod_methode = __webpack_require__(528);

var _mod_methode2 = _interopRequireDefault(_mod_methode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lists = {
	state: {
		master_lists: [],
		cached_lists: {}
	},

	check_if_list_cached: function check_if_list_cached(list_id) {
		var found_list = false;
		var vm = this;

		// LOOP THROUGH CACHED OBJECTS
		for (var key in vm.state.master_lists) {
			if (vm.state.master_lists[key].list_id == list_id) {
				found_list = vm.state.master_lists[key];
			}
		}

		return found_list;
	},

	get_cms_list2: function get_cms_list2(list_id, limit) {
		var vm = this;

		// CHECK IF LIST ALREADY IN STATE
		if (vm.state.cached_lists[list_id]) {
			// RETURN CACHED LIST IF EXISTS
			return vm.state.cached_lists[list_id];
		} else {
			// GET LIST FROM CMS
			_mod_methode2.default.fetch_methode_api_data(list_id, limit).then(function (response) {
				// console.log('response: ', response);

				var normalized_list = _mod_methode2.default.normalize_api_data(response.data);
				// console.log('normalized_list: ', normalized_list);

				// STORE LIST IN STATE
				_vue2.default.set(vm.state.cached_lists, list_id, normalized_list);

				// RE-RUN THIS METHOD TO GET LIST FROM CACHE
				vm.get_cms_list2(list_id);
			});
		}
	},

	get_cms_list: function get_cms_list(list_id) {
		// CHECK IF LIST ALREADY CACHED
		var vm = this;
		var cached_list = vm.check_if_list_cached(list_id);

		// RETURN CACHED LIST IF EXISTS
		if (cached_list !== false) {
			return cached_list;
		} else {
			// GET LIST FROM CMS
			_http_services2.default.get_cms_list(list_id).then(function (response) {

				// APPEND LIST ID TO OBJECT
				response.data.list_id = list_id;

				// STORE LIST
				vm.state.master_lists.push(response.data);

				vm.get_cms_list(list_id);
			});
		}
	}

};

exports.default = lists;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _axios = __webpack_require__(59);

var _axios2 = _interopRequireDefault(_axios);

var _mod_cacher = __webpack_require__(529);

var _mod_cacher2 = _interopRequireDefault(_mod_cacher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var methode = {
	state: {
		api_path: 'https://www.dayton.com/external-feeds/json/apps/v1/',
		img_mods: {
			compact: 'compact', // NO CROP (150xauto @ 76%)
			md: 'md', // NO CROP (400xauto)
			large: 'large', // NO CROP (800xauto)
			lowres: 'lowres', // NO CROP (1000xauto @ 75%)
			thumbnail: 'thumbnail', // CROPPED (120x120 @ 70%)
			widescreen: 'widescreen', // CROPPED (1140x600)
			portrait: 'portrait', // CROPPED (235x350)
			inline: 'inline', // CROPPED (365x205)
			medium: 'medium', // CROPPED (750x422)
			square: 'square' // CROPPED (450x450)
		}
	},

	normalize_api_data: function normalize_api_data(api_data) {
		var vm = this;
		var channel = api_data.channel;
		var items = api_data.channel.item;

		var normalized_data = {
			title: channel.title,
			link: channel.link,
			type: channel.type,
			source: channel.source,
			list_items: []

			// NORMALIZE LIST ITEMS
		};items.map(function (item) {
			var normalized_item = vm.normalize_single_api_list_item(item);
			normalized_data.list_items.push(normalized_item);
		});

		return normalized_data;
	},

	normalize_single_api_list_item: function normalize_single_api_list_item(list_item) {
		var vm = this;
		var normalized_item = {
			uuid: list_item.guid,
			item_class: list_item.item_class,
			file: list_item.file,
			link: list_item.link,
			canonical_url: list_item.canonical_url,
			page_title: list_item.page_title,
			title: list_item.title,
			summary: list_item.summary,
			subhead: list_item.subhead,
			author: list_item.author,
			bylines: list_item.bylines,
			byline_source: list_item.byline_source,
			pub_date: list_item.pub_date,
			first_pub_date: list_item.first_pub_date,
			last_pub_date: list_item.last_pub_date,
			last_edit_date: list_item.last_edit_date,
			full_text: list_item.full_text,
			primary_category: list_item.primary_category,
			tag: list_item.tags,
			topics: list_item.topics,
			images: list_item.images,
			videos: list_item.videos,
			originating_site: list_item.originating_site,
			originating_domain: 'www.' + list_item.originating_site,
			sites: list_item.sites,
			categories: list_item.categories,
			thumbnail_url: list_item.thumbnail_url,
			master_image_url: ''

			// DETERMINE MASTER IMAGE URL
		};if (normalized_item.thumbnail_url != '') {
			normalized_item.master_image_url = normalized_item.thumbnail_url;
		} else if (normalized_item.videos.length > 0) {
			if (normalized_item.videos[0].image) {
				normalized_item.master_image_url = normalized_item.videos[0].image.url;
			}
		} else if (normalized_item.images.length > 0) {
			if (normalized_item.images[0].url) {
				normalized_item.master_image_url = normalized_item.images[0].url;
			}
		}

		return normalized_item;
	},

	create_methode_api_url: function create_methode_api_url(uuid, verbose, limit) {
		var vm = this;
		var api_url = vm.state.api_path;

		if (verbose) {
			api_url += '?verbose=true';
		} else {
			api_url += '?verbose=false';
		}

		if (!limit || limit == 0) {
			limit = 25;
		}

		api_url += '&count=' + limit;

		api_url += '&id=' + uuid;

		return api_url;
	},

	resize_image: function resize_image(url, size) {
		return url.replace(/\/rw\//g, '/rf/' + this.state.img_mods[size] + '/');
	},

	resize_image_compact: function resize_image_compact(url) {
		return url.replace(/\/rw\//g, '/rf/image_compact/');
	},

	resize_image_md: function resize_image_md(url) {
		return url.replace(/\/rw\//g, '/rf/image_md/');
	},

	fetch_methode_api_data: function fetch_methode_api_data(uuid, limit) {
		var vm = this;
		var count = 0;

		if (limit) {
			count = limit;
		}

		var data_url = vm.create_methode_api_url(uuid, true, count);
		data_url = _mod_cacher2.default.create_file_get_url(data_url);

		return _axios2.default.get(data_url);
	}
};

exports.default = methode;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	state: {
		cacher_path: 'https://host.coxmediagroup.com/cop/digital/common/cache/cacher.php',
		file_get_path: 'https://host.coxmediagroup.com/cop/digital/common/php/simple_get_file.php'
	},

	create_cacher_url: function create_cacher_url(saveas, data_url, force_reload, max_cache_lifetime) {
		var vm = this;
		var cacher_url = vm.state.cacher_path;
		cacher_url += '?saveas=' + saveas;

		if (force_reload) {
			cacher_url += '&force_reload=true';
		}

		if (max_cache_lifetime) {
			cacher_url += '&max_cache_lifetime=' + max_cache_lifetime;
		}

		cacher_url += '&json_url=' + encodeURIComponent(data_url);

		return cacher_url;
	},

	create_file_get_url: function create_file_get_url(file_url) {
		var vm = this;
		var file_get_url = vm.state.file_get_path;
		file_get_url += '?url=';
		file_get_url += encodeURIComponent(file_url);

		return file_get_url;
	}

};

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _http_services = __webpack_require__(19);

var _http_services2 = _interopRequireDefault(_http_services);

var _mod_storage = __webpack_require__(91);

var _mod_storage2 = _interopRequireDefault(_mod_storage);

var _mod_manipulation_helpers = __webpack_require__(96);

var _mod_manipulation_helpers2 = _interopRequireDefault(_mod_manipulation_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var session = {
  expiration_days: 30,
  state: {
    logged_in: false,
    default_userid: 1,
    user: {
      id: 1,
      email: ''
    }
  },

  log_in: function log_in(email_address, email_consent) {
    // FAKE LOGIN FOR TESTING
    var vm = this;

    // IF ALREADY LOGGED IN
    if (vm.check_login_status) {
      // LOG OUT
      vm.log_out();
    }

    // PREP DATA
    var data = {
      email: email_address,
      login_email_opt_in: email_consent,
      requested_action: 'login_user'

      // TRY LOGIN
    };return _http_services2.default.make_simple_post(data).then(function (response) {
      // console.log('login response: ', response);
      if (response.data) {
        if (response.data.data) {
          if (response.data.data.user) {
            // UPDATE LOCAL STATE
            _vue2.default.set(vm.state, 'logged_in', true);
            _vue2.default.set(vm.state.user, 'id', response.data.data.user.id);
            _vue2.default.set(vm.state.user, 'email', response.data.data.user.email);

            // UPDATE STORAGE
            _mod_storage2.default.set_item('user_data', {
              id: vm.state.user.id,
              email: vm.state.user.email
            });
          }
        }
      }
    });
  },

  log_out: function log_out() {
    var vm = this;

    // RESET LOCAL STATE
    _vue2.default.set(vm.state, 'logged_in', false);
    _vue2.default.set(vm.state, 'user', { id: 0, email: '' });

    // RESET STORAGE
    _mod_storage2.default.remove_item('user_data');
    _mod_storage2.default.remove_item('super_category_list');
  },

  check_login_status: function check_login_status() {
    if (this.state.logged_in === true) {
      return true;
    } else {
      return false;
    }
  },

  check_stored_login: function check_stored_login() {
    var vm = this;

    // CHECK STORAGE FOR LOGGED IN USER
    vm.fetch_stored_login().then(function (vf_response) {
      if (vf_response) {
        // CHECK FOR REQUIRED DATA IN STORAGE
        if (vf_response.email && vf_response.id && vf_response.last_modified) {
          // CHECK IF LOGIN HAS EXPIRED
          var now = new Date();
          var diff = _mod_manipulation_helpers2.default.check_timestamp_diff(vf_response.last_modified, now.getTime());

          if (diff.days >= vm.expiration_days) {
            // SESSION HAS EXPIRED. FORCE FULL LOGOUT
            vm.log_out();
          } else {
            // SESSION IS STILL VALID. LOAD IT.
            _vue2.default.set(vm.state, 'logged_in', true);
            _vue2.default.set(vm.state.user, 'id', vf_response.id);
            _vue2.default.set(vm.state.user, 'email', vf_response.email);
          }
        }
      }
    }).catch(function (error) {
      // console.log('error: ', error);
    });
  },

  fetch_stored_login: function fetch_stored_login() {
    var vm = this;

    // CHECK STORAGE FOR LOGGED IN USER
    return _mod_storage2.default.get_item('user_data');
  },

  get_userid: function get_userid() {
    var vm = this;

    // CHECK IF USER ID IS DEFAULT
    if (vm.state.user.id == vm.state.default_userid) {
      // FOUND DEFAULT ID, NEED NEW DATA. 
      // TRY TO GET STORED DATA
      vm.fetch_stored_login().then(function (response) {
        // CHECK FOR REQUIRED DATA IN STORAGE
        if (typeof response != 'undefined' && response != 'null' && response != null) {
          if (typeof response.email != 'undefined' && typeof response.id != 'undefined' && typeof response.last_modified != 'undefined') {
            _vue2.default.set(vm.state, 'logged_in', true);
            _vue2.default.set(vm.state.user, 'id', response.id);
            _vue2.default.set(vm.state.user, 'email', response.email);
          }

          return vm.state.user.id;
        } else {
          return vm.state.user.id;
        }
      });
    } else {
      return vm.state.user.id;
    }
  },

  get_user_email: function get_user_email() {
    return vm.state.user.email;
  }
};

exports.default = session;

/***/ }),
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nav = {
  state: {
    mobile_nav_visible: false,
    main_nav: [{
      label: 'Home',
      icon: 'home',
      path: '/',
      path_name: '/',
      subnav: []
    }, {
      label: 'Nominations',
      icon: 'clipboard-check',
      path: '/nominate/',
      path_name: '/nominate',
      subnav: []
    }, {
      label: 'Voting',
      icon: 'check-double',
      path: '/vote/',
      path_name: '/vote',
      subnav: []
    }]
  },
  get_main_nav: function get_main_nav() {
    return this.state.main_nav;
  },
  get_mobile_nav_visibility: function get_mobile_nav_visibility() {
    return this.state.mobile_nav_visible;
  },
  toggle_mobile_nav: function toggle_mobile_nav() {
    this.state.mobile_nav_visible = !this.state.mobile_nav_visible;
  },
  close_mobile_nav: function close_mobile_nav() {
    this.state.mobile_nav_visible = false;
  }
};

exports.default = nav;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _http_services = __webpack_require__(19);

var _http_services2 = _interopRequireDefault(_http_services);

var _mod_storage = __webpack_require__(91);

var _mod_storage2 = _interopRequireDefault(_mod_storage);

var _mod_manipulation_helpers = __webpack_require__(96);

var _mod_manipulation_helpers2 = _interopRequireDefault(_mod_manipulation_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var categories = {
  expiration_minutes: 60,
  state: {
    super_category_list: []
  },

  get_current_super_category_list: function get_current_super_category_list() {
    return this.state.super_category_list;
  },

  refresh_super_category_list: function refresh_super_category_list(instanceid) {
    var vm = this;

    // CHECK STORAGE FIRST
    _mod_storage2.default.get_item('super_category_list').then(function (vf_response) {
      // console.log('vf_response: ', vf_response);
      if (vf_response) {
        if (vf_response.length > 0) {
          // DATA IS STILL VALID. LOAD IT.
          _vue2.default.set(vm.state, 'super_category_list', vf_response);
        } else {
          // GET FROM DB
          vm.fetch_super_category_list(instanceid).then(function (response) {
            // SAVE TO LOCAL STATE
            _vue2.default.set(vm.state, 'super_category_list', response.data.data);

            // SAVE TO STORAGE
            _mod_storage2.default.set_item('super_category_list', vm.state.super_category_list);
          });
        }
      } else {
        // GET FROM DB
        vm.fetch_super_category_list(instanceid).then(function (response) {
          // SAVE TO LOCAL STATE
          _vue2.default.set(vm.state, 'super_category_list', response.data.data);

          // SAVE TO STORAGE
          _mod_storage2.default.set_item('super_category_list', vm.state.super_category_list);
        });
      }
    }).catch(function (error) {
      console.log('error: ', error);
    });
  },

  fetch_super_category_list: function fetch_super_category_list(instanceid) {
    var vm = this;
    var requested_set = 'all_super_categories';

    return _http_services2.default.get_api_data(requested_set, { instanceid: instanceid });
  }
};

exports.default = categories;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _http_services = __webpack_require__(19);

var _http_services2 = _interopRequireDefault(_http_services);

var _store = __webpack_require__(193);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var instances = {
  state: {
    instanceid: 0,
    instance_periods: [],
    instance_data: {},
    timezone_offset: '-0400',
    active_instance_period: 'Event not started',
    active_instance_updated: false
  },

  get_current_instanceid: function get_current_instanceid() {
    return this.state.instanceid;
  },

  get_current_instance_periods: function get_current_instance_periods() {
    return this.state.instance_periods;
  },

  get_current_timezone_offset: function get_current_timezone_offset() {
    return this.state.timezone_offset;
  },

  get_specific_instance_period: function get_specific_instance_period(period_label) {
    var vm = this;
    var instance = {};

    for (var i = 0, l = vm.state.instance_periods.length; i < l; i++) {
      if (vm.state.instance_periods[i].label.toUpperCase() == period_label.toUpperCase()) {
        instance = vm.state.instance_periods[i];
      }
    }

    return instance;
  },

  get_current_instance_data: function get_current_instance_data() {
    return this.state.instance_data;
  },

  get_current_active_instance_period: function get_current_active_instance_period() {
    return this.state.active_instance_period;
  },

  get_active_instance_period: function get_active_instance_period() {
    var vm = this;
    var default_period_text = 'Event not started';
    var active_instance_period = default_period_text;

    if (vm.state.instance_periods.length != 0) {
      var today = new Date();

      for (var i = 0, l = vm.state.instance_periods.length; i < l; i++) {
        var test_start_date = new Date(vm.state.instance_periods[i].start);
        var test_stop_date = new Date(vm.state.instance_periods[i].stop);

        // CHECK IF THE START DATE HAS ELAPSED
        if (test_start_date >= today) {
          // START DATE IS IN THE FUTURE AND HAS NOT ELAPSED

          // DO NOT START THIS PERIOD
          // console.log('test_start_date: ', test_start_date);
        } else {
          // START DATE IS IN THE PAST AND HAS ELAPSED

          // CHECK IF STOP DATE HAS ELAPSED
          if (test_stop_date >= today) {
            // STOP DATE IS IN THE FUTURE AND HAS NOT ELAPSED

            // START THIS PERIOD
            active_instance_period = vm.state.instance_periods[i].label;
          } else {
            // STOP DATE IS IN THE PAST AND HAS ELAPSED

            // DO NOT START THIS PERIOD
          }
        }
      }

      // IF PERIOD STILL NOT SET, CHECK IF OVERALL EVENT HAS STARTED OR COMPLETED
      if (active_instance_period == default_period_text) {
        for (var _i = 0, _l = vm.state.instance_periods.length; _i < _l; _i++) {

          // CHECK IF FIRST PERIOD (NOMINATION PERIOD) HAS STARTED
          if (vm.state.instance_periods[_i].label == 'Nomination Period') {
            var _test_start_date = new Date(vm.state.instance_periods[_i].start);
            var _test_stop_date = new Date(vm.state.instance_periods[_i].stop);

            // CHECK IF EVENT STARTED
            if (_test_start_date > today) {
              // EVENT HAS NOT YET STARTED

              // ADJUST PERIOD LABEL
              active_instance_period = 'Event not started';
            }
          }

          // CHECK IF LAST EVENT (WINNERS PERIOD) HAS COMPLETED
          if (vm.state.instance_periods[_i].label == 'Winners Period') {
            var _test_start_date2 = new Date(vm.state.instance_periods[_i].start);
            var _test_stop_date2 = new Date(vm.state.instance_periods[_i].stop);

            // CHECK IF EVENT ENDED
            if (_test_stop_date2 < today) {
              // EVENT HAS NOT YET STARTED

              // ADJUST PERIOD LABEL
              active_instance_period = 'Event has ended';
            }
          }
        }
      }
    }

    // SET CURRENT PERIOD
    _vue2.default.set(vm.state, 'active_instance_period', active_instance_period);
    _vue2.default.set(vm.state, 'active_instance_updated', true);
  },

  get_client_instance_data: function get_client_instance_data() {
    var vm = this;

    vm.fetch_client_instanceid().then(function (response) {
      // console.log('get_client_instance_data response: ', response);
      // RECORD INSTANCE ID
      _vue2.default.set(vm.state, 'instanceid', response.data.data[0].instanceid);

      // GET INSTANCE DATA
      return vm.fetch_instance_data();
    }).then(function (response) {
      // console.log('response: ', response);

      // RECORD INSTANCE DATA
      _vue2.default.set(vm.state, 'instance_data', response.data.data[0]);

      // GET TIMEZONE DATA
      return vm.fetch_timezone_data();
    }).then(function (response) {

      // CONVERT OFFSET FROM SECONDS TO HOURS
      var offset = response.data.data.offset;
      offset = offset / 60 / 60;

      // MAKE OFFSET A STRING
      var posneg = '-';
      if (offset >= 0) {
        posneg = '+';
      }
      offset = posneg + '0' + Math.abs(offset) + '00';

      // RECORD OFFSET
      _vue2.default.set(vm.state, 'timezone_offset', offset);

      // GET INSTANCE PERIODS
      return vm.fetch_instance_periods();
    }).then(function (response) {
      // console.log('response: ', response);
      // RECORD INSTANCE PERIODS
      _vue2.default.set(vm.state, 'instance_periods', response.data.data);
    }).then(function () {
      vm.get_active_instance_period();
    });
  },

  get_instance_periods: function get_instance_periods() {
    var vm = this;

    vm.fetch_instance_periods().then(function (response) {
      _vue2.default.set(vm.state, 'instance_periods', response.data.data);
    });
  },

  set_active_instance_period: function set_active_instance_period(new_period) {
    var vm = this;
    _vue2.default.set(vm.state, 'active_instance_period', new_period);
  },

  fetch_client_instanceid: function fetch_client_instanceid() {
    var vm = this;
    var requested_set = 'client_instanceid';

    return _http_services2.default.get_api_data(requested_set, { clientid: _store2.default.state.clientid });
  },

  fetch_instance_periods: function fetch_instance_periods() {
    var vm = this;
    var requested_set = 'instance_periods';

    return _http_services2.default.get_api_data(requested_set, { instanceid: vm.get_current_instanceid() });
  },

  fetch_instance_data: function fetch_instance_data() {
    var vm = this;
    var requested_set = 'instance_data';

    return _http_services2.default.get_api_data(requested_set, { instanceid: vm.get_current_instanceid() });
  },

  fetch_timezone_data: function fetch_timezone_data() {
    return _http_services2.default.get_timezone_data();
  }

};

exports.default = instances;

/***/ })
]),[214]);


// WEBPACK FOOTER //
// static/js/app.513c643ae7a752043f01.js